import "./index.css"
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/admin/styles.js
import styled from "styled-components";
var Container = styled.div`
  position: relative;
`;
var Body = styled.div`
  width: 100%;
`;
var Drawer = styled.div`
  height: 100vh;
  @media only screen and (min-width: 1024px) {
    width: 300px;
  }
`;
var Content = styled.div`
  flex: 1;
`;
var styles_default = {
  Container,
  Body,
  Drawer,
  Content
};

// src/components/drawer/index.tsx
import React2 from "react";

// src/components/drawer/styles.js
import styled2 from "styled-components";

// src/components/animations/index.ts
import * as _Animations from "react-animations";
import { keyframes, css } from "styled-components";
var Animations = {};
for (let key in _Animations)
  Animations[key] = keyframes`${_Animations[key]}`;
var mountHandler = (props) => props.mountAnim ? css`
				animation: ${props.mountAnim.duration}
					${Animations[props.mountAnim.anim]};
				animation-delay: ${props.mountAnim.delay};
				animation-fill-mode: forwards;
		  ` : null;
var animations_default = Animations;

// src/components/drawer/styles.js
var Container2 = styled2.div``;
var SignOut = styled2.div``;
var Component = styled2.div`
  height: 100%;
  width: 100%;
  overflow-x: hidden;
`;
var Item = styled2.div`
  ${(props) => mountHandler(props)}
  /* Position and sizing of burger button */
	.bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    ${(props) => `${props.buttonSide ? props.buttonSide : "left"}: 36px;`}
    top: 36px;
  }

  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: ${(props) => props.showBars ? "white" : "transparent"};
  }

  /* Color/shape of burger icon bars on hover*/
  .bm-burger-bars-hover {
    background: darkgray;
  }
`;
var styles_default2 = {
  Container: Container2,
  Item,
  SignOut,
  Component
};

// src/components/drawer/index.tsx
import Menu from "react-burger-menu";

// src/components/fontawesome/index.tsx
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// src/components/fontawesome/styles.js
import styled3 from "styled-components";
var Container3 = styled3.div`
  display: inline;
`;
var styles_default3 = {
  Container: Container3
};

// src/components/fontawesome/index.tsx
import { jsx } from "react/jsx-runtime";
library.add(fab, fas, far);
var type = (icon) => {
  for (let key in library.definitions) {
    if (library.definitions[key][icon])
      return key;
  }
};
var FontAwesome = ({
  icon,
  animation,
  size,
  animationPaused,
  onClick,
  className
}) => {
  const selectAnimation = () => animation ? { [animation]: true } : { animation: "none" };
  return /* @__PURE__ */ jsx(styles_default3.Container, { className: `${className}`, children: /* @__PURE__ */ jsx(
    FontAwesomeIcon,
    __spreadProps(__spreadValues({}, selectAnimation()), {
      onClick: onClick ? onClick : null,
      icon: [type(icon), icon],
      size,
      border: false,
      transform: "",
      className: `${onClick ? "arclight-cursor-pointer" : ""}`,
      style: { animationPlayState: animationPaused ? "paused" : "" }
    })
  ) });
};
var fontawesome_default = FontAwesome;

// src/components/button/index.tsx
import React from "react";
import ReactiveButton from "reactive-button";

// src/components/button/styles.js
import styled4 from "styled-components";
var Container4 = styled4.div`
  ${(props) => props.span ? `width: 100%;` : null}
`;
var FontAwesome2 = styled4.div`
  cursor: pointer;
  display: inline-flex;
  transition: filter 0.25s ease;
  &:hover {
    -webkit-filter: brightness(150%);
    filter: brightness(150%);
  }
`;
var styles_default4 = {
  Container: Container4,
  FontAwesome: FontAwesome2
};

// src/components/button/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Button = ({
  span,
  label,
  loadingText,
  loadingIcon,
  successIcon,
  successText,
  errorText,
  onClick,
  type: type2,
  size,
  idleIcon,
  rounded,
  block,
  disabled,
  animation,
  square,
  isIconButton,
  className,
  style
}) => {
  const [state, setState] = React.useState("idle");
  const onClickHandler = () => __async(void 0, null, function* () {
    if (loadingIcon)
      setState("loading");
    onClick(setState);
  });
  return /* @__PURE__ */ jsx2(
    styles_default4.Container,
    {
      span,
      className: `arclight-text-text-primary arclight-font-primary ${className}`,
      style,
      children: /* @__PURE__ */ jsx2(
        ReactiveButton,
        {
          buttonState: state,
          onClick: onClickHandler,
          idleText: /* @__PURE__ */ jsxs("span", { className: "arclight-text-text-primary", children: [
            idleIcon ? /* @__PURE__ */ jsx2(fontawesome_default, { size: isIconButton ? "xl" : "lg", icon: idleIcon }) : null,
            idleIcon && label ? " " : null,
            label ? label : null
          ] }),
          loadingText: /* @__PURE__ */ jsxs("span", { children: [
            loadingIcon ? /* @__PURE__ */ jsx2(fontawesome_default, { size: "lg", icon: loadingIcon, animation: "spin" }) : null,
            loadingIcon && loadingText ? " " : null,
            loadingText ? loadingText : null
          ] }),
          successText: /* @__PURE__ */ jsxs("span", { children: [
            successIcon ? /* @__PURE__ */ jsx2(fontawesome_default, { size: "lg", icon: successIcon }) : null,
            successIcon && successText ? " " : null,
            successText ? successText : null
          ] }),
          errorText,
          type: type2,
          style: {
            borderRadius: square ? "0px" : "4px",
            backgroundColor: "rgb(32,32,32)"
          },
          outline: false,
          shadow: false,
          rounded,
          size,
          block,
          messageDuration: 2e3,
          disabled,
          buttonRef: null,
          width: span ? "100%" : null,
          height: null,
          animation
        }
      )
    }
  );
};
var button_default = Button;

// src/components/drawer/index.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var Item2 = ({
  index,
  icon,
  text,
  onClick,
  items,
  isExpanded,
  italic,
  color,
  autoSort
}) => {
  const [expanded, setExpanded] = React2.useState(isExpanded);
  React2.useEffect(() => setExpanded(isExpanded), [isExpanded]);
  return icon || text ? /* @__PURE__ */ jsx3(
    styles_default2.Item,
    {
      className: "arclight-flex arclight-items-center arclight-cursor-pointer arclight-font-primary arclight-text-text-primary arclight-text-left arclight-whitespace-nowrap arclight-z-20",
      style: { opacity: 0 },
      mountAnim: {
        anim: "fadeInRight",
        duration: "0.35s",
        delay: `${0.075 * index}s`
      },
      children: /* @__PURE__ */ jsx3("table", { className: "arclight-w-full", children: /* @__PURE__ */ jsxs2("tbody", { children: [
        /* @__PURE__ */ jsxs2(
          "tr",
          {
            onClick: () => {
              if (items && (isExpanded === void 0 || isExpanded === null))
                setExpanded(!expanded);
              if (onClick)
                onClick();
            },
            className: `arclight-relative arclight-group ${italic ? "arclight-italic" : null}`,
            style: { color },
            children: [
              items ? /* @__PURE__ */ jsx3(
                fontawesome_default,
                {
                  animation: "none",
                  icon: "arrow-right",
                  size: "xs",
                  className: `arclight-absolute -arclight-left-5 ${expanded ? `arclight-rotate-90` : `arclight-rotate-0`} arclight-transition-all arclight-duration-200 arclight-text-inherit`
                }
              ) : null,
              icon ? /* @__PURE__ */ jsx3("td", { className: "arclight-w-5", children: /* @__PURE__ */ jsx3(
                fontawesome_default,
                {
                  animation: "none",
                  icon,
                  size: "1x",
                  className: "arclight-mr-2 arclight-text-inherit"
                }
              ) }) : null,
              text ? /* @__PURE__ */ jsx3("td", { className: "arclight-text-left", children: /* @__PURE__ */ jsx3("span", { className: "arclight-text-lg arclight-bold", children: text }) }) : null,
              /* @__PURE__ */ jsx3(
                "div",
                {
                  className: `arclight-left-0 arclight-bottom-0 arclight-absolute arclight-border-b-2 arclight-w-0 group-hover:arclight-w-full arclight-transition-all arclight-duration-200`
                }
              )
            ]
          }
        ),
        items ? /* @__PURE__ */ jsx3("tr", { children: /* @__PURE__ */ jsx3("td", { children: /* @__PURE__ */ jsx3(
          "div",
          {
            className: `${!expanded ? "arclight-scale-y-0 arclight-h-0" : null} arclight-w-0 arclight-transition-all arclight-duration-200 arclight-origin-top ${italic ? "arclight-italic" : null}`,
            children: /* @__PURE__ */ jsx3("div", { className: `arclight-scale-90 arclight-ml-4`, children: items.sort(
              (a, b) => (
                // @ts-ignore
                autoSort && a.text && b.text ? (
                  // @ts-ignore
                  a.text < b.text ? -1 : 1
                ) : (
                  // @ts-ignore
                  autoSort && a.text && b.text ? (
                    // @ts-ignore
                    a.icon < b.icon ? -1 : 1
                  ) : null
                )
              )
            ).map((item, index2) => /* @__PURE__ */ jsx3(
              Item2,
              {
                index: index2,
                items: item.items,
                icon: item.icon,
                text: item.text,
                onClick: () => item.onClick()
              }
            )) })
          }
        ) }) }) : null
      ] }) })
    }
  ) : null;
};
var Drawer2 = ({
  locked,
  startOpen,
  animation,
  width,
  buttonSide,
  side,
  className,
  items,
  signOut,
  headerImg,
  autoSort
}) => {
  const [isOpen, setIsOpen] = React2.useState(startOpen ? startOpen : false);
  const Component2 = Menu[animation && Menu[animation] ? animation : "slide"];
  return /* @__PURE__ */ jsx3(
    styles_default2.Container,
    {
      buttonSide,
      className: className ? className : null,
      children: /* @__PURE__ */ jsx3(styles_default2.Item, { buttonSide, showBars: !locked, children: /* @__PURE__ */ jsx3(
        Component2,
        {
          right: side === "right",
          width,
          isOpen,
          onOpen: () => !locked ? setIsOpen(true) : null,
          onClose: () => !locked ? setIsOpen(false) : null,
          noOverlay: locked,
          styles: {
            bmCrossButton: {
              height: "24px",
              width: "24px"
            },
            bmCross: {
              background: "#bdc3c7"
            },
            bmMenuWrap: {
              position: "fixed",
              height: "100%"
            },
            bmMenu: {
              background: "#373a47",
              padding: "2.5em 1.5em 0",
              fontSize: "1.15em"
            },
            bmMorphShape: {
              fill: "#373a47"
            },
            bmItemList: {
              color: "#b8b7ad",
              padding: "0.8em"
            },
            bmItem: {
              display: "inline-block"
            },
            bmOverlay: {
              background: "rgba(0, 0, 0, 0.3)"
            }
          },
          children: /* @__PURE__ */ jsxs2(styles_default2.Component, { className: `${!locked ? "arclight-pt-6" : ""}`, children: [
            headerImg ? /* @__PURE__ */ jsx3(
              "img",
              {
                src: headerImg,
                className: `arclight-w-24 arclight-m-auto arclight-mb-10 arclight-mt-0`
              }
            ) : null,
            items && Array.isArray(items) ? items.sort(
              (a, b) => autoSort && a.text && b.text ? a.text < b.text ? -1 : 1 : a.text && b.text ? (
                // @ts-ignore
                autoSort && a.icon < b.icon ? -1 : 1
              ) : null
            ).map((item, index) => /* @__PURE__ */ jsx3(
              Item2,
              {
                index,
                autoSort,
                color: item.color,
                italic: item.italic,
                isExpanded: item.isExpanded ? item.isExpanded : null,
                items: item.items,
                icon: item.icon,
                text: item.text,
                onClick: () => item.onClick ? item.onClick() : null
              }
            )) : items ? /* @__PURE__ */ jsx3(
              Item2,
              {
                index: 0,
                autoSort,
                color: items.color,
                italic: items.italic,
                isExpanded: items.isExpanded ? items.isExpanded : null,
                items: items.items,
                icon: items.icon,
                text: items.text,
                onClick: () => items.onClick ? items.onClick() : null
              }
            ) : null,
            signOut ? /* @__PURE__ */ jsx3(styles_default2.SignOut, { className: `arclight-mt-8`, children: /* @__PURE__ */ jsx3(
              button_default,
              {
                span: true,
                label: "Sign Out",
                type: "button",
                size: "md",
                animation: true,
                onClick: (status) => signOut ? signOut() : null
              }
            ) }) : null
          ] })
        }
      ) })
    }
  );
};
var drawer_default = Drawer2;

// src/components/authpage/index.tsx
import React5 from "react";

// src/components/authpage/styles.js
import styled5 from "styled-components";
var Container5 = styled5.div`
	position: relative;
	height: ${(props) => props.headless ? "100vh" : "75vh"};
`;
var Body2 = styled5.div`
	width: 100%;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
`;
var styles_default5 = {
  Container: Container5,
  Body: Body2
};

// src/components/card/index.tsx
import React3 from "react";

// src/components/card/styles.js
import styled6 from "styled-components";
var Container6 = styled6.div`
  ${(props) => mountHandler(props)}
  height: 32rem;
  @media only screen and (max-width: 1024px) {
    height: ${(props) => props.bodyComponent ? "50vh" : "12rem"};
  }
  position: relative;
  ${(props) => props.medium ? `
        height: 18rem;
        @media only screen and (max-width: 1024px) {
          height: 12rem;
        }
      ` : null}
  ${(props) => props.small ? `
        width: 10rem;
        height: 8rem;
        @media only screen and (max-width: 1024px) {
          height: 8rem;
        }
      ` : null}
	${(props) => props.line ? `
        margin: 12px;
        width: 100%;
        height: 6rem;
        @media only screen and (max-width: 1024px) {
          height: 6rem;
        }
      ` : null}
			${(props) => props.linesmall ? `
			margin: 10px;
			width: 100%;
			height: 3rem;
			@media only screen and (max-width: 1024px) {
				height: 3rem;
			}
		` : null}
	${(props) => props.max ? `
			height: unset;
			width: 85%;
			max-width: 1280px;
			min-height: 24rem;
		` : null}
	${(props) => props.modal ? `
			height: 65vh;
		` : null}
`;
var Back = styled6.div`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: ${(props) => props.borderRadius};
`;
var Front = styled6.div`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: ${(props) => props.borderRadius};
`;
var BgImg = styled6.div`
  width: 100%;
  height: 100%;
  position: absolute;
  ${(props) => props.line || props.linesmall ? `
			width: 75%;
			right: 0;
		` : null}
  transition: all ease 0.25s;
`;
var BgImgChild = styled6.img`
  ${(props) => props.line || props.linesmall ? `
		-webkit-mask-image: -webkit-gradient(
			linear,
			right top,
			left bottom,
			from(rgba(0, 0, 0, 1)),
			to(rgba(0, 0, 0, 0))
		);
		` : null}
`;
var BgVidChild = styled6.video`
  ${(props) => props.line || props.linesmall ? `
		-webkit-mask-image: -webkit-gradient(
			linear,
			right top,
			left bottom,
			from(rgba(0, 0, 0, 1)),
			to(rgba(0, 0, 0, 0))
		);
		` : null}
`;
var LockContainer = styled6.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
var TabNumberWrapper = styled6.div`
  transform-origin: center;
  position: absolute;
  width: 200%;
  height: 50%;
  top: -25%;
  left: -100%;

  transform: rotate(-45deg) translate(-25%);
`;
var TabNumber = styled6.div`
  position: absolute;
  top: 0;
  left: 5px;
`;
var BodyComponent = styled6.div`
  position: relative;
  ${(props) => !props.noabsolute ? `position: absolute;
			top: 50%;
			transform: translateY(-50%);
			width: 100%;` : null}
  height: 100%;
`;
var styles_default6 = {
  BodyComponent,
  Container: Container6,
  Front,
  Back,
  BgImg,
  LockContainer,
  TabNumber,
  TabNumberWrapper,
  BgImgChild,
  BgVidChild
};

// src/components/card/index.tsx
import { PuffLoader } from "react-spinners";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Card = ({
  managed,
  exitButton,
  bodyComponent,
  bgImg,
  bgVid,
  subText,
  onClick,
  locked,
  hoverComponent,
  medium,
  small,
  className,
  index,
  line,
  linesmall,
  active,
  hover,
  mountAnim: mountAnim2,
  max,
  modal,
  noBodyComponentAbsolute
}) => {
  const imgref = React3.useRef();
  const [top, setTop] = React3.useState(0);
  const [s, setS] = React3.useState(null);
  const BodyComponentRef = React3.useRef(null);
  const [bgOpacity, setBgOpacity] = React3.useState(0);
  React3.useEffect(() => {
    if (noBodyComponentAbsolute && (max || modal)) {
      const resize = () => {
        if (!BodyComponentRef.current)
          return;
        return setS(BodyComponentRef.current.clientHeight);
      };
      window.addEventListener("resize", resize);
      resize();
      return window.removeEventListener("resize", resize);
    }
  }, [bodyComponent]);
  React3.useEffect(() => {
    if (!bgImg)
      return;
    const loaded = () => setBgOpacity(1);
    if (imgref.current.complete) {
      loaded();
    } else {
      imgref.current.addEventListener("load", loaded);
    }
  }, []);
  return /* @__PURE__ */ jsxs3(
    styles_default6.Container,
    {
      bodyComponent,
      onMouseEnter: (hover == null ? void 0 : hover.onMouseEnter) && typeof hover.onMouseEnter === "function" ? hover.onMouseEnter : void 0,
      onMouseLeave: (hover == null ? void 0 : hover.onMouseLeave) && typeof hover.onMouseLeave === "function" ? hover.onMouseLeave : void 0,
      className: !modal ? `${!noBodyComponentAbsolute ? "arclight-group " : null}${line || linesmall ? "arclight-w-full" : ""} ${bodyComponent && !line && !linesmall ? "md:arclight-w-1/2 lg:arclight-w-1/3" : null} ${!line && !linesmall && !small ? "arclight-w-full lg:arclight-max-w-sm" : ""} arclight-text-text-primary arclight-font-primary ${active !== null && active === false ? "arclight-opacity-50" : null} ${small && (!line || !linesmall) ? "arclight-w-40" : ""} ${className ? className : null}` : `arclight-max-w-2xl arclight-w-[100vw] ${className ? className : ""}`,
      max,
      modal,
      medium,
      small,
      line,
      linesmall,
      style: {
        height: s,
        cursor: onClick ? "pointer" : ""
      },
      mountAnim: mountAnim2,
      children: [
        /* @__PURE__ */ jsx4(
          styles_default6.Back,
          {
            borderRadius: "4px",
            className: `arclight-transform arclight-bg-background-tertiary arclight-opacity-0 group-hover:arclight-opacity-100 group-hover:arclight-translate-x-1 group-hover:arclight-translate-y-1 arclight-transition-all arclight-ease-linear ${locked ? "arclight-hidden" : ""}`
          }
        ),
        /* @__PURE__ */ jsxs3(
          styles_default6.Front,
          {
            onClick: onClick && !locked ? () => onClick() : null,
            borderRadius: "4px",
            className: `arclight-flex arclight-flex-col arclight-justify-end arclight-text-center arclight-bg-background-secondary ${!modal ? `arclight-overflow-hidden` : ""}`,
            children: [
              bgImg ? /* @__PURE__ */ jsx4(
                styles_default6.BgImg,
                {
                  line: line || linesmall,
                  className: `arclight-rounded arclight-overflow-hidden`,
                  style: noBodyComponentAbsolute && (max || modal) ? { top } : {},
                  children: /* @__PURE__ */ jsxs3(
                    "div",
                    {
                      className: `arclight-relative arclight-w-full arclight-h-full`,
                      children: [
                        /* @__PURE__ */ jsx4(
                          styles_default6.BgImgChild,
                          {
                            ref: imgref,
                            line,
                            linesmall,
                            src: bgImg,
                            className: `arclight-object-cover arclight-h-full arclight-w-full arclight-transition-all arclight-duration-600 ${!bgOpacity ? `arclight-opacity-0` : `arclight-opacity-100`}`,
                            style: noBodyComponentAbsolute && false ? { height: `calc(100vh + 1000px)` } : {}
                          }
                        ),
                        /* @__PURE__ */ jsx4(
                          PuffLoader,
                          {
                            color: "#B6B6B6",
                            className: `arclight-absolute arclight-transition-all arclight-duration-600 arclight-top-1/2 arclight-left-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2 ${bgOpacity ? `arclight-opacity-0` : `arclight-opacity-100`}`
                          }
                        )
                      ]
                    }
                  )
                }
              ) : null,
              bgVid ? /* @__PURE__ */ jsx4(
                styles_default6.BgImg,
                {
                  line: line || linesmall,
                  className: `arclight-rounded arclight-overflow-hidden`,
                  style: noBodyComponentAbsolute && (max || modal) ? { top } : {},
                  children: /* @__PURE__ */ jsx4(
                    styles_default6.BgVidChild,
                    {
                      preload: true,
                      line,
                      linesmall,
                      src: bgVid,
                      className: `arclight-object-cover arclight-h-full arclight-w-full`,
                      style: noBodyComponentAbsolute && false ? { height: `calc(100vh + 1000px)` } : {}
                    }
                  )
                }
              ) : null,
              bodyComponent ? /* @__PURE__ */ jsx4(
                styles_default6.BodyComponent,
                {
                  noabsolute: noBodyComponentAbsolute,
                  ref: BodyComponentRef,
                  children: /* @__PURE__ */ jsx4(
                    "div",
                    {
                      className: `arclight-flex arclight-flex-col arclight-justify-center arclight-align-middle arclight-w-full arclight-h-full arclight-rounded`,
                      children: bodyComponent
                    }
                  )
                }
              ) : null,
              /* @__PURE__ */ jsx4(
                styles_default6.TabNumberWrapper,
                {
                  className: `${!index ? "arclight-hidden" : null}`
                }
              ),
              /* @__PURE__ */ jsx4(styles_default6.TabNumber, { className: `${!index ? "arclight-hidden" : null}`, children: index }),
              hoverComponent && !locked ? /* @__PURE__ */ jsx4(
                "div",
                {
                  className: `arclight-w-full arclight-top-0 arclight-absolute ${!subText ? "arclight-h-full" : line || linesmall ? "arclight-h-2/3" : "arclight-h-3/4"} arclight-bg-visibility-primary arclight-opacity-0 group-hover:arclight-opacity-100 arclight-transition-all arclight-ease-linear`,
                  children: /* @__PURE__ */ jsx4(
                    "div",
                    {
                      className: `arclight-absolute arclight-top-1/2 arclight-left-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2`,
                      children: hoverComponent
                    }
                  )
                }
              ) : null,
              /* @__PURE__ */ jsx4(
                "div",
                {
                  className: `arclight-w-full arclight-bottom-0 arclight-absolute ${line || linesmall ? "arclight-h-1/3" : "arclight-h-1/4"} arclight-bg-visibility-primary ${!subText || line || linesmall ? "arclight-hidden" : null}`
                }
              ),
              subText ? /* @__PURE__ */ jsx4(
                "div",
                {
                  className: `${medium ? "arclight-m-2 lg:arclight-m-5 arclight-text-2xl" : !(line || linesmall) && !small ? "arclight-m-2 lg:arclight-m-10 arclight-text-2xl" : !(line || linesmall) ? "arclight-text-sm" : line || linesmall ? "arclight-text-sm lg:arclight-text-lg arclight-text-left arclight-px-10 md:arclight-px-20 arclight-h-3/5" : "arclight-text-md lg:arclight-text-2xl"} arclight-relative arclight-p-0${managed ? ` arclight-text-cyan-300` : ""}`,
                  children: subText
                }
              ) : null,
              exitButton ? /* @__PURE__ */ jsx4(
                button_default,
                {
                  className: `arclight-absolute arclight-top-2 arclight-right-2`,
                  idleIcon: "arrow-right-from-bracket",
                  type: "button",
                  size: "normal",
                  animation: true,
                  onClick: exitButton
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ jsx4(
          styles_default6.LockContainer,
          {
            className: `arclight-bg-visibility-primary ${locked ? "" : "arclight-hidden"}`,
            children: /* @__PURE__ */ jsxs3(
              "div",
              {
                className: `arclight-absolute arclight-left-1/2 arclight-top-1/2 -arclight-translate-x-2/4 -arclight-translate-y-1/2 arclight-text-center`,
                children: [
                  /* @__PURE__ */ jsx4(fontawesome_default, { size: "2x", icon: "lock" }),
                  /* @__PURE__ */ jsx4(
                    "div",
                    {
                      className: `arclight-text-sm xl:arclight-text-lg arclight-text-left arclight-md-10`,
                      children: locked
                    }
                  )
                ]
              }
            )
          }
        )
      ]
    }
  );
};
var card_default = Card;

// src/components/textfield/index.tsx
import React4 from "react";
import { TextField as _TextField } from "@mui/material";

// src/components/textfield/styles.js
import styled7 from "styled-components";
var Container7 = styled7.div`
  width: 100%;
  ${(props) => !props.span ? `max-width: 400px;` : null}
`;
var styles_default7 = {
  Container: Container7
};

// src/components/textfield/index.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var TextField = ({
  key,
  label,
  variant,
  span,
  type: type2,
  onChange,
  hot,
  value,
  defaultValue,
  multiline,
  rows
}) => {
  const inputRef = React4.useRef();
  return /* @__PURE__ */ jsx5(styles_default7.Container, { span, children: /* @__PURE__ */ jsx5(
    _TextField,
    {
      onKeyDown: (e) => {
        e.stopPropagation();
      },
      rows,
      multiline,
      inputRef,
      defaultValue,
      value,
      onChange: (d) => {
        if (hot)
          onChange(d);
      },
      onBlur: (d) => {
        if (!hot)
          onChange(d);
      },
      type: type2,
      label,
      variant,
      fullWidth: true,
      InputProps: {
        ref: inputRef,
        style: {
          color: "inherit",
          fontFamily: "inherit"
        }
      },
      InputLabelProps: {
        style: {
          color: "inherit",
          fontFamily: "inherit"
        }
      }
    },
    key
  ) });
};
var textfield_default = TextField;

// src/components/loader/styles.js
import styled8 from "styled-components";
var Container8 = styled8.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;
var styles_default8 = {
  Container: Container8
};

// src/components/loader/index.tsx
import { ClipLoader } from "react-spinners";
import { jsx as jsx6 } from "react/jsx-runtime";
var Loader = ({ loading }) => {
  return /* @__PURE__ */ jsx6(
    styles_default8.Container,
    {
      className: `${loading ? `arclight-opacity-100` : `arclight-opacity-0`}`,
      children: /* @__PURE__ */ jsx6(
        ClipLoader,
        {
          color: "red",
          loading: true,
          size: 150,
          "aria-label": "Loading Spinner",
          "data-testid": "loader"
        }
      )
    }
  );
};
var loader_default = Loader;

// src/components/authpage/index.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var AuthPage = ({
  fns: fns2,
  D,
  authBackgroundImage,
  OATH,
  OATHOnly,
  disableNewRegistration,
  className,
  redirect,
  headless
}) => {
  const [credentials, setCredentials] = React5.useState({
    username: "",
    password: "",
    email: ""
  });
  React5.useEffect(() => {
    if (D && D.DiscordOATH2 && D.DiscordOATH2.url)
      window.location.replace(D.DiscordOATH2.url);
  }, [D]);
  return /* @__PURE__ */ jsx7(styles_default5.Container, { className, headless, children: /* @__PURE__ */ jsx7(styles_default5.Body, { children: /* @__PURE__ */ jsx7(
    "div",
    {
      className: `arclight-flex arclight-justify-center arclight-relative xs:max-md:arclight-w-3/4 xs:max-md:arclight-mx-auto`,
      children: /* @__PURE__ */ jsx7(
        card_default,
        {
          bgImg: authBackgroundImage,
          bodyComponent: /* @__PURE__ */ jsxs4(
            "div",
            {
              className: `arclight-flex arclight-flex-col arclight-space-y-6 arclight-justify-center arclight-w-3/4 arclight-m-auto`,
              children: [
                !OATHOnly ? /* @__PURE__ */ jsxs4(React5.Fragment, { children: [
                  /* @__PURE__ */ jsx7(
                    textfield_default,
                    {
                      hot: true,
                      onChange: (data) => setCredentials((_) => __spreadProps(__spreadValues({}, _), {
                        username: data.target.value
                      })),
                      value: credentials.username,
                      span: true,
                      type: "text",
                      label: "Username",
                      variant: "standard"
                    },
                    1
                  ),
                  /* @__PURE__ */ jsx7(
                    textfield_default,
                    {
                      hot: true,
                      onChange: (data) => setCredentials((_) => __spreadProps(__spreadValues({}, _), {
                        password: data.target.value
                      })),
                      value: credentials.password,
                      span: true,
                      type: "password",
                      label: "Password",
                      variant: "standard"
                    },
                    1
                  ),
                  /* @__PURE__ */ jsx7(
                    "div",
                    {
                      className: `arclight-flex arclight-flex-col arclight-space-y-2 arclight-justify-center arclight-w-full`,
                      children: /* @__PURE__ */ jsx7(
                        button_default,
                        {
                          span: true,
                          label: "Sign In",
                          type: "button",
                          size: "large",
                          animation: true,
                          onClick: (status) => fns2.authenticate(credentials, redirect)
                        }
                      )
                    }
                  )
                ] }) : null,
                OATH ? /* @__PURE__ */ jsxs4(React5.Fragment, { children: [
                  /* @__PURE__ */ jsx7(
                    "div",
                    {
                      className: `arclight-border-b-2 arclight-border-b-text-primary ${OATHOnly ? "hidden" : null}`
                    }
                  ),
                  /* @__PURE__ */ jsx7(
                    "div",
                    {
                      className: `arclight-flex arclight-flex-${OATHOnly ? "arclight-col arclight-space-y-4 arclight-m-auto" : "arclight-row arclight-space-x-4"} arclight-w-3/4`,
                      children: OATH.map((s) => /* @__PURE__ */ jsx7(
                        button_default,
                        {
                          span: OATHOnly,
                          label: OATHOnly ? s.type.charAt(0).toUpperCase() + s.type.slice(1) : null,
                          idleIcon: s.type.toLowerCase(),
                          type: "button",
                          size: "large",
                          animation: true,
                          isIconButton: OATHOnly ? false : true,
                          onClick: (status) => s.onClick ? s.onClick() : null
                        }
                      ))
                    }
                  )
                ] }) : null,
                !disableNewRegistration && !OATHOnly ? /* @__PURE__ */ jsx7(
                  button_default,
                  {
                    span: true,
                    label: "Don't have an account?",
                    type: "button",
                    size: "small",
                    animation: true,
                    onClick: (status) => fns2.setModal({
                      noescape: true,
                      body: function Body9(props) {
                        const [loading, setLoading] = React5.useState(false);
                        const [username, setUsername] = React5.useState("");
                        const [password, setPassword] = React5.useState("");
                        const [verifyPassword, setVerifyPassword] = React5.useState("");
                        const [email, setEmail] = React5.useState("");
                        React5.useEffect(() => {
                          if (!props.D.serversuccess)
                            setLoading(false);
                          if (props.D.serversuccess)
                            props.setModal(false);
                        }, [
                          props.D.serversuccess,
                          props.D.servererror,
                          props.D.serverwarning,
                          props.D.servermessage
                        ]);
                        React5.useEffect(
                          () => props.setExitButton ? props.setExitButton(!loading) : null,
                          [loading]
                        );
                        return !loading ? /* @__PURE__ */ jsxs4(
                          "div",
                          {
                            className: `arclight-w-full arclight-max-w-xs`,
                            children: [
                              /* @__PURE__ */ jsx7("div", { children: "Register a New Account" }),
                              [
                                {
                                  defaultValue: "",
                                  type: "text",
                                  label: "Username",
                                  v: username,
                                  fn: setUsername
                                },
                                {
                                  defaultValue: "",
                                  type: "password",
                                  label: "Password",
                                  v: password,
                                  fn: setPassword
                                },
                                {
                                  defaultValue: "",
                                  type: "password",
                                  label: "Verify Password",
                                  v: verifyPassword,
                                  fn: setVerifyPassword
                                },
                                {
                                  defaultValue: "",
                                  type: "text",
                                  label: "Email",
                                  v: email,
                                  fn: setEmail
                                }
                              ].map((el, i) => /* @__PURE__ */ jsx7(
                                textfield_default,
                                {
                                  span: true,
                                  hot: true,
                                  value: el.v,
                                  onChange: (e) => el.fn(e.target.value),
                                  type: el.type,
                                  label: el.label,
                                  variant: "standard"
                                },
                                i
                              )),
                              /* @__PURE__ */ jsx7("div", { className: `arclight-mt-3`, children: /* @__PURE__ */ jsx7(
                                button_default,
                                {
                                  span: true,
                                  label: "submit",
                                  type: "button",
                                  size: "md",
                                  animation: true,
                                  disabled: false,
                                  block: false,
                                  rounded: false,
                                  square: false,
                                  isIconButton: false,
                                  onClick: (status2) => {
                                    if (fns2 && fns2.calls && fns2.calls.registeruser) {
                                      setLoading(true);
                                      fns2.calls.registeruser({
                                        username,
                                        password,
                                        email,
                                        redirect: `http://leagueoflegends.localhost:3000/login`
                                      });
                                    }
                                  }
                                }
                              ) })
                            ]
                          }
                        ) : /* @__PURE__ */ jsx7(loader_default, { loading: true });
                      },
                      bgImg: `https://wallpaperaccess.com/full/6843267.jpg`
                    })
                  }
                ) : null
              ]
            }
          )
        }
      )
    }
  ) }) });
};
var authpage_default = AuthPage;

// src/components/admin/flexpanel/index.tsx
import React29 from "react";

// src/components/admin/flexpanel/styles.js
import styled9 from "styled-components";
var Container9 = styled9.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
var Item3 = styled9.div`
  ${(props) => mountHandler(props)}
  width: 100%;
  max-width: 99%;
  max-height: 99%;
  position: relative;
`;
var NoSelect = styled9.div`
  ${(props) => mountHandler(props)}
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`;
var ItemContent = styled9.div``;
var Table = styled9.table`
  width: 100%;
`;
var BgImg2 = styled9.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.05;
  object-fit: cover;
  pointer-events: none;
`;
var styles_default9 = {
  Container: Container9,
  Item: Item3,
  Table,
  ItemContent,
  NoSelect,
  BgImg: BgImg2
};

// src/components/picklist/index.tsx
import React7 from "react";

// src/components/picklist/styles.js
import styled10 from "styled-components";
var Container10 = styled10.div`
  width: 100%;
  ${(props) => !props.span ? `max-width: 400px;` : null}
  &::-webkit-scrollbar {
    display: none;
  }
`;
var SearchControls = styled10.div``;
var styles_default10 = {
  Container: Container10,
  SearchControls
};

// src/components/picklist/index.tsx
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";

// src/components/checkbox/index.tsx
import React6 from "react";
import { Checkbox as _Checkbox } from "@mui/material";

// src/components/checkbox/styles.js
import styled11 from "styled-components";
var Container11 = styled11.div`
	align-items: center;
`;
var styles_default11 = {
  Container: Container11
};

// src/components/checkbox/index.tsx
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var Checkbox = ({ value, onChange, label }) => {
  const [checked, setChecked] = React6.useState(
    value ? value : false
  );
  React6.useEffect(() => setChecked(value), [value]);
  return /* @__PURE__ */ jsxs5(styles_default11.Container, { className: `arclight-flex`, children: [
    /* @__PURE__ */ jsx8(
      _Checkbox,
      {
        checked: checked ? true : false,
        onChange: () => onChange ? onChange(checked, (b) => setChecked(b)) : null,
        style: { color: "inherit" }
      }
    ),
    label ? /* @__PURE__ */ jsx8(
      "div",
      {
        className: `arclight-text-md arclight-font-primary arclight-primary`,
        children: label
      }
    ) : null
  ] });
};
var checkbox_default = Checkbox;

// src/components/picklist/index.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var _picklistSizeLimit = 10;
var __val = (obj, value = false) => {
  if (!obj.D)
    return;
  const _ = obj.label === "model";
  const __ = obj.script ? obj.script : `getrecords_${obj.type}`;
  if (_ && obj.D.getdatamodels && obj.D.getdatamodels[`model__${obj.label}value-${obj.keyname}`]) {
    return obj.D.getdatamodels[`model__${obj.label}value-${obj.keyname}`];
  } else if (obj.D[__] && obj.D[__][`${obj.label}`]) {
    return obj.D[__][`${obj.label}${value ? "value" : ""}`];
  }
};
var __condition1 = (obj) => {
  return !obj.loading && !obj.disableSearch && __val(obj);
};
var __renderValue = (obj) => {
  const v = obj.unlinked ? {
    records: Array.isArray(obj.value) ? obj.list.filter((el) => obj.value.includes(el.value)) : [obj.list.find((el) => el.value === obj.value)]
  } : __val(obj, true);
  if (v && v.records) {
    return v.records.map((_) => {
      if (!_)
        return;
      const arr = ["_type", "username", "name", "text", "title"];
      for (let i = 0; i < arr.length; i++)
        if (_[arr[i]])
          return _[arr[i]];
    }).join(", ");
  }
  return "";
};
var __query = (obj) => {
  const _ = obj.type === "model";
  const __ = obj.label === "model";
  if (!__ && obj.fns.calls[obj.script ? obj.script : _ ? "getdatamodels" : `getrecords_${obj.type}`]) {
    if (obj.script) {
      obj.fns.calls[obj.script]({
        index: obj.label,
        search: {
          [obj.searchkey]: obj.searchFilterValue ? { $regex: obj.searchFilterValue, $options: "i" } : void 0,
          limit: _picklistSizeLimit,
          skip: obj.skip * _picklistSizeLimit
        }
      });
    } else {
      obj.fns.calls[_ ? "getdatamodels" : `getrecords_${obj.type}`]({
        index: !_ ? obj.label : void 0,
        search: {
          [obj.searchkey]: obj.searchFilterValue ? { $regex: obj.searchFilterValue, $options: "i" } : void 0,
          limit: _picklistSizeLimit,
          skip: obj.skip * _picklistSizeLimit
        }
      });
    }
  }
  if (obj.value && obj.value.length) {
    if (obj.script ? !obj.fns.calls[obj.script] : !obj.fns.calls[__ ? `getdatamodels` : `getrecords_${obj.type}`])
      return;
    const _id = Array.isArray(obj[__ ? "id" : "value"]) ? { $in: obj[__ ? "id" : "value"] } : obj[__ ? "id" : "value"];
    if (obj.script) {
      obj.fns.calls[obj.script]({
        index: `${obj.label}value`,
        search: {
          _id
        }
      });
    } else {
      obj.fns.calls[__ ? `getdatamodels` : `getrecords_${obj.type}`]({
        index: `${__ ? "model__" : ""}${obj.label}value${__ ? `-${obj.keyname}` : ""}`,
        search: {
          _id
        }
      });
    }
  }
};
var PickList = ({
  type: type2,
  multiple,
  keyname,
  label,
  variant,
  span,
  onChange,
  hot,
  value,
  list,
  disallowNone,
  D,
  fns: fns2,
  id,
  unlinked,
  searchkey,
  script
}) => {
  const [_searchkey, setSearchKey] = React7.useState(searchkey);
  const [skip, setSkip] = React7.useState(0);
  const [loading, setLoading] = React7.useState(!unlinked && id);
  const [searchFilterValue, setSearchFilterValue] = React7.useState(void 0);
  const None = !loading && !multiple && !disallowNone ? /* @__PURE__ */ jsx9(MenuItem, { value: "", sx: { backgroundColor: "transparent" }, children: /* @__PURE__ */ jsx9("div", { className: `arclight-text-text-primary arclight-font-primary`, children: /* @__PURE__ */ jsx9("em", { children: "None" }) }) }) : null;
  const Items = list && !loading ? list.concat({ value, text: "" }).map((el) => {
    return /* @__PURE__ */ jsx9(
      MenuItem,
      {
        value: el.value,
        sx: {
          backgroundColor: "transparent",
          display: !el.text || !el.text.length ? "none" : ""
        },
        children: /* @__PURE__ */ jsx9(
          "div",
          {
            className: `arclight-text-text-primary arclight-font-primary`,
            children: multiple ? /* @__PURE__ */ jsx9("table", { children: /* @__PURE__ */ jsx9("tbody", { children: /* @__PURE__ */ jsxs6("tr", { children: [
              /* @__PURE__ */ jsx9("td", { children: /* @__PURE__ */ jsx9(
                checkbox_default,
                {
                  value: value && Array.isArray(value) ? value.some((val) => val === el.value) : false
                }
              ) }),
              multiple ? /* @__PURE__ */ jsx9("td", { children: el.text }) : null
            ] }) }) }) : el.text
          }
        )
      }
    );
  }) : /* @__PURE__ */ jsx9("div", { style: { minHeight: "180px" }, children: /* @__PURE__ */ jsx9(loader_default, { loading }) });
  React7.useEffect(() => {
    if (unlinked)
      return;
    setLoading(false);
  }, [D]);
  React7.useEffect(() => {
    if (unlinked)
      return;
    if (!fns2)
      return;
    __query({
      searchFilterValue,
      type: type2,
      fns: fns2,
      label,
      value,
      skip,
      keyname,
      id,
      searchkey: _searchkey,
      script
    });
  }, [skip]);
  return !(!Array.isArray(value) && multiple) ? /* @__PURE__ */ jsx9(styles_default10.Container, { span, children: /* @__PURE__ */ jsxs6(
    FormControl,
    {
      variant,
      style: { width: "100%", textAlign: "left" },
      children: [
        /* @__PURE__ */ jsx9(
          InputLabel,
          {
            style: {
              color: "inherit",
              fontFamily: "inherit",
              width: "100%"
            },
            children: label
          }
        ),
        /* @__PURE__ */ jsxs6(
          Select,
          {
            multiple,
            value,
            renderValue: () => {
              return __renderValue({
                script,
                D,
                type: type2,
                label,
                keyname,
                list,
                value,
                unlinked
              });
            },
            onOpen: () => {
              setSearchFilterValue(void 0);
              if (unlinked)
                return;
              setSkip(0);
              if (id)
                setLoading(true);
              __query({
                script,
                type: type2,
                fns: fns2,
                label,
                value,
                skip,
                keyname,
                id,
                searchkey: _searchkey
              });
            },
            onChange: (d) => {
              if (hot) {
                if (!unlinked && d.target.value && d.target.value.length) {
                  const _ = label === "model";
                  const _id = _ ? id : Array.isArray(d.target.value) ? { $in: d.target.value } : d.target.value;
                  fns2.calls[_ ? `getdatamodels` : script ? script : `getrecords_${type2}`]({
                    index: _ ? `model__${label}value-${keyname}` : `${label}value`,
                    search: {
                      _id
                    }
                  });
                }
                onChange(d);
              }
            },
            onBlur: (d) => {
              if (!hot)
                onChange(d);
            },
            style: {
              color: "inherit",
              fontFamily: "inherit",
              width: "100%"
            },
            MenuProps: {
              sx: {
                "& .MuiPaper-root": {
                  backgroundColor: "rgb(32,32,32)"
                },
                "&& .Mui-selected": {
                  //backgroundColor: "pink",
                }
              }
              //transitionDuration: 200
            },
            children: [
              __condition1({ D, loading, type: type2, keyname, label, script }) ? /* @__PURE__ */ jsxs6(
                "div",
                {
                  className: `arclight-text-text-primary arclight-font-primary arclight-m-5 arclight-mb-0 arclight-mt-0 arclight-max-w-sm`,
                  children: [
                    /* @__PURE__ */ jsx9(
                      textfield_default,
                      {
                        value: searchFilterValue,
                        hot,
                        onChange: (data) => setSearchFilterValue(data.target.value),
                        type: "text",
                        label: "Search",
                        variant: "standard"
                      },
                      1
                    ),
                    /* @__PURE__ */ jsxs6(
                      "div",
                      {
                        className: `arclight-flex arclight-flex-row arclight-justify-start`,
                        children: [
                          /* @__PURE__ */ jsx9(
                            button_default,
                            {
                              label: "Search",
                              idleIcon: null,
                              type: "button",
                              size: "normal",
                              animation: true,
                              className: `arclight-m-1 lg:arclight-block`,
                              onClick: () => {
                                __query({
                                  script,
                                  searchFilterValue,
                                  type: type2,
                                  fns: fns2,
                                  label,
                                  value,
                                  skip,
                                  keyname,
                                  id,
                                  searchkey: _searchkey
                                });
                                setSkip(0);
                              }
                            }
                          ),
                          /* @__PURE__ */ jsxs6(
                            "div",
                            {
                              className: `arclight-flex arclight-flex-row arclight-justify-end arclight-w-full`,
                              children: [
                                /* @__PURE__ */ jsx9(
                                  button_default,
                                  {
                                    label: "Last",
                                    idleIcon: "arrow-left",
                                    type: "button",
                                    size: "normal",
                                    animation: true,
                                    className: `arclight-m-1 lg:arclight-block ${skip < 1 ? `arclight-opacity-30 arclight-pointer-events-none` : ""}`,
                                    onClick: () => setSkip(skip - 1)
                                  }
                                ),
                                /* @__PURE__ */ jsx9(
                                  button_default,
                                  {
                                    label: "Next",
                                    idleIcon: "arrow-right",
                                    type: "button",
                                    size: "normal",
                                    animation: true,
                                    className: D[`getrecords_${type2}`] && D[`getrecords_${type2}`][label] ? `arclight-m-1 lg:arclight-block ${skip * _picklistSizeLimit > D[`getrecords_${type2}`][label].totalcount - _picklistSizeLimit ? `arclight-opacity-30 arclight-pointer-events-none` : ""}` : ``,
                                    onClick: () => setSkip(skip + 1)
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ) : null,
              None,
              Items
            ]
          }
        )
      ]
    }
  ) }) : null;
};
var picklist_default = PickList;

// src/components/dateselector/index.tsx
import moment from "moment";

// src/components/dateselector/styles.js
import styled12 from "styled-components";
var Container12 = styled12.div``;
var styles_default12 = {
  Container: Container12
};

// src/components/dateselector/index.tsx
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment/index.js";
import { LocalizationProvider } from "@mui/x-date-pickers/index.js";
import { DatePicker } from "@mui/x-date-pickers/DatePicker/index.js";
import { jsx as jsx10 } from "react/jsx-runtime";
var DateSelector = ({ onChange, label, value }) => {
  return /* @__PURE__ */ jsx10(styles_default12.Container, { className: `arclight-font-primary arclight-relative`, children: /* @__PURE__ */ jsx10(LocalizationProvider, { dateAdapter: AdapterMoment, children: /* @__PURE__ */ jsx10(
    DatePicker,
    {
      label,
      value: value ? value : moment(),
      className: `arclight-rounded arclight-text-white`,
      views: ["day", "month", "year"],
      onChange: (value2) => onChange(value2)
    }
  ) }) });
};
var dateselector_default = DateSelector;

// src/components/calendar/index.tsx
import React10 from "react";
import moment2 from "moment";

// src/components/calendar/styles.js
import styled13 from "styled-components";
var Container13 = styled13.div``;
var styles_default13 = {
  Container: Container13
};

// src/components/calendar/_navbar.tsx
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var Calendar = ({ state, setState, moment: moment4 }) => {
  const B = (props) => /* @__PURE__ */ jsx11(
    button_default,
    {
      className: ``,
      label: props.label,
      type: "button",
      size: "normal",
      animation: true,
      onClick: (status) => props.onClick ? props.onClick() : null
    }
  );
  return /* @__PURE__ */ jsxs7("div", { className: `arclight-flex arclight-mb-3`, children: [
    /* @__PURE__ */ jsxs7("div", { className: `arclight-flex arclight-space-x-1`, children: [
      /* @__PURE__ */ jsx11(
        B,
        {
          label: "Back",
          onClick: () => {
            state.today.subtract(1, "month");
            const monthStart = moment4(state.today._d).startOf("month").day();
            const monthEnd = moment4(state.today._d).endOf("month").get("date");
            setState((_) => __spreadProps(__spreadValues({}, _), {
              monthStart,
              monthEnd,
              offset: state.offset + 1
            }));
          }
        }
      ),
      /* @__PURE__ */ jsx11(
        B,
        {
          label: "Today",
          onClick: () => {
            state.today.add(state.offset, "month");
            const monthStart = moment4(state.today._d).startOf("month").day();
            const monthEnd = moment4(state.today._d).endOf("month").get("date");
            setState((_) => __spreadProps(__spreadValues({}, _), {
              monthStart,
              monthEnd,
              offset: 0
            }));
          }
        }
      ),
      /* @__PURE__ */ jsx11(
        B,
        {
          label: "Next",
          onClick: () => {
            state.today.add(1, "month");
            const monthStart = moment4(state.today._d).startOf("month").day();
            const monthEnd = moment4(state.today._d).endOf("month").get("date");
            setState((_) => __spreadProps(__spreadValues({}, _), {
              monthStart,
              monthEnd,
              offset: state.offset - 1
            }));
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx11(
      "div",
      {
        className: `arclight-flex arclight-justify-center arclight-w-full arclight-text-center arclight-items-center`,
        children: state.today.format("MMMM YYYY")
      }
    ),
    /* @__PURE__ */ jsx11(
      "div",
      {
        className: `arclight-flex arclight-space-x-1 arclight-w-full arclight-justify-end`,
        children: /* @__PURE__ */ jsx11(B, { label: "Month", onClick: () => null })
      }
    )
  ] });
};
var navbar_default = Calendar;

// src/components/calendar/_weekdaybar.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var Calendar2 = ({}) => {
  return /* @__PURE__ */ jsx12("div", { className: `arclight-flex arclight-w-full arclight-mb-3`, children: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ].map((t) => /* @__PURE__ */ jsx12("div", { className: `arclight-flex-1 arclight-text-center`, children: t })) });
};
var weekdaybar_default = Calendar2;

// src/components/calendar/_event.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var Event = ({ text }) => {
  return /* @__PURE__ */ jsx13(
    "div",
    {
      className: `arclight-w-full arclight-bg-background-primary arclight-rounded arclight-text-xs`,
      children: text
    }
  );
};
var event_default = Event;

// src/components/calendar/_eventcard.tsx
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var EventCard = ({ events }) => {
  const n = 4;
  return (events == null ? void 0 : events.length) ? /* @__PURE__ */ jsx14(
    "div",
    {
      className: `arclight-w-full arclight-h-24 arclight-p-1 arclight-pt-3 arclight-space-y-1`,
      children: events.map(
        (event, i) => i <= n ? /* @__PURE__ */ jsxs8("div", { children: [
          i < n ? /* @__PURE__ */ jsx14(event_default, { text: event.info.text }) : null,
          i === n ? /* @__PURE__ */ jsxs8("div", { className: `arclight-w-full arclight-text-xs`, children: [
            "+",
            events.length - n,
            " Events"
          ] }) : null
        ] }) : null
      )
    }
  ) : null;
};
var eventcard_default = EventCard;

// src/components/calendar/_largeview.tsx
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var LargeView = ({
  callModal,
  state,
  setState,
  events,
  moment: moment4,
  defaultEventBgImg,
  manageEvent,
  body
}) => {
  let n = 0;
  const C = (props) => {
    const _events = props.events.filter((event) => {
      if (!props.date)
        return;
      return event.startDate.startOf("day") <= props.date.startOf("day") && event.endDate.startOf("day") >= props.date.startOf("day");
    });
    return /* @__PURE__ */ jsx15(
      card_default,
      {
        noBodyComponentAbsolute: false,
        index: props.index,
        hover: {
          onMouseEnter: () => {
          },
          onMouseLeave: () => {
          }
        },
        active: (_events == null ? void 0 : _events.length) > 0,
        small: true,
        hoverComponent: void 0,
        locked: false,
        bgImg: (_events == null ? void 0 : _events.length) > 0 ? _events[0].info.img : defaultEventBgImg && !props.inactive ? defaultEventBgImg : null,
        bodyComponent: /* @__PURE__ */ jsx15(eventcard_default, { events: _events }),
        onClick: () => {
          if ((_events == null ? void 0 : _events.length) > 0) {
            callModal({
              date: props.date,
              bgImg: _events[0].info.img,
              events: _events,
              body: body(_events[0]._id, _events[0].info.body)
            });
          } else if (defaultEventBgImg) {
            callModal({
              date: props.date,
              bgImg: defaultEventBgImg,
              body: manageEvent(props.date)
            });
          }
        },
        className: props.inactive ? `arclight-opacity-5 arclight-pointer-events-none` : ``
      }
    );
  };
  const buildRow = () => {
    const _ = [];
    for (let i = 0; i < 7; i++) {
      const cond = (i >= state.monthStart || n) && n < state.monthEnd;
      _.push(
        /* @__PURE__ */ jsx15(
          C,
          {
            events,
            index: cond ? ++n : null,
            inactive: !cond,
            date: cond ? moment4(state.today).startOf("month").add(n - 1, "day") : null
          }
        )
      );
    }
    return /* @__PURE__ */ jsx15("div", { className: `arclight-flex arclight-space-x-3`, children: _ });
  };
  const buildRows = () => {
    const _ = [];
    for (let i = 0; i < 6 && n < state.monthEnd; i++) {
      _.push(buildRow());
    }
    return /* @__PURE__ */ jsx15("div", { className: `arclight-space-y-3`, children: _ });
  };
  return /* @__PURE__ */ jsxs9(
    styles_default13.Container,
    {
      className: `arclight-flex-col arclight-px-3 arclight-py-3 arclight-w-full`,
      children: [
        /* @__PURE__ */ jsx15(navbar_default, { state, setState, moment: moment4 }),
        /* @__PURE__ */ jsx15(weekdaybar_default, {}),
        buildRows()
      ]
    }
  );
};
var largeview_default = LargeView;

// src/components/calendar/_manageevent.tsx
import React9 from "react";

// src/components/monaco/index.tsx
import React8 from "react";
import Editor from "@monaco-editor/react";

// src/components/monaco/styles.js
import styled14 from "styled-components";
var Container14 = styled14.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
var FormatButton = styled14.div`
  position: absolute;
  right: 40px;
  bottom: 20px;
`;
var styles_default14 = {
  Container: Container14,
  FormatButton
};

// src/components/monaco/index.tsx
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var Monaco = ({
  language,
  defaultValue,
  state,
  setState,
  refName
}) => {
  const MonacoRef = React8.useRef(null);
  React8.useEffect(() => {
    if (MonacoRef && MonacoRef.current && //@ts-ignore
    MonacoRef.monaco && //@ts-ignore
    MonacoRef.monaco.editor) {
      MonacoRef.monaco.editor.setModelLanguage(
        //@ts-ignore
        MonacoRef.monaco.editor.getModels()[0],
        language
      );
      MonacoRef.current.setValue(defaultValue);
      if (MonacoRef.current.getAction("editor.action.formatDocument")) {
        MonacoRef.current.getAction("editor.action.formatDocument").run();
      }
    }
  }, [language, defaultValue, refName]);
  return /* @__PURE__ */ jsxs10(styles_default14.Container, { children: [
    /* @__PURE__ */ jsx16(
      Editor,
      {
        height: "100%",
        width: "100%",
        theme: "vs-dark",
        defaultLanguage: language ? language : "javascript",
        defaultValue: defaultValue ? defaultValue : "",
        onMount: (editor, monaco) => {
          if (setState && MonacoRef) {
            const stateMonacoRef = state && state.MonacoRef ? state.MonacoRef : {};
            MonacoRef.current = editor;
            MonacoRef.monaco = monaco;
            stateMonacoRef[refName] = MonacoRef;
            setState((_) => __spreadProps(__spreadValues({}, _), {
              MonacoRef: stateMonacoRef
            }));
            [10, 20, 40, 80].map(
              (n) => setTimeout(() => {
                if (
                  //@ts-ignore
                  MonacoRef.current.getAction("editor.action.formatDocument")
                ) {
                  MonacoRef.current.getAction("editor.action.formatDocument").run();
                }
              }, n)
            );
          }
        }
      }
    ),
    /* @__PURE__ */ jsx16(styles_default14.FormatButton, { children: /* @__PURE__ */ jsx16(
      button_default,
      {
        idleIcon: "code",
        type: "button",
        size: "sm",
        animation: true,
        isIconButton: true,
        onClick: (status) => MonacoRef && MonacoRef.current && //@ts-ignore
        MonacoRef.current.getAction("editor.action.formatDocument") ? MonacoRef.current.getAction("editor.action.formatDocument").run() : null
      }
    ) })
  ] });
};
var monaco_default = Monaco;

// src/components/calendar/_manageevent.tsx
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var NewEvent = ({ D, fns: fns2, script, type: type2, date, event }) => {
  var _a, _b;
  const [state, setState] = React9.useState({
    startDate: (event == null ? void 0 : event.startDate) ? event.startDate : date,
    endDate: (event == null ? void 0 : event.endDate) ? event.endDate : date,
    recurrence: event == null ? void 0 : event.recurrence,
    title: event == null ? void 0 : event.info.text,
    img: event == null ? void 0 : event.info.img,
    script: event == null ? void 0 : event.script
  });
  return /* @__PURE__ */ jsx17("div", { className: `arclight-m-10`, children: /* @__PURE__ */ jsxs11(
    "div",
    {
      className: `arclight-bg-background-primary arclight-rounded arclight-p-10 arclight-flex-col arclight-space-y-2`,
      children: [
        /* @__PURE__ */ jsxs11("div", { className: `arclight-font-primary arclight-text-2xl`, children: [
          (event == null ? void 0 : event._id) ? "Edit" : "Create",
          " Event"
        ] }),
        /* @__PURE__ */ jsxs11(
          "div",
          {
            className: `arclight-flex arclight-justify-center arclight-space-x-10`,
            children: [
              /* @__PURE__ */ jsx17(
                dateselector_default,
                {
                  label: "Event Start Date",
                  value: state.startDate,
                  onChange: (startDate) => setState((_) => __spreadProps(__spreadValues({}, _), { startDate }))
                }
              ),
              /* @__PURE__ */ jsx17(
                dateselector_default,
                {
                  label: "Event End Date",
                  value: state.endDate,
                  onChange: (endDate) => setState((_) => __spreadProps(__spreadValues({}, _), { endDate }))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx17(
          textfield_default,
          {
            span: true,
            hot: true,
            value: state.title,
            label: "Event Title",
            type: "text",
            variant: "standard",
            onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), { title: e.target.value }))
          },
          0
        ),
        !script ? /* @__PURE__ */ jsx17(
          textfield_default,
          {
            span: true,
            hot: true,
            label: "Image Url",
            type: "text",
            variant: "standard",
            onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), { img: e.target.value }))
          },
          0
        ) : null,
        /* @__PURE__ */ jsx17(
          picklist_default,
          {
            unlinked: true,
            D,
            fns: fns2,
            span: true,
            hot: true,
            value: state.recurrence,
            list: [
              { value: "Yearly", text: "Yearly" },
              { value: "Semi-Yearly", text: "Semi-Yearly" },
              { value: "Quarterly", text: "Quarterly" },
              { value: "Monthly", text: "Monthly" },
              { value: "Bi-Weekly", text: "Bi-Weekly" },
              { value: "Weekly", text: "Weekly" },
              { value: "Daily", text: "Daily" },
              { value: "Hourly", text: "Hourly" },
              { value: "Semi-Hourly", text: "Semi-Hourly" },
              { value: "Quarter-Hourly", text: "Quarter-Hourly" },
              { value: "Ten Minutes", text: "Ten Minutes" },
              { value: "Five Minutes", text: "Five Minutes" },
              { value: "One Minute", text: "One Minute" }
            ],
            onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), { recurrence: e.target.value })),
            keyname: 0,
            label: "Recurrence",
            variant: "standard"
          }
        ),
        script && (D == null ? void 0 : D.getscripts) ? /* @__PURE__ */ jsx17(
          picklist_default,
          {
            unlinked: true,
            keyname: 0,
            D,
            fns: fns2,
            span: true,
            hot: true,
            value: state.script,
            list: ((_b = (_a = D == null ? void 0 : D.getscripts) == null ? void 0 : _a.records) == null ? void 0 : _b.universal) ? Object.keys(D.getscripts.records.universal).map(
              (k) => {
                const _ = JSON.parse(
                  D.getscripts.records.universal[k].metadata
                );
                return {
                  value: _.name,
                  text: _.name
                };
              }
            ) : [],
            onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), { script: e.target.value })),
            label: "Script",
            variant: "standard",
            searchkey: "name"
          },
          0
        ) : null,
        !script ? /* @__PURE__ */ jsxs11("div", { children: [
          /* @__PURE__ */ jsx17("div", { className: `arclight-text-md arclight-text-left`, children: "JSX" }),
          /* @__PURE__ */ jsx17("div", { className: `arclight-h-44`, children: /* @__PURE__ */ jsx17(
            monaco_default,
            {
              refName: "jsx",
              language: "jsx",
              defaultValue: "",
              state,
              setState
            }
          ) })
        ] }) : null,
        /* @__PURE__ */ jsx17(
          button_default,
          {
            span: true,
            disabled: false,
            label: `${(event == null ? void 0 : event._id) ? "Update" : "Create"} Event`,
            type: "submit",
            size: "normal",
            animation: true,
            onClick: (e) => {
              var _a2, _b2, _c;
              const __ = {};
              if ((_c = (_b2 = (_a2 = state == null ? void 0 : state.MonacoRef) == null ? void 0 : _a2.jsx) == null ? void 0 : _b2.current) == null ? void 0 : _c.getValue) {
                __.jsx = state.MonacoRef.jsx.current.getValue();
              }
              for (let k in state) {
                if (k !== "MonacoRef") {
                  __[k] = state[k];
                }
              }
              if (script) {
                delete __.jsx;
                __.img = "https://highmountainlabs.io/cdn/arclight/media/js.jpg";
              }
              const _obj = fns2 == null ? void 0 : fns2.calls;
              const n = (event == null ? void 0 : event._id) ? "updaterecords_event" : "createrecords_event";
              if (_obj && _obj[n]) {
                fns2.calls[n](
                  Object.assign(
                    {
                      _id: event == null ? void 0 : event._id,
                      nopanelchange: true,
                      type: script ? "script" : type2
                    },
                    __
                  )
                );
              }
            }
          }
        )
      ]
    }
  ) });
};
var manageevent_default = NewEvent;

// src/components/calendar/_body.tsx
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var Body3 = ({ eventId, fns: fns2, D, Element: Element2, event, events }) => {
  return /* @__PURE__ */ jsxs12(
    "div",
    {
      className: `arclight-flex arclight-h-full relative arclight-justify-center arclight-items-center`,
      children: [
        /* @__PURE__ */ jsxs12(
          "div",
          {
            className: `arclight-flex-col arclight-absolute arclight-top-12 arclight-right-2 arclight-space-y-1`,
            children: [
              /* @__PURE__ */ jsx18(
                button_default,
                {
                  className: ``,
                  idleIcon: "pen-to-square",
                  type: "button",
                  size: "normal",
                  animation: true,
                  onClick: () => {
                    fns2.setModal({
                      noescape: true,
                      body: () => /* @__PURE__ */ jsx18(
                        "div",
                        {
                          className: `arclight-flex arclight-flex-col arclight-justify-center arclight-align-middle arclight-w-full arclight-h-full arclight-rounded`,
                          children: /* @__PURE__ */ jsx18(
                            manageevent_default,
                            {
                              event,
                              fns: fns2,
                              D,
                              script: true,
                              type: "type"
                            }
                          )
                        }
                      ),
                      events,
                      bgImg: event.info.img
                    });
                  }
                }
              ),
              /* @__PURE__ */ jsx18(
                button_default,
                {
                  className: ``,
                  idleIcon: "trash-can",
                  type: "button",
                  size: "normal",
                  animation: true,
                  onClick: () => {
                    var _a;
                    if ((_a = fns2 == null ? void 0 : fns2.calls) == null ? void 0 : _a.deleterecords_event) {
                      fns2.calls.deleterecords_event({
                        search: { _id: eventId },
                        nopanelchange: true
                      });
                    }
                  }
                }
              )
            ]
          }
        ),
        Element2
      ]
    }
  );
};
var body_default = Body3;

// src/components/calendar/index.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var Calendar3 = ({
  D,
  fns: fns2,
  events,
  type: type2,
  defaultEventBgImg,
  script
}) => {
  const monthStart = moment2();
  const monthEnd = moment2();
  const [state, setState] = React10.useState({
    today: moment2(),
    monthStart: monthStart.startOf("month").day(),
    monthEnd: monthEnd.endOf("month").get("date"),
    offset: 0,
    events: void 0
  });
  const successRef = React10.useRef(D.serversuccess);
  const search = !script ? { $and: [{ type: type2 }, { type: { $ne: "script" } }] } : { type: "script" };
  const callModal = (obj) => {
    var _a;
    fns2.setModal({
      noescape: true,
      bgImg: obj.bgImg,
      events: (_a = obj.events) == null ? void 0 : _a.map((ev) => {
        if (ev.info) {
          ev.info.body = /* @__PURE__ */ jsx19(
            body_default,
            {
              event: ev,
              Element: ev.body,
              fns: fns2,
              D,
              eventId: ev._id
            }
          );
        }
        return ev;
      }).concat({
        startDate: moment2(),
        endDate: moment2(),
        info: {
          text: "",
          img: "https://titanesports.org:7000/static/media/tesbg.png",
          body: /* @__PURE__ */ jsx19(
            manageevent_default,
            {
              fns: fns2,
              D,
              script,
              type: type2,
              date: obj.date
            }
          )
        }
      }),
      body: () => {
        return /* @__PURE__ */ jsx19(
          "div",
          {
            className: `arclight-flex arclight-flex-col arclight-justify-center arclight-align-middle arclight-w-full arclight-h-full arclight-rounded`,
            children: obj.body
          }
        );
      }
    });
  };
  React10.useEffect(() => {
    var _a, _b, _c, _d;
    if (script && !((_b = (_a = D == null ? void 0 : D.getscripts) == null ? void 0 : _a.records) == null ? void 0 : _b.totalcount) && ((_c = fns2 == null ? void 0 : fns2.calls) == null ? void 0 : _c.getscripts)) {
      fns2.calls.getscripts();
    }
    if ((script || type2) && ((_d = fns2 == null ? void 0 : fns2.calls) == null ? void 0 : _d.getrecords_event)) {
      fns2.calls.getrecords_event({
        search
      });
    }
  }, []);
  React10.useEffect(() => {
    var _a, _b;
    if ((_b = (_a = D == null ? void 0 : D.getrecords_event) == null ? void 0 : _a.init) == null ? void 0 : _b.records) {
      setState(__spreadProps(__spreadValues({}, state), {
        events: D.getrecords_event.init.records.map((e) => ({
          _id: e._id,
          startDate: moment2(e.startDate),
          endDate: moment2(e.endDate),
          recurrence: e.recurrence,
          script: e.script,
          info: {
            text: e.title,
            img: e.img,
            body: e.jsx
          }
        }))
      }));
    }
    if (D.serversuccess && D.serversuccess !== successRef.current && D.getrecords_event) {
      fns2.calls.getrecords_event({
        search
      });
    }
    successRef.current = D.serversuccess;
  }, [D]);
  return (state == null ? void 0 : state.events) && (!script || (D == null ? void 0 : D.getscripts)) ? /* @__PURE__ */ jsx19("div", { className: `arclight-bg-background-secondary arclight-rounded`, children: /* @__PURE__ */ jsx19(
    largeview_default,
    {
      manageEvent: (date) => /* @__PURE__ */ jsx19(
        manageevent_default,
        {
          fns: fns2,
          D,
          script,
          type: type2,
          date
        }
      ),
      body: (eventId, Element2) => /* @__PURE__ */ jsx19(
        body_default,
        {
          event: state.events[0],
          Element: Element2,
          fns: fns2,
          D,
          eventId
        }
      ),
      defaultEventBgImg,
      moment: moment2,
      state,
      setState,
      callModal,
      events: state.events ? state.events : []
    }
  ) }) : null;
};
var calendar_default = Calendar3;

// src/components/listpanel/index.tsx
import React12 from "react";

// src/components/listpanel/styles.js
import styled15 from "styled-components";
var Container15 = styled15.div`
	height: 100%;
	min-height: ${(props) => props.mh}px;
`;
var styles_default15 = {
  Container: Container15
};

// src/components/listpanel/index.tsx
import { useMediaQuery } from "react-responsive";

// src/components/searchcontrols/index.tsx
import React11 from "react";

// src/components/searchcontrols/styles.js
import styled16 from "styled-components";
var Container16 = styled16.div`
	position: relative;
	height: 100%;
	${(props) => !props.picklist ? `min-height: 600px;` : ""}
`;
var Children = styled16.div`
	overflow-y: auto;
	overflow-x: hidden;
`;
var styles_default16 = {
  Container: Container16,
  Children
};

// src/components/searchcontrols/index.tsx
import { jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var SearchControls2 = ({
  minHeight,
  textField,
  controls,
  className,
  children,
  constrain,
  hot,
  pagination,
  btnActive,
  setBtnActive,
  search,
  picklist,
  D,
  fns: fns2
}) => {
  const [searchKey, setSearchKey] = React11.useState(
    controls && controls.length ? controls[0].key : null
  );
  const a = pagination ? pagination.skip * pagination.length + 1 : null;
  const b = pagination ? pagination.skip * pagination.length + pagination.length : null;
  const c = pagination ? pagination.totalcount : null;
  const bb = pagination ? b > c ? c : b : null;
  const NextLast = (props) => /* @__PURE__ */ jsxs13(React11.Fragment, { children: [
    /* @__PURE__ */ jsx20(
      button_default,
      {
        className: `arclight-hidden arclight-m-1 lg:arclight-block arclight-min-w-max ${pagination.skip > 0 ? "arclight-pointer-events-auto" : "arclight-opacity-30 arclight-pointer-events-none"}`,
        label: "Last",
        idleIcon: "arrow-left",
        type: "button",
        size: "normal",
        animation: true,
        onClick: (status) => pagination.onClick(-1)
      }
    ),
    /* @__PURE__ */ jsx20(
      button_default,
      {
        className: `arclight-block arclight-m-1 lg:arclight-hidden ${pagination.skip > 0 ? "arclight-pointer-events-auto" : "arclight-opacity-30 arclight-pointer-events-none"}`,
        label: props.isTop ? void 0 : "Last",
        idleIcon: "arrow-left",
        type: "button",
        size: "small",
        animation: true,
        onClick: (status) => pagination.onClick(-1)
      }
    ),
    /* @__PURE__ */ jsx20(
      button_default,
      {
        className: `arclight-hidden arclight-m-1 lg:arclight-block ${(pagination.skip + 1) * pagination.length < pagination.totalcount ? "arclight-pointer-events-auto" : "arclight-opacity-30 arclight-pointer-events-none"} arclight-min-w-max`,
        label: "Next",
        idleIcon: "arrow-right",
        type: "button",
        size: "normal",
        animation: true,
        onClick: (status) => pagination.onClick(1)
      }
    ),
    /* @__PURE__ */ jsx20(
      button_default,
      {
        className: `arclight-block arclight-m-1 lg:arclight-hidden ${(pagination.skip + 1) * pagination.length < pagination.totalcount ? "arclight-pointer-events-auto" : "arclight-opacity-30 arclight-pointer-events-none"}`,
        label: props.isTop ? void 0 : "Next",
        idleIcon: "arrow-right",
        type: "button",
        size: "small",
        animation: true,
        onClick: (status) => pagination.onClick(1)
      }
    )
  ] });
  return /* @__PURE__ */ jsxs13(
    styles_default16.Container,
    {
      picklist,
      className: `arclight-text-text-primary arclight-font-primary ${className}`,
      children: [
        textField ? /* @__PURE__ */ jsx20("div", { style: { textAlign: "left" }, children: /* @__PURE__ */ jsx20(
          textfield_default,
          {
            value: textField == null ? void 0 : textField.value,
            hot,
            onChange: (data) => {
              if (textField && textField.onChange)
                textField.onChange(data);
            },
            type: "text",
            label: textField.label,
            variant: "standard"
          },
          1
        ) }) : null,
        controls && search ? /* @__PURE__ */ jsx20(React11.Fragment, { children: /* @__PURE__ */ jsxs13("div", { className: `arclight-flex arclight-flex-row`, children: [
          /* @__PURE__ */ jsx20(
            button_default,
            {
              label: "Search",
              idleIcon: null,
              type: "button",
              size: "normal",
              animation: true,
              className: `arclight-hidden arclight-m-1 lg:arclight-block`,
              onClick: () => search ? search.onSubmit(
                searchKey ? searchKey : "name",
                textField == null ? void 0 : textField.value
              ) : null
            }
          ),
          /* @__PURE__ */ jsx20(
            button_default,
            {
              label: "Search",
              idleIcon: null,
              type: "button",
              size: "small",
              animation: true,
              className: `arclight-block arclight-m-1 lg:arclight-hidden`,
              onClick: () => search ? search.onSubmit(
                searchKey ? searchKey : "name",
                search.value
              ) : null
            }
          ),
          /* @__PURE__ */ jsx20(NextLast, { isTop: true }),
          /* @__PURE__ */ jsx20(
            "div",
            {
              className: `arclight-hidden arclight-flex-row arclight-justify-end arclight-w-full lg:arclight-flex arclight-space-x-3`,
              children: controls.map((b2, i) => {
                if (b2.type === "button")
                  return /* @__PURE__ */ jsx20(
                    button_default,
                    {
                      label: b2 == null ? void 0 : b2.text,
                      idleIcon: b2 == null ? void 0 : b2.icon,
                      type: "button",
                      size: "normal",
                      animation: true,
                      className: `arclight-m-1 ${i === btnActive ? "" : "arclight-opacity-30"}`,
                      onClick: () => {
                        if (setBtnActive)
                          setBtnActive(i);
                        setSearchKey(b2.key);
                      }
                    }
                  );
                if (b2.type === "picklist")
                  return /* @__PURE__ */ jsx20("div", { className: `arclight-w-96`, children: /* @__PURE__ */ jsx20(
                    picklist_default,
                    {
                      disallowNone: true,
                      span: true,
                      hot: true,
                      value: "test",
                      list: [],
                      onChange: (e) => {
                      },
                      keyname: "test",
                      id: void 0,
                      label: "model",
                      variant: "standard",
                      type: "test",
                      fns: fns2,
                      D
                    }
                  ) });
              })
            }
          ),
          /* @__PURE__ */ jsx20(
            "div",
            {
              className: `arclight-flex arclight-flex-row arclight-justify-end arclight-w-full lg:arclight-hidden arclight-space-x-3`,
              children: controls.map((b2, i) => {
                if (b2.type === "button")
                  return /* @__PURE__ */ jsx20(
                    button_default,
                    {
                      label: null,
                      idleIcon: b2.icon ? b2.icon : null,
                      type: "button",
                      size: "small",
                      animation: true,
                      className: `arclight-m-1 ${i === btnActive ? "" : "arclight-opacity-30"}`,
                      onClick: () => {
                        if (setBtnActive)
                          setBtnActive(i);
                        setSearchKey(b2.key);
                      }
                    }
                  );
                if (b2.type === "picklist")
                  return /* @__PURE__ */ jsx20("div", { className: `arclight-w-96` });
              })
            }
          )
        ] }) }) : null,
        pagination && pagination.totalcount || Array.isArray(children) && children.length > 1 || true ? /* @__PURE__ */ jsx20("div", { style: { minHeight: minHeight + 25 }, children: /* @__PURE__ */ jsx20(
          styles_default16.Children,
          {
            className: `arclight-relative arclight-z-0 arclight-h-full`,
            style: { height: `${!constrain ? `100%` : null}` },
            children
          }
        ) }) : /* @__PURE__ */ jsx20(
          "div",
          {
            className: `arclight-absolute arclight-top-1/2 arclight-left-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2`,
            children: "No Data"
          }
        ),
        /* @__PURE__ */ jsxs13(
          "div",
          {
            className: `arclight-absolute arclight-w-full arclight-pointer-events-none arclight-bottom-0`,
            style: {
              top: constrain ? "100%" : "125%",
              display: Array.isArray(children) && children.length > 1 ? "" : ""
            },
            children: [
              pagination && pagination.totalcount ? /* @__PURE__ */ jsx20(
                "div",
                {
                  className: `arclight-flex arclight-items-center arclight-justify-center`,
                  children: /* @__PURE__ */ jsx20(NextLast, {})
                }
              ) : null,
              pagination && pagination.totalcount ? /* @__PURE__ */ jsx20("div", { className: "arclight-text-center arclight-pointer-events-auto", children: /* @__PURE__ */ jsxs13(
                "div",
                {
                  className: "arclight-text-text-primary arclight-font-primary arclight-text-lg",
                  children: [
                    "Showing ",
                    a,
                    "-",
                    bb,
                    " of ",
                    c
                  ]
                }
              ) }) : null
            ]
          }
        )
      ]
    }
  );
};
var searchcontrols_default = SearchControls2;

// src/components/listpanel/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var mountAnim = (i) => ({
  anim: "fadeIn",
  duration: "0.30s",
  delay: `${0.01 * i}s`
});
var ListPanel = ({
  loadwatcher,
  autoSort,
  line,
  linesmall,
  constrain,
  fns: fns2,
  Request,
  card,
  D,
  controls
}) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const max = isTabletOrMobile ? 10 : 32;
  if (Request && Request.search && Request.search.limit && Request.search.limit > max)
    Request.search.limit = max;
  const sizeRef = React12.useRef(null);
  const [minHeight, setMinHeight] = React12.useState(0);
  const [loading, setLoading] = React12.useState(loadwatcher);
  const [sCards, setSCards] = React12.useState(/* @__PURE__ */ jsx21("div", {}));
  const [nPerRow, setNPerRow] = React12.useState(8);
  const [skip, setSkip] = React12.useState(0);
  const [btnActive, setBtnActive] = React12.useState(0);
  const [searchValue, setSearchValue] = React12.useState("");
  let cards = fns2.e(
    D,
    Request.script ? `D.${Request.script}.${Request.index}` : fns2.getCallType(Request.type, Request.index, Request.local)[0],
    {
      records: []
    }
  );
  if (!cards)
    cards = { records: [] };
  if (Array.isArray(cards.records))
    cards = cards.records.map((_) => card(_));
  else
    cards = Object.keys(cards.records).map((_) => card(_));
  if (autoSort)
    cards = cards.sort((a, b) => a.subText < b.subText ? -1 : 1);
  let row = [];
  const rows = [];
  const provideCard = (obj, i) => {
    return /* @__PURE__ */ jsx21(
      card_default,
      {
        managed: obj.managed,
        line,
        linesmall,
        mountAnim: mountAnim(i),
        index: skip * Request.search.limit + (i + 1),
        small: !line && !linesmall,
        hoverComponent: obj.hoverComponent,
        locked: obj.locked,
        bgImg: obj.img,
        bgVid: obj.vid,
        subText: obj.subtext,
        onClick: obj.onClick ? (
          //@ts-ignore
          () => obj.onClick ? obj.onClick() : null
        ) : null
      }
    );
  };
  if (!line && !linesmall) {
    for (let i = 0; i < cards.length; i++) {
      if (i % nPerRow === 0 && i > 0) {
        rows.push(
          /* @__PURE__ */ jsx21(
            "div",
            {
              className: "arclight-flex arclight-flex-row arclight-w-full arclight-items-center arclight-justify-center arclight-m-auto arclight-gap-4 arclight-my-4",
              children: row
            }
          )
        );
        row = [];
      }
      row.push(provideCard(cards[i], i));
    }
    if (row.length) {
      for (let i = row.length; i < nPerRow; i++) {
        row.push(/* @__PURE__ */ jsx21("div", { className: `arclight-w-40` }));
      }
      rows.push(
        /* @__PURE__ */ jsx21(
          "div",
          {
            className: "arclight-flex arclight-flex-row arclight-w-full arclight-items-center arclight-justify-center arclight-m-auto arclight-gap-4 arclight-my-4",
            children: row
          }
        )
      );
    }
  } else {
    for (let i = 0; i < cards.length; i++) {
      rows.push(provideCard(cards[i], i));
    }
  }
  const handleResize = () => {
    const _ = window.innerWidth;
    if (_ > 1280)
      setNPerRow(8);
    else if (_ > 1024)
      setNPerRow(8);
    else if (_ > 768)
      setNPerRow(4);
    else if (_ > 604)
      setNPerRow(3);
    else
      setNPerRow(3);
  };
  React12.useEffect(() => {
    var _a;
    if (!((_a = sizeRef == null ? void 0 : sizeRef.current) == null ? void 0 : _a.clientHeight))
      return;
    window.addEventListener("resize", handleResize);
    handleResize();
    setMinHeight(sizeRef.current.clientHeight - 25);
  }, []);
  React12.useEffect(() => {
    setTimeout(() => setLoading(false), 1);
    setSCards(rows);
  }, [D]);
  React12.useEffect(() => {
    setSkip(0);
    setBtnActive(0);
    if (fns2.calls && fns2.calls[Request.script || fns2.getCallType(Request.type, Request.local)[1]]) {
      fns2.calls[Request.script ? Request.script : fns2.getCallType(Request.type, Request.local)[1]]({
        index: Request.index,
        search: __spreadProps(__spreadValues({}, Request.search), { skip: 0 })
      });
    }
  }, [Request.type]);
  React12.useEffect(() => {
    if (loadwatcher) {
      setLoading(true);
      setSkip(0);
    }
  }, [loadwatcher]);
  return /* @__PURE__ */ jsx21(
    styles_default15.Container,
    {
      mh: Request.search.limit / nPerRow * 150,
      className: `${constrain ? `arclight-w-4/5 arclight-max-w-screen-xl arclight-m-auto` : `arclight-w-full arclight-flex arclight-flex-col arclight-flex-1`}`,
      children: !loading ? /* @__PURE__ */ jsx21("div", { ref: sizeRef, children: sCards ? /* @__PURE__ */ jsx21("div", { style: { height: "100%" }, children: /* @__PURE__ */ jsx21(
        searchcontrols_default,
        {
          D,
          fns: fns2,
          minHeight,
          hot: true,
          pagination: Object.assign(
            fns2.e(
              D,
              fns2.getCallType(
                Request.type,
                Request.index,
                Request.local
              )[0],
              {
                records: []
              }
            ),
            {
              skip,
              length: Request.search.limit ? Request.search.limit : void 0,
              onClick: (n) => {
                setSkip(skip + n);
                setSCards(/* @__PURE__ */ jsx21("div", {}));
                fns2.calls[Request.script ? Request.script : fns2.getCallType(Request.type, Request.local)[1]]({
                  index: Request.index,
                  search: __spreadProps(__spreadValues({}, Request.search), {
                    skip: (skip + n) * (Request.search.limit ? Request.search.limit : 1)
                  })
                });
              }
            }
          ),
          constrain,
          textField: {
            label: "Search",
            value: searchValue,
            onChange: (e) => setSearchValue(e.target.value)
          },
          btnActive,
          setBtnActive: (n) => setBtnActive(n),
          search: {
            onSubmit: (key, $regex) => {
              const _ = key && $regex ? { [key]: { $regex, $options: "i" } } : {};
              fns2.calls[Request.script ? Request.script : fns2.getCallType(Request.type, Request.local)[1]]({
                index: Request.index,
                search: __spreadValues(__spreadValues({}, Request.search), _)
              });
            }
          },
          controls,
          className: ``,
          children: sCards
        }
      ) }) : /* @__PURE__ */ jsx21("div", {}) }) : /* @__PURE__ */ jsx21(loader_default, { loading })
    }
  );
};
var listpanel_default = ListPanel;

// src/components/heropanel/index.tsx
import React13 from "react";

// src/components/heropanel/styles.js
import styled17 from "styled-components";
var Container17 = styled17.div`
  width: 100%;
`;
var styles_default17 = {
  Container: Container17
};

// src/components/minidiamondpicker/styles.js
import styled18 from "styled-components";
var Container18 = styled18.div``;
var styles_default18 = {
  Container: Container18
};

// src/components/minidiamondpicker/index.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var Checkbox2 = ({ count, cb, index, columns, images }) => {
  return /* @__PURE__ */ jsx22(styles_default18.Container, { className: `arclight-h-${images ? `24` : `12`}`, children: /* @__PURE__ */ jsx22("div", { className: `arclight-relative`, children: /* @__PURE__ */ jsx22(
    "div",
    {
      className: `arclight-absolute arclight-left-1/2 -arclight-translate-x-1/2 -arclight-bottom-${images ? `24` : `12`}`,
      children: /* @__PURE__ */ jsx22(
        "div",
        {
          className: `arclight-flex arclight-flex-row arclight-justify-center arclight-space-x-${!images ? `10` : `5`} arclight-h-${images ? `24` : `11`}`,
          children: (() => {
            const _ = [];
            for (let i = 0; i < Math.ceil(count / columns); i++)
              _.push(
                images ? /* @__PURE__ */ jsx22(
                  "img",
                  {
                    onClick: () => cb ? cb(i) : null,
                    src: images[i],
                    className: `${index === i ? "arclight-w-16 arclight-h-16 arclight-opacity-100 arclight-border-[1px]" : "arclight-w-14 arclight-h-14 arclight-opacity-30 arclight-border-0"} arclight-border-background-tertiary arclight-object-cover arclight-cursor-pointer arclight-transition-all arclight-duration-200`,
                    style: { borderRadius: `50%` }
                  }
                ) : /* @__PURE__ */ jsx22(
                  "div",
                  {
                    onClick: () => cb ? cb(i) : null,
                    className: `arclight-bg-background-quarternary ${index === i ? "arclight-w-8 arclight-h-8 arclight-opacity-100 arclight-border-2 arclight-rotate-45" : "arclight-w-6 arclight-h-6 arclight-opacity-30 arclight-border-0 -arclight-rotate-45"} arclight-border-background-tertiary arclight-cursor-pointer arclight-transition-all arclight-duration-200`
                  }
                )
              );
            return _;
          })()
        }
      )
    }
  ) }) });
};
var minidiamondpicker_default = Checkbox2;

// src/components/heropanel/index.tsx
import { jsx as jsx23, jsxs as jsxs14 } from "react/jsx-runtime";
var HeroPanel = React13.memo(
  ({
    cards,
    autoSort,
    small,
    title,
    left,
    rows,
    pageCallback,
    index,
    single
  }) => {
    const MAX_C = single ? 1 : 3;
    const CL = cards.length;
    rows = single ? 1 : rows;
    if (rows && index)
      cards = cards.filter(
        (c, i) => i > index * ((rows ? rows : 1) * MAX_C) - 1
      );
    const className = `arclight-flex arclight-flex-col lg:arclight-flex-row arclight-w-full arclight-items-center arclight-justify-${left ? "start" : "center"} arclight-m-auto arclight-gap-7 lg:arclight-gap-7 xl:arclight-gap-7 arclight-my-7`;
    const [hItem, setHItem] = React13.useState(-1);
    if (autoSort)
      cards = cards.sort(
        (a, b) => a.subText && b.subText && a.subText < b.subText ? -1 : 1
      );
    let row = [];
    const _rows = [];
    _rows.push(
      /* @__PURE__ */ jsx23("div", { className, children: /* @__PURE__ */ jsx23("div", { className: "arclight-text-text-primary arclight-font-primary arclight-text-3xl arclight-text-start", children: title }) })
    );
    for (let i = 0; i < (rows ? rows * MAX_C : cards.length); i++) {
      if (i % MAX_C === 0 && i > 0) {
        _rows.push(/* @__PURE__ */ jsx23("div", { className, children: row }));
        row = [];
      }
      if (cards[i])
        row.push(
          /* @__PURE__ */ jsx23(
            card_default,
            {
              hover: {
                onMouseEnter: () => {
                  if (cards[i].onHover)
                    cards[i].onHover();
                  setHItem(i);
                },
                onMouseLeave: () => {
                  if (cards[i].onHover)
                    cards[i].onHoverLeave();
                  setHItem(-1);
                }
              },
              active: cards[i].active !== null && cards[i].active !== void 0 ? cards[i].active || hItem === i : null,
              medium: small,
              hoverComponent: cards[i].hoverComponent,
              locked: cards[i].locked,
              bgImg: cards[i].bgImg,
              subText: cards[i].subText,
              bodyComponent: cards[i].bodyComponent,
              onClick: cards[i].onClick ? (
                //@ts-ignore
                () => cards[i].onClick ? cards[i].onClick() : null
              ) : null
            }
          )
        );
    }
    if (row.length > 0)
      _rows.push(/* @__PURE__ */ jsx23("div", { className, children: row }));
    return /* @__PURE__ */ jsxs14(styles_default17.Container, { className: "lg:arclight-px-20", children: [
      _rows,
      rows && CL > MAX_C ? /* @__PURE__ */ jsx23(
        minidiamondpicker_default,
        {
          index,
          columns: MAX_C,
          count: CL,
          cb: pageCallback
        }
      ) : null
    ] });
  }
);
var heropanel_default = HeroPanel;

// src/components/articlepage/index.tsx
import React17 from "react";

// src/components/articlepage/styles.js
import styled19 from "styled-components";
var Container19 = styled19.div``;
var Body4 = styled19.div``;
var Nopage = styled19.img`
	width: 100%;
	object-fit: cover;
`;
var styles_default19 = {
  Container: Container19,
  Nopage,
  Body: Body4
};

// src/components/fadedivider/index.tsx
import React14 from "react";

// src/components/fadedivider/styles.js
import styled20 from "styled-components";
var Container20 = styled20.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  height: 650px;
  @media only screen and (max-width: 1024px) {
    height: 300px;
  }
`;
var Divider = styled20.div`
  position: absolute;
  top: -10%;
  left: -10%;
  width: 125%;
  height: 100%;
  transform: rotate(${(props) => props.rotation}deg);
  transform-origin: bottom right;
  overflow: hidden;
  & img {
    transform: rotate(-${(props) => props.rotation}deg);
  }
`;
var BackgroundFade = styled20.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;
var BackgroundImgFade = styled20.img`
  object-fit: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 1)),
    to(rgba(0, 0, 0, 0))
  );
`;
var styles_default20 = {
  Container: Container20,
  BackgroundImgFade,
  Divider,
  BackgroundFade
};

// src/components/fadedivider/index.tsx
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var FadeDivider = ({ ruby, fadeOpacity, img }) => {
  const imgs = [];
  if (img) {
    for (let i = 0; i < 3; i++) {
      imgs.push(
        /* @__PURE__ */ jsx24(
          styles_default20.BackgroundImgFade,
          {
            src: img,
            className: ``,
            style: { opacity: fadeOpacity }
          }
        )
      );
    }
  }
  return /* @__PURE__ */ jsxs15(styles_default20.Container, { children: [
    img ? /* @__PURE__ */ jsx24(React14.Fragment, { children: imgs }) : /* @__PURE__ */ jsx24(
      styles_default20.BackgroundFade,
      {
        className: `arclight-bg-gradient-to-b arclight-from-background-tertiary arclight-to arclight-to-transparent`,
        style: { opacity: fadeOpacity }
      }
    ),
    ruby ? /* @__PURE__ */ jsx24(
      "img",
      {
        src: ruby,
        className: `arclight-absolute arclight-bottom-6 lg:arclight-bottom-24 arclight-left-1/2 -arclight-translate-x-1/2 arclight-w-44 lg:arclight-w-72`
      }
    ) : null
  ] });
};
var fadedivider_default = FadeDivider;

// src/components/googledoc/index.tsx
import React15 from "react";

// src/components/googledoc/styles.js
import styled21 from "styled-components";
var Container21 = styled21.div`
	text-shadow: none;
`;
var Body5 = styled21.div`
	background-color: white;
`;
var Document = styled21.iframe`
	margin: auto;
`;
var Author = styled21.div`
	text-align: right;
	font-family: inherit;
`;
var styles_default21 = {
  Container: Container21,
  Document,
  Body: Body5,
  Author
};

// src/components/googledoc/index.tsx
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var GoogleDoc = ({ url, author }) => {
  const docref = React15.useRef(null);
  const [docImport, setDocImport] = React15.useState(null);
  React15.useEffect(() => {
    (() => __async(void 0, null, function* () {
      const _ = yield fetch(url).then((res) => res.text()).then((__html) => /* @__PURE__ */ jsx25(
        "div",
        {
          ref: docref,
          dangerouslySetInnerHTML: {
            __html
          }
        }
      ));
      setDocImport(_);
    }))();
  }, [url]);
  React15.useEffect(() => {
    if (docref && docref.current) {
      setDocImport(
        /* @__PURE__ */ jsx25(
          styles_default21.Document,
          {
            scrolling: "no",
            frameBorder: "0",
            width: "817px",
            height: docref.current.scrollHeight - docref.current.offsetTop,
            src: url
          }
        )
      );
    }
  }, [docImport]);
  return /* @__PURE__ */ jsx25(styles_default21.Container, { className: "", children: /* @__PURE__ */ jsxs16(styles_default21.Body, { className: `arclight-m-10`, children: [
    docImport,
    author ? /* @__PURE__ */ jsx25(styles_default21.Author, { className: `arclight-p-5 arclight-text-xl`, children: author.split("(M) ")[1] }) : null
  ] }) });
};
var googledoc_default = GoogleDoc;

// src/components/quill/index.tsx
import React16 from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// src/components/quill/styles.js
import styled22 from "styled-components";
var Container22 = styled22.div`
  background-color: white;
  color: black;
  text-shadow: -0px -0px 0 #000, 0px -0px 0 #000, -0px 0px 0 #000,
    0px 0px 0 #000;
`;
var styles_default22 = {
  Container: Container22
};

// src/components/quill/index.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var Quill = ({ value, onChange, hot }) => {
  const quillref = React16.useRef(null);
  return /* @__PURE__ */ jsx26(
    styles_default22.Container,
    {
      onBlur: () => {
        if (!hot) {
          onChange(quillref.current.value);
        }
      },
      children: /* @__PURE__ */ jsx26(
        ReactQuill,
        {
          ref: quillref,
          theme: "snow",
          value,
          onChange: (value2) => hot ? onChange(value2) : void 0
        }
      )
    }
  );
};
var quill_default = Quill;

// src/components/articlepage/index.tsx
import moment3 from "moment";
import { jsx as jsx27, jsxs as jsxs17 } from "react/jsx-runtime";
var ArticlePage = ({
  init,
  className,
  fns: fns2,
  D,
  bannerImg,
  ruby,
  googledoc,
  nopage,
  cb,
  preview,
  setPreview,
  edit
}) => {
  const blockTemplate = (index) => ({
    title: `Block Title ${index + 1}`,
    value: ""
  });
  const [title, setTitle2] = React17.useState("");
  const [previewMode, setPreviewMode] = React17.useState(false);
  const [authorName, setAuthorName] = React17.useState(null);
  const [img, setImg] = React17.useState("");
  const [contentBlocks, setContentBlocks] = React17.useState({
    0: blockTemplate(0)
  });
  const manageBlocks = (contentBlocks2) => {
    if (cb && init) {
      return cb(__spreadProps(__spreadValues({}, init), {
        contentBlocks: contentBlocks2
      }));
    } else {
      return setContentBlocks(contentBlocks2);
    }
  };
  const Bttn2 = (props) => /* @__PURE__ */ jsx27(
    button_default,
    {
      span: props.span,
      label: props.label,
      type: "button",
      size: "md",
      animation: true,
      disabled: false,
      block: false,
      rounded: false,
      square: false,
      isIconButton: false,
      onClick: (status) => props.fn()
    }
  );
  const Builder = (props) => {
    return /* @__PURE__ */ jsxs17("div", { className: `arclight-flex-col arclight-space-y-5`, children: [
      /* @__PURE__ */ jsx27(
        textfield_default,
        {
          span: true,
          defaultValue: init ? init.title : title,
          label: "Title",
          onChange: (input) => {
            if (cb && init) {
              return cb(__spreadProps(__spreadValues({}, init), {
                title: input.target.value
              }));
            } else {
              return setTitle2(input.target.value);
            }
          },
          type: "text",
          variant: "standard"
        },
        0
      ),
      /* @__PURE__ */ jsx27(
        textfield_default,
        {
          span: true,
          defaultValue: init ? init.img : img,
          label: "Image Url",
          onChange: (input) => {
            if (cb && init) {
              return cb(__spreadProps(__spreadValues({}, init), {
                img: input.target.value
              }));
            } else {
              return setImg(input.target.value);
            }
          },
          type: "text",
          variant: "standard"
        },
        0
      ),
      Object.keys(init ? init.contentBlocks : contentBlocks).map(
        (k, i) => {
          return /* @__PURE__ */ jsxs17("div", { className: `arclight-flex-col arclight-space-y-3`, children: [
            /* @__PURE__ */ jsx27(
              textfield_default,
              {
                span: true,
                defaultValue: (init ? init.contentBlocks : contentBlocks)[k].title,
                label: void 0,
                onChange: (input) => {
                  if (cb && init) {
                    const _ = init ? init.contentBlocks : contentBlocks;
                    _[k].title = input.target.value;
                    manageBlocks(_);
                  } else {
                  }
                },
                type: "text",
                variant: "standard"
              },
              0
            ),
            /* @__PURE__ */ jsx27(
              quill_default,
              {
                value: (init ? init.contentBlocks : contentBlocks)[k].value,
                onChange: (value) => {
                  if (cb && init) {
                    const _ = init ? init.contentBlocks : contentBlocks;
                    _[k].value = value;
                    manageBlocks(_);
                  } else {
                  }
                }
              }
            ),
            /* @__PURE__ */ jsx27(
              "div",
              {
                className: `arclight-flex arclight-space-x-3 arclight-justify-end`,
                children: [
                  {
                    label: "Create Block",
                    fn: () => {
                      const _ = init ? init.contentBlocks : contentBlocks;
                      const ii = (() => {
                        for (let i2 = 0; i2 < Object.keys(_).length + 1; i2++) {
                          if (!_[i2])
                            return i2;
                        }
                        return 0;
                      })();
                      _[ii] = blockTemplate(ii);
                      manageBlocks(_);
                    }
                  },
                  {
                    label: "Delete Block",
                    fn: () => {
                      const _ = init ? init.contentBlocks : contentBlocks;
                      delete _[i];
                      manageBlocks(_);
                    }
                  }
                ].filter(
                  (c) => c.label !== "Delete Block" || Object.keys(init ? init.contentBlocks : contentBlocks).length > 1
                ).map((c) => /* @__PURE__ */ jsx27(Bttn2, __spreadValues({}, c)))
              }
            )
          ] });
        }
      ),
      authorName && (init == null ? void 0 : init.author) && false ? /* @__PURE__ */ jsx27("div", { className: `arclight-text-left arclight-text-xl`, children: authorName }) : null
    ] });
  };
  const Previewer = (props) => init ? /* @__PURE__ */ jsx27("div", { className: `arclight-flex-col arclight-space-y-5`, children: /* @__PURE__ */ jsxs17(
    "div",
    {
      className: `arclight-bg-slate-100 arclight-text-black arclight-flex-col arclight-space-y-14 arclight-text-left arclight-p-10`,
      style: { textShadow: "none" },
      children: [
        /* @__PURE__ */ jsx27("div", { className: `arclight-text-center arclight-text-3xl`, children: init.title }),
        /* @__PURE__ */ jsx27("div", { className: `arclight-flex-col arclight-space-y-5`, children: Object.values(init.contentBlocks).map((block) => /* @__PURE__ */ jsx27(
          "div",
          {
            dangerouslySetInnerHTML: {
              __html: block.value.replace(/&lt;/g, "<")
            }
          }
        )) }),
        /* @__PURE__ */ jsxs17("div", { className: `arclight-text-right arclight-flex-col`, children: [
          authorName ? /* @__PURE__ */ jsx27("div", { className: `arclight-text-lg`, children: authorName }) : null,
          (init == null ? void 0 : init.createddate) ? /* @__PURE__ */ jsx27("div", { className: `arclight-text-sm`, children: moment3(init.createddate).format("MMM Do, YYYY").toString() }) : null
        ] })
      ]
    }
  ) }) : null;
  React17.useEffect(() => {
    var _a;
    if (authorName)
      return;
    if (((_a = fns2 == null ? void 0 : fns2.calls) == null ? void 0 : _a.getrecords_user) && (init == null ? void 0 : init.author)) {
      fns2.calls.getrecords_user({
        search: {
          _id: init.author
        }
      });
    }
  }, [init]);
  React17.useEffect(() => {
    var _a, _b;
    if (authorName)
      return;
    if ((_b = (_a = D == null ? void 0 : D.getrecords_user) == null ? void 0 : _a.authorvalue) == null ? void 0 : _b.records) {
      setAuthorName(D.getrecords_user.authorvalue.records[0].username);
    }
  }, [D]);
  return /* @__PURE__ */ jsxs17(styles_default19.Container, { className, children: [
    googledoc ? /* @__PURE__ */ jsx27(fadedivider_default, { img: bannerImg, ruby }) : null,
    /* @__PURE__ */ jsxs17(styles_default19.Body, { children: [
      googledoc ? /* @__PURE__ */ jsx27(googledoc_default, { url: googledoc, author: void 0 }) : preview || previewMode || !edit ? /* @__PURE__ */ jsx27(Previewer, {}) : /* @__PURE__ */ jsx27(Builder, {}),
      edit ? /* @__PURE__ */ jsx27("div", { className: `arclight-mt-5`, children: /* @__PURE__ */ jsx27(
        Bttn2,
        {
          span: true,
          label: !previewMode ? "Preview Mode" : "Edit Mode",
          fn: () => setPreview ? setPreview(!preview) : setPreviewMode(!previewMode)
        }
      ) }) : null
    ] })
  ] });
};
var articlepage_default = ArticlePage;

// src/components/application/index.tsx
import React19 from "react";

// src/components/application/styles.js
import styled23 from "styled-components";
var Container23 = styled23.div`
	${(props) => mountHandler(props)}
`;
var Body6 = styled23.div`
	min-height: 100vh;
	background-color: white;
	border-radius: 3px;
	text-align: center;
	position: relative;
	overflow: hidden;
`;
var BackgroundImage = styled23.div`
	top: 0;
	left: 0;
	position: absolute;
	opacity: 1;
	width: 100%;
`;
var Nopage2 = styled23.img`
	width: 100%;
	object-fit: cover;
`;
var TitleImg = styled23.div`
	overflow: hidden;
	border-radius: 50%;
	margin: auto;
	& img {
		height: 100%;
		object-fit: cover;
	}
`;
var Title = styled23.div``;
var Text = styled23.div``;
var Link = styled23.a`
	color: blue;
	border-bottom: 1px solid blue;
`;
var Description = styled23.div`
	text-shadow: none;
	text-align: left;
`;
var Input = styled23.div`
	text-shadow: none;
`;
var Controls = styled23.div`
	text-align: left;
`;
var styles_default23 = {
  Container: Container23,
  Link,
  Text,
  Description,
  Input,
  Controls,
  Title,
  TitleImg,
  Nopage: Nopage2,
  Body: Body6,
  BackgroundImage
};

// src/components/checkboxgroup/index.tsx
import React18 from "react";

// src/components/checkboxgroup/styles.js
import styled24 from "styled-components";
var Container24 = styled24.div``;
var styles_default24 = {
  Container: Container24
};

// src/components/checkboxgroup/index.tsx
import { jsx as jsx28, jsxs as jsxs18 } from "react/jsx-runtime";
var CheckboxGroup = ({ values, onChange, label }) => {
  const [state, setState] = React18.useState({});
  React18.useEffect(() => {
    const _ = {};
    values.map(
      (v) => _[v.label] = v.value
    );
    setState(_);
  }, []);
  return /* @__PURE__ */ jsxs18(styles_default24.Container, { children: [
    label ? /* @__PURE__ */ jsx28("div", { className: `arclight-font-primary arclight-text-md`, children: label }) : null,
    /* @__PURE__ */ jsx28("div", { className: `arclight-flex arclight-flex-wrap`, children: values.map((value) => /* @__PURE__ */ jsx28(
      checkbox_default,
      {
        label: value.label,
        value: state[value.label],
        onChange: (e) => {
          if (onChange)
            onChange({ label: value.label, value: !e });
          setState((s) => __spreadProps(__spreadValues({}, s), { [value.label]: !e }));
        }
      }
    )) })
  ] });
};
var checkboxgroup_default = CheckboxGroup;

// src/components/application/index.tsx
import { jsx as jsx29, jsxs as jsxs19 } from "react/jsx-runtime";
var Application = ({ className, fns: fns2, D, form, locked }) => {
  const [state, setState] = React19.useState(null);
  const init = () => {
    if (!form)
      return;
    const _state = {};
    form.controls.map(
      (control, i) => _state[`${control.type}_${i}`] = {
        [control.values ? `values` : `value`]: control.value ? control.value : control.values ? control.values : void 0,
        required: control.required
      }
    );
    setState(_state);
  };
  React19.useEffect(init, [form]);
  return form && state ? /* @__PURE__ */ jsx29(
    styles_default23.Container,
    {
      className,
      mountAnim: {
        anim: "fadeIn",
        duration: "0.6s",
        delay: `0s`
      },
      children: /* @__PURE__ */ jsxs19(styles_default23.Body, { className: `arclight-max-w-6xl arclight-m-auto`, children: [
        form.backgroundimage ? /* @__PURE__ */ jsx29(styles_default23.BackgroundImage, { children: /* @__PURE__ */ jsx29(fadedivider_default, { img: form.backgroundimage }) }) : null,
        /* @__PURE__ */ jsxs19("div", { className: `arclight-relative arclight-p-3 md:arclight-p-10`, children: [
          /* @__PURE__ */ jsx29(
            styles_default23.TitleImg,
            {
              className: `arclight-w-96 arclight-h-96 ${form.titleimage ? `arclight-border-0 arclight-border-black` : ""}`,
              children: form.titleimage ? /* @__PURE__ */ jsx29("img", { src: form.titleimage }) : null
            }
          ),
          /* @__PURE__ */ jsx29(
            styles_default23.Title,
            {
              className: `arclight-text-text-primary arclight-font-primary arclight-text-6xl arclight-m-10`,
              children: form.title
            }
          ),
          /* @__PURE__ */ jsx29(
            styles_default23.Description,
            {
              className: `arclight-text-black arclight-font-primary arclight-text-2xl arclight-m-10`,
              children: form.description
            }
          ),
          /* @__PURE__ */ jsxs19(
            styles_default23.Input,
            {
              className: `arclight-text-black arclight-font-primary arclight-text-1xl arclight-m-10`,
              children: [
                /* @__PURE__ */ jsx29(styles_default23.Controls, { className: `arclight-mb-10`, children: form.controls ? form.controls.map(
                  (control, i) => {
                    if (state[`${control.type}_${i}`]) {
                      if (control.type === "textfield")
                        return /* @__PURE__ */ jsx29(
                          textfield_default,
                          {
                            span: true,
                            hot: true,
                            value: state[`${control.type}_${i}`].value,
                            onChange: (e) => {
                              if (locked)
                                return;
                              setState((s) => __spreadProps(__spreadValues({}, s), {
                                [`${control.type}_${i}`]: __spreadProps(__spreadValues({}, state[`${control.type}_${i}`]), {
                                  value: e.target.value
                                })
                              }));
                            },
                            type: "text",
                            label: `${control.label ? control.label : "Your Response"}${control.required ? ` (Required)` : ""}`,
                            variant: "standard"
                          },
                          i
                        );
                      else if (control.type === "textarea")
                        return /* @__PURE__ */ jsx29(
                          textfield_default,
                          {
                            multiline: true,
                            rows: 6,
                            span: true,
                            hot: true,
                            value: state[`${control.type}_${i}`].value,
                            onChange: (e) => {
                              if (locked)
                                return;
                              setState((s) => __spreadProps(__spreadValues({}, s), {
                                [`${control.type}_${i}`]: __spreadProps(__spreadValues({}, state[`${control.type}_${i}`]), {
                                  value: e.target.value
                                })
                              }));
                            },
                            type: "text",
                            label: `${control.label ? control.label : "Your Response"}${control.required ? ` (Required)` : ""}`,
                            variant: "standard"
                          },
                          i
                        );
                      else if (control.type === "ul")
                        return /* @__PURE__ */ jsx29("ul", { children: control.values.map((c) => /* @__PURE__ */ jsxs19("li", { children: [
                          "\u2022 ",
                          c
                        ] })) });
                      else if (control.type === "text")
                        return /* @__PURE__ */ jsx29(
                          styles_default23.Text,
                          {
                            className: `arclight-text-black arclight-font-primary`,
                            children: control.value
                          }
                        );
                      else if (control.type === "divide")
                        return /* @__PURE__ */ jsx29("div", { className: `arclight-mt-5 arclight-mb-5` });
                      else if (control.type === "link")
                        return /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29(
                          styles_default23.Link,
                          {
                            className: `arclight-font-primary`,
                            href: control.href,
                            target: "_blank",
                            children: control.value
                          }
                        ) });
                      else if (control.type === "picklist")
                        return /* @__PURE__ */ jsx29(
                          picklist_default,
                          {
                            keyname: i,
                            D,
                            fns: fns2,
                            disallowNone: false,
                            multiple: false,
                            span: true,
                            hot: true,
                            value: state[`${control.type}_${i}`].value,
                            unlinked: true,
                            list: control.values.map((value) => ({
                              text: value,
                              value
                            })),
                            onChange: (e) => {
                              if (locked)
                                return;
                              setState((s) => __spreadProps(__spreadValues({}, s), {
                                [`${control.type}_${i}`]: __spreadProps(__spreadValues({}, state[`${control.type}_${i}`]), {
                                  value: e.target.value
                                })
                              }));
                            },
                            label: `${control.label ? control.label : "Your Response"}${control.required ? ` (Required)` : ""}`,
                            variant: "standard"
                          },
                          i
                        );
                      else if (control.type === "checkbox")
                        return /* @__PURE__ */ jsx29(
                          checkbox_default,
                          {
                            value: false,
                            onChange: (s) => {
                              if (locked)
                                return;
                              return null;
                            }
                          }
                        );
                      else if (control.type === "checkboxgroup")
                        return /* @__PURE__ */ jsx29(
                          checkboxgroup_default,
                          {
                            label: "(Required)",
                            values: control.values,
                            onChange: (e) => {
                              if (locked)
                                return;
                              const el = state[`${control.type}_${i}`].values.find(
                                (checkbox) => checkbox.label === e.label
                              );
                              if (!el)
                                return;
                              setState((s) => __spreadProps(__spreadValues({}, s), {
                                [`${control.type}_${i}`]: __spreadProps(__spreadValues({}, state[`${control.type}_${i}`]), {
                                  values: state[`${control.type}_${i}`].values.map(
                                    (_el) => _el.label === el.label ? __spreadProps(__spreadValues({}, _el), { value: !el.value }) : _el
                                  )
                                })
                              }));
                            }
                          }
                        );
                    }
                  }
                ) : null }),
                !locked ? /* @__PURE__ */ jsx29(
                  button_default,
                  {
                    span: true,
                    label: "Submit",
                    type: "button",
                    size: "md",
                    animation: true,
                    disabled: false,
                    block: false,
                    rounded: false,
                    square: false,
                    isIconButton: false,
                    onClick: (status) => fns2 && fns2.calls && fns2.calls.createforms ? fns2.calls.createforms(__spreadProps(__spreadValues({}, state), {
                      __template: form.__template
                    })) : null
                  }
                ) : null
              ]
            }
          )
        ] })
      ] })
    }
  ) : /* @__PURE__ */ jsx29("div", { className: `arclight-h-96` });
};
var application_default = Application;

// src/components/admin/flexpanel/components/textfield.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var textfield_default2 = (obj) => {
  return obj.state._id && obj.state[obj.c.label] ? /* @__PURE__ */ jsx30(
    "div",
    {
      className: false ? `arclight-opacity-50 arclight-pointer-events-none` : ``,
      children: /* @__PURE__ */ jsx30(
        obj.TextField,
        {
          span: true,
          hot: true,
          defaultValue: obj.state[obj.c.label] !== null && obj.state[obj.c.label] !== void 0 ? obj.state[obj.c.label] : "",
          onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
            [obj.c.label]: e.target.value
          })),
          type: "text",
          label: obj.c.label,
          variant: "standard"
        },
        obj.state._id
      )
    }
  ) : /* @__PURE__ */ jsx30(
    "div",
    {
      className: false ? `arclight-opacity-50 arclight-pointer-events-none` : ``,
      children: /* @__PURE__ */ jsx30(
        obj.TextField,
        {
          span: true,
          hot: true,
          defaultValue: null,
          onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
            [obj.c.label]: e.target.value
          })),
          type: "text",
          label: obj.c.label,
          variant: "standard"
        },
        obj.i
      )
    }
  );
};

// src/components/admin/flexpanel/components/articlepage.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var articlepage_default2 = (obj) => {
  var _a, _b, _c;
  if (!obj.state[obj.c.label]) {
    if (((_a = obj == null ? void 0 : obj.state) == null ? void 0 : _a._id) && ((_c = (_b = obj == null ? void 0 : obj.D) == null ? void 0 : _b.getrecords_article) == null ? void 0 : _c.init)) {
      obj.state[obj.c.label] = obj.D.getrecords_article.init.records.find(
        (r) => r._id === obj.state._id
      );
    } else {
      obj.state[obj.c.label] = {
        title: "New Article Title",
        img: "https://highmountainlabs.io/cdn/arclight/media/article.jpg",
        contentBlocks: {
          0: {
            title: "Block Title 1",
            value: ""
          }
        }
      };
    }
  }
  return /* @__PURE__ */ jsx31("div", { className: ``, children: /* @__PURE__ */ jsx31(
    obj.ArticlePage,
    {
      edit: true,
      init: obj.state[obj.c.label],
      nopage: obj.D.nopage,
      googledoc: null,
      author: null,
      fns: obj.fns,
      D: obj.D,
      bannerImg: null,
      className: `-mt-24 lg:-mt-44`,
      ruby: null,
      cb: (st) => {
        obj.setState((_) => __spreadProps(__spreadValues({}, _), {
          [obj.c.label]: st
        }));
      }
    }
  ) });
};

// src/components/admin/flexpanel/components/dateselector.tsx
import { jsx as jsx32, jsxs as jsxs20 } from "react/jsx-runtime";
var dateselector_default2 = (c, i, DateSelector2, state, setState) => {
  return /* @__PURE__ */ jsxs20("div", { className: `arclight-text-left`, children: [
    /* @__PURE__ */ jsx32("div", { className: `arclight-text-xs`, children: c.label }),
    /* @__PURE__ */ jsx32(
      DateSelector2,
      {
        onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), {
          [c.label]: e.target.value
        }))
      }
    )
  ] });
};

// src/components/admin/flexpanel/components/dynamicfield.tsx
import { jsx as jsx33, jsxs as jsxs21 } from "react/jsx-runtime";
var dynamicfield_default = (obj) => {
  return obj.state && obj.state[obj.c.label] && typeof obj.state[obj.c.label] === "object" ? /* @__PURE__ */ jsxs21(
    "div",
    {
      className: `arclight-border-background-quarternary arclight-border-l-2 arclight-p-4 arclight-flex-row arclight-justify-start arclight-space-y-4`,
      children: [
        /* @__PURE__ */ jsx33(
          obj.TextField,
          {
            span: true,
            hot: true,
            defaultValue: obj.state[obj.c.label].key,
            onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                key: e.target.value
              })
            })),
            type: "text",
            label: "key",
            variant: "standard"
          },
          obj.i
        ),
        /* @__PURE__ */ jsx33(
          obj.PickList,
          {
            unlinked: true,
            disallowNone: true,
            span: true,
            hot: true,
            value: obj.state[obj.c.label].type,
            list: [
              { value: "String", text: "String" },
              { value: "Number", text: "Number" },
              { value: "Boolean", text: "Boolean" },
              { value: "Array", text: "Array" },
              { value: "Date", text: "Date" },
              { value: "JSON", text: "JSON" }
            ].sort((a, b) => a.text < b.text ? -1 : 1),
            onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                type: e.target.value,
                lookup: null
              })
            })),
            label: "type",
            variant: "standard"
          },
          obj.i
        ),
        obj.state[obj.c.label].lookup && obj.D.getdatamodels && obj.D.getdatamodels.records ? /* @__PURE__ */ jsx33(
          obj.PickList,
          {
            disallowNone: true,
            span: true,
            hot: true,
            value: obj.state[obj.c.label].lookup && obj.D.getdatamodels.records.find(
              (R) => R._type === obj.state[obj.c.label].lookup
            ) ? obj.state[obj.c.label].lookup : void 0,
            list: obj.D.getdatamodels.records.map((el) => ({
              text: el._type,
              value: el._type,
              _id: el._id
            })),
            onChange: (e) => {
              return obj.setState((_) => __spreadProps(__spreadValues({}, _), {
                [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                  lookup: e.target.value
                })
              }));
            },
            keyname: obj.state[obj.c.label].key,
            id: (() => {
              const _ = obj.D.getdatamodels.records.find(
                (el) => el._type === obj.state[obj.c.label].lookup
              );
              if (_)
                return _._id;
            })(),
            label: "model",
            variant: "standard",
            type: obj.state[obj.c.label].lookup,
            fns: obj.fns,
            D: obj.D
          }
        ) : null,
        obj.state[obj.c.label].lookup ? /* @__PURE__ */ jsx33(
          obj.TextField,
          {
            span: true,
            hot: true,
            defaultValue: obj.state[obj.c.label].adminlookup,
            onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                adminlookup: e.target.value
              })
            })),
            type: "text",
            label: "adminlookup",
            variant: "standard"
          },
          obj.i
        ) : null,
        /* @__PURE__ */ jsxs21(
          "div",
          {
            className: `arclight-text-text-primary arclight-font-primary arclight-text-base arclight-flex arclight-justify-start`,
            children: [
              /* @__PURE__ */ jsx33(
                "div",
                {
                  className: `arclight-m-auto ${obj.state[obj.c.label] && obj.state[obj.c.label].type && (obj.state[obj.c.label].type === "String" || obj.state[obj.c.label].type === "Array") ? null : `arclight-opacity-30 arclight-pointer-events-none`}`,
                  children: /* @__PURE__ */ jsx33(
                    obj.Checkbox,
                    {
                      value: obj.state[obj.c.label].lookup,
                      onChange: (b, cb) => {
                        obj.setState((_) => __spreadProps(__spreadValues({}, _), {
                          [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                            lookup: b ? null : _[obj.c.label]
                          })
                        }));
                        cb(!b);
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx33(
                "div",
                {
                  className: `arclight-m-auto ${obj.state[obj.c.label] && obj.state[obj.c.label].type && (obj.state[obj.c.label].type === "String" || obj.state[obj.c.label].type === "Array") ? null : `arclight-opacity-30 arclight-pointer-events-none`}`,
                  children: "Lookup"
                }
              ),
              /* @__PURE__ */ jsx33("div", { className: `arclight-m-auto`, children: /* @__PURE__ */ jsx33(
                obj.Checkbox,
                {
                  value: obj.state[obj.c.label].required,
                  onChange: (b, cb) => {
                    obj.setState((_) => __spreadProps(__spreadValues({}, _), {
                      [obj.c.label]: __spreadProps(__spreadValues({}, obj.state[obj.c.label]), {
                        required: b ? false : true
                      })
                    }));
                    cb(!b);
                  }
                }
              ) }),
              /* @__PURE__ */ jsx33("div", { className: `arclight-m-auto`, children: "Required" }),
              /* @__PURE__ */ jsx33(
                "div",
                {
                  className: `arclight-flex arclight-justify-end arclight-w-full arclight-space-x-2`,
                  children: !obj.state[obj.c.label].system || true ? /* @__PURE__ */ jsx33(
                    obj.Bttn,
                    {
                      t: "Remove",
                      a: () => {
                        obj.setState((_) => __spreadProps(__spreadValues({}, _), { [obj.c.label]: void 0 }));
                      }
                    }
                  ) : null
                }
              )
            ]
          }
        )
      ]
    }
  ) : null;
};

// src/components/admin/flexpanel/components/listpanel.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var listpanel_default2 = (listquery, C, i, ListPanel2, state, setState, fns2, D) => {
  if (!D.getdatamodels)
    return;
  const keyarr = ["username", "name"];
  const type2 = fns2.parseAdminDomainState().item;
  let key = D.getdatamodels.records.find((r) => r._type === type2);
  const script = key && key.adminlookup && key.adminlookup.length ? key.adminlookup : void 0;
  if (key) {
    key = (() => {
      for (let i2 = 0; i2 < keyarr.length; i2++) {
        if (key[keyarr[i2]]) {
          return key = keyarr[i2];
        }
      }
      return "_type";
    })();
  }
  return /* @__PURE__ */ jsx34("div", { style: { height: "100%" }, children: /* @__PURE__ */ jsx34(
    ListPanel2,
    {
      controls: [
        // {
        //   icon: "diamond",
        //   text: key,
        //   key,
        //   type: "button",
        // },
        false ? {
          text: key,
          key,
          type: "picklist"
        } : {}
      ],
      loadwatcher: fns2.parseAdminDomainState().activePanel,
      Request: {
        index: "init",
        type: type2,
        search: { limit: 32, skip: 0 },
        local: C.cards,
        script
      },
      fns: fns2,
      D: C.cards ? { [type2]: { records: C.cards } } : D,
      card: (c) => {
        return type2 === "model" ? {
          managed: c._managed,
          img: c.metaimg,
          subtext: c._type,
          onClick: () => {
            if (C.onClick)
              C.onClick(c);
            else
              c.onClick(c);
            if (listquery)
              listquery(type2, c._id);
          }
        } : {
          managed: c._managed,
          img: c.img,
          vid: c.url,
          subtext: c.name || c.username || c.title,
          onClick: () => {
            if (C.onClick)
              C.onClick(c);
            else
              c.onClick(c);
            if (listquery)
              listquery(type2, c._id);
          }
        };
      },
      line: false,
      constrain: true
    }
  ) });
};

// src/components/admin/flexpanel/components/picklist.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var picklist_default2 = (obj, multiple) => {
  const dblist = obj.c.adminlookup && obj.c.D[obj.c.adminlookup] && obj.c.D[obj.c.adminlookup][obj.c.label] && obj.c.D[obj.c.adminlookup][obj.c.label].records || obj.c.lookup && obj.c.D[`getrecords_${obj.c.lookup}`] && obj.c.D[`getrecords_${obj.c.lookup}`][obj.c.label] && obj.c.D[`getrecords_${obj.c.lookup}`][obj.c.label].records;
  const _pL = (i) => /* @__PURE__ */ jsx35(
    "div",
    {
      className: false ? `arclight-opacity-50 arclight-pointer-events-none` : ``,
      children: /* @__PURE__ */ jsx35(
        obj.PickList,
        {
          script: obj.c.adminlookup,
          type: obj.c.lookup,
          D: obj.D,
          fns: obj.fns,
          disallowNone: obj.c.type === "Boolean",
          multiple,
          span: true,
          hot: true,
          value: obj.state[obj.c.label] !== void 0 && obj.state[obj.c.label] !== null && Array.isArray(obj.state[obj.c.label]) ? obj.state[obj.c.label] : !multiple ? obj.state[obj.c.label] : [],
          unlinked: obj.c.type === "Boolean",
          list: obj.c.type === "Boolean" ? [
            { text: "true", value: true },
            { text: "false", value: false }
          ] : obj.c && obj.c.D && dblist ? dblist.map((obj2) => {
            const _ = { value: obj2._id };
            if (obj2.name)
              _.text = obj2.name;
            else if (obj2.username)
              _.text = obj2.username;
            else if (obj2.text)
              _.text = obj2.text;
            return _;
          }) : [],
          onChange: (e) => {
            return obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: e.target.value
            }));
          },
          label: obj.c.label,
          variant: "standard",
          searchkey: (() => {
            if (!obj.c || !obj.c.searchkey)
              return;
            if (obj.c.searchkey["username"])
              return "username";
            else if (obj.c.searchkey["name"])
              return "name";
          })()
        },
        i
      )
    }
  );
  return obj.state[obj.c.label] ? _pL(obj.i) : _pL(obj.i + 1);
};

// src/components/admin/flexpanel/components/calendar.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var calendar_default2 = (obj) => {
  return /* @__PURE__ */ jsx36("div", { className: ``, children: /* @__PURE__ */ jsx36(
    obj.Calendar,
    {
      script: obj.c.script,
      type: !obj.c.script ? "admin" : void 0,
      D: obj.D,
      fns: obj.fns,
      defaultEventBgImg: `https://titanesports.org:7000/static/media/tesbg.png`,
      events: []
    }
  ) });
};

// src/components/admin/flexpanel/components/monaco.tsx
import { jsx as jsx37, jsxs as jsxs22 } from "react/jsx-runtime";
var monaco_default2 = (obj) => {
  return /* @__PURE__ */ jsxs22(
    "div",
    {
      className: `arclight-h-96 ${false ? `arclight-opacity-50 arclight-pointer-events-none` : ``}`,
      children: [
        /* @__PURE__ */ jsx37("div", { className: `arclight-text-start arclight-text-sm`, children: obj.c.label }),
        /* @__PURE__ */ jsx37(
          obj.Monaco,
          {
            refName: obj.c.label,
            language: "json",
            defaultValue: obj.state[obj.c.label] && typeof obj.state[obj.c.label] === "string" ? obj.state[obj.c.label] : "",
            state: obj.state,
            setState: obj.setState
          }
        )
      ]
    }
  );
};

// src/components/admin/flexpanel/components/formselector.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var Panel = (props) => {
  return /* @__PURE__ */ jsx38("div", { children: /* @__PURE__ */ jsx38(
    props.ListPanel,
    {
      controls: [
        {
          icon: "diamond",
          text: "Name",
          key: "name"
        }
      ],
      Request: {
        type: props.fns.parseAdminDomainState().activePanel === 1 ? "Form" : "Form Template",
        search: { limit: 32 }
      },
      fns: props.fns,
      D: props.D,
      card: (c) => ({
        img: c.backgroundimage,
        subtext: c.title,
        onClick: () => {
          props.fns.setAdminDomainState(__spreadProps(__spreadValues({}, props.fns.parseAdminDomainState()), {
            activePanel: props.fns.parseAdminDomainState().item === "Form" ? !props.fns.parseAdminDomainState().activePanel ? 1 : 2 : 2,
            formname: c.__filename ? c.__filename.split(".")[0] : void 0,
            formtemplate: c.__template.split(".")[0]
          }));
        }
      }),
      line: false,
      constrain: true
    }
  ) });
};
var formselector_default = (obj) => {
  return /* @__PURE__ */ jsx38(
    Panel,
    {
      fns: obj.fns,
      D: obj.D,
      ListPanel: obj.ListPanel,
      publicURI: obj.publicURI
    }
  );
};

// src/components/admin/flexpanel/components/scriptselector.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var Panel2 = (props) => {
  const scriptContext = props.fns.parseAdminDomainState().script;
  return /* @__PURE__ */ jsx39("div", { children: /* @__PURE__ */ jsx39(
    props.ListPanel,
    {
      controls: [
        {
          icon: "diamond",
          text: "Name",
          key: "name"
        }
      ],
      Request: {
        type: "Script",
        search: { limit: 32 },
        local: true
      },
      fns: props.fns,
      D: {
        Script: {
          records: scriptContext && props.D.getscripts.records[scriptContext] ? Object.keys(props.D.getscripts.records[scriptContext]).map(
            (k) => {
              const metadata = JSON.parse(
                props.D.getscripts.records[scriptContext][k].metadata
              );
              return {
                img: `https://highmountainlabs.io/cdn/arclight/media/${metadata.managed ? "js-m" : "js"}.jpg`,
                subtext: metadata.name,
                onClick: () => {
                  props.fns.setAdminDomainState(__spreadProps(__spreadValues({}, props.fns.parseAdminDomainState()), {
                    activePanel: 2,
                    selectedscript: k
                  }));
                }
              };
            }
          ) : []
        }
      },
      card: (c) => ({
        img: c.img,
        subtext: c.subtext,
        onClick: c.onClick
      }),
      line: false,
      constrain: true
    }
  ) });
};
var scriptselector_default = (obj) => {
  return /* @__PURE__ */ jsx39(
    Panel2,
    {
      fns: obj.fns,
      D: obj.D,
      ListPanel: obj.ListPanel,
      publicURI: obj.publicURI
    }
  );
};

// src/components/admin/flexpanel/components/integrationselector.tsx
import React20 from "react";
import { jsx as jsx40 } from "react/jsx-runtime";
var Panel3 = (props) => {
  const [index, setIndex] = React20.useState(0);
  React20.useEffect(() => {
    props.fns.calls.getintegrations();
  }, []);
  if (!props.D || !props.D.getintegrations)
    return /* @__PURE__ */ jsx40("div", {});
  return /* @__PURE__ */ jsx40("div", { className: `arclight-w-full arclight-h-full arclight-relative`, children: /* @__PURE__ */ jsx40(
    "div",
    {
      className: `arclight-w-full arclight-absolute arclight-top-1/2 arclight-left-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2`,
      children: /* @__PURE__ */ jsx40("div", { className: `arclight-w-full`, children: /* @__PURE__ */ jsx40(
        props.HeroPanel,
        {
          index,
          rows: 1,
          pageCallback: setIndex,
          autoSort: false,
          cards: Object.keys(props.D.getintegrations).map((k) => ({
            active: props.D.getintegrations[k].active,
            hoverComponent: /* @__PURE__ */ jsx40("div", { children: /* @__PURE__ */ jsx40("div", { className: `text-md`, children: props.D.getintegrations[k].decorators.description }) }),
            bgImg: `${props.D.getintegrations[k].decorators.img}`,
            subText: k,
            onClick: () => props.fns.setAdminDomainState(__spreadProps(__spreadValues({}, props.fns.parseAdminDomainState()), {
              integration: k,
              activePanel: 1
            }))
          }))
        }
      ) })
    }
  ) });
};
var integrationselector_default = (obj) => {
  return /* @__PURE__ */ jsx40(
    Panel3,
    {
      fns: obj.fns,
      D: obj.D,
      HeroPanel: obj.HeroPanel,
      publicURI: obj.publicURI
    }
  );
};

// src/components/admin/flexpanel/components/integrationconfiguration.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var integrationconfiguration_default = (obj) => {
  const k = obj.fns.parseAdminDomainState().integration;
  const v = obj.D && obj.D.getintegrations && obj.D.getintegrations[k] ? obj.D.getintegrations[k] : null;
  return v ? /* @__PURE__ */ jsx41("div", { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsx41(
    obj.Monaco,
    {
      refName: "Integration",
      language: "json",
      defaultValue: JSON.stringify(obj.D.getintegrations[k]),
      state: obj.state,
      setState: obj.setState
    }
  ) }) : null;
};

// src/components/admin/flexpanel/components/scriptconfiguration.tsx
import { jsx as jsx42, jsxs as jsxs23 } from "react/jsx-runtime";
var scriptconfiguration_default = (obj) => {
  const k = obj.fns.parseAdminDomainState().script;
  const kk = obj.fns.parseAdminDomainState().selectedscript;
  const v = kk && obj.D && obj.D.getscripts && obj.D.getscripts.records && obj.D.getscripts.records[k] && obj.D.getscripts.records[k][kk] ? obj.D.getscripts.records[k][kk] : {
    metadata: `{
					"name": "newscript.js",
					"active": false,
					"context": "${k}"
					${k !== "universal" && k !== "endpoint" && k !== "custom-call" && k !== "custom-call-admin" ? `,
"model": "bindingmodel"` : ""}
          ${k === "custom-call" ? `,
"profiles": ["administrator"]` : ""}
				}`,
    fn: `async (ServerObject) => {

};`
  };
  const cc = obj.state.scriptkey && obj.state.scriptkey === "Script Logic";
  return v ? /* @__PURE__ */ jsxs23("div", { style: { height: "100%" }, children: [
    /* @__PURE__ */ jsx42(
      picklist_default,
      {
        unlinked: true,
        type: "script",
        D: obj.D,
        fns: obj.fns,
        disallowNone: true,
        span: true,
        hot: true,
        value: obj.state.scriptkey ? obj.state.scriptkey : "Metadata",
        list: [
          { value: "Metadata", text: "Metadata" },
          { value: "Script Logic", text: "Script Logic" }
        ].filter(
          (el) => obj.fns.parseAdminDomainState().selectedscript || el.value === "Metadata"
        ),
        onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), { scriptkey: e.target.value })),
        keyname: 0,
        label: "Source Control",
        variant: "standard"
      }
    ),
    /* @__PURE__ */ jsx42(
      "div",
      {
        style: { height: "100%", maxHeight: "600px" },
        className: `arclight-mt-5`,
        children: /* @__PURE__ */ jsx42(
          obj.Monaco,
          {
            refName: cc ? "Script Logic" : "Metadata",
            language: cc ? "javascript" : "json",
            defaultValue: cc ? v.fn : v.metadata,
            state: obj.state,
            setState: obj.setState
          }
        )
      },
      obj.state.scriptkey
    )
  ] }) : null;
};

// src/components/admin/apps/LoL Tournament API/index.tsx
import React26 from "react";

// src/components/admin/apps/LoL Tournament API/panels/buildtournamnetcodes.tsx
import React21 from "react";
import { jsx as jsx43, jsxs as jsxs24 } from "react/jsx-runtime";
var buildtournamnetcodes_default = (props) => {
  let TEAMS_LIST = void 0;
  const [state, setState] = React21.useState({
    league: null,
    team1: null,
    team2: null,
    count: null,
    weekNum: null,
    seasonNum: null,
    MonacoRef: {}
  });
  React21.useEffect(() => {
    if (props.fns.calls && props.fns.calls.getintegrations && props.D && !props.D.getintegrations)
      props.fns.calls.getintegrations();
  });
  if (props.D && props.D.getintegrations && props.D.getintegrations["LoL Tournament API"] && props.D.getintegrations["LoL Tournament API"].overrides.teamlookup && props.D.getintegrations["LoL Tournament API"].overrides.teamlookup.length)
    TEAMS_LIST = props.D.getintegrations["LoL Tournament API"].overrides.teamlookup;
  return props.D && props.D.getintegrations && props.D.getintegrations["LoL Tournament API"] ? /* @__PURE__ */ jsxs24("div", { className: `arclight-flex arclight-flex-col arclight-space-y-10`, children: [
    [
      {
        type: props.D.getintegrations["LoL Tournament API"].settings.leaguemodeltype,
        value: "league",
        label: "League Selection"
      },
      {
        type: props.D.getintegrations["LoL Tournament API"].settings.teammodeltype,
        value: "team1",
        label: "Team 1 Selection"
      },
      {
        type: props.D.getintegrations["LoL Tournament API"].settings.teammodeltype,
        value: "team2",
        label: "Team 2 Selection"
      }
    ].map((el) => /* @__PURE__ */ jsx43(
      props.Controls.PickList,
      {
        script: TEAMS_LIST && el.value.includes("team") ? TEAMS_LIST : void 0,
        keyname: "name",
        searchkey: "name",
        type: el.type,
        D: props.D,
        fns: props.fns,
        span: true,
        hot: true,
        value: state[el.value],
        list: props.D && props.D[TEAMS_LIST && el.value.includes("team") ? TEAMS_LIST : `getrecords_${el.type}`] && props.D[TEAMS_LIST && el.value.includes("team") ? TEAMS_LIST : `getrecords_${el.type}`][el.label] && props.D[TEAMS_LIST && el.value.includes("team") ? TEAMS_LIST : `getrecords_${el.type}`][el.label].records ? props.D[TEAMS_LIST && el.value.includes("team") ? TEAMS_LIST : `getrecords_${el.type}`][el.label].records.map((obj) => {
          const _ = { value: obj._id };
          _.text = obj.name;
          return _;
        }) : [],
        onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), {
          [el.value]: e.target.value
        })),
        label: el.label,
        variant: "standard"
      },
      0
    )),
    /* @__PURE__ */ jsx43(
      props.Controls.PickList,
      {
        unlinked: true,
        span: true,
        hot: true,
        value: state.count,
        list: [1, 3, 5, 7].map((value) => ({
          text: `${value}`,
          value
        })),
        onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), {
          count: e.target.value
        })),
        label: "Code Count",
        variant: "standard"
      },
      0
    ),
    /* @__PURE__ */ jsx43(
      props.Controls.TextField,
      {
        defaultValue: props.D.getintegrations["LoL Tournament API"].settings.defaultseason,
        span: true,
        hot: true,
        value: state.seasonNum,
        onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), {
          seasonNum: parseInt(e.target.value)
        })),
        type: "text",
        label: "Season Number",
        variant: "standard"
      },
      0
    ),
    /* @__PURE__ */ jsx43(
      props.Controls.TextField,
      {
        defaultValue: props.D.getintegrations["LoL Tournament API"].settings.defaultweek,
        span: true,
        hot: true,
        value: state.weekNum,
        onChange: (e) => setState((_) => __spreadProps(__spreadValues({}, _), {
          weekNum: parseInt(e.target.value)
        })),
        type: "text",
        label: "Week Number",
        variant: "standard"
      },
      0
    ),
    /* @__PURE__ */ jsx43(
      props.Controls.Button,
      {
        span: true,
        label: "Generate Tournament Codes",
        type: "button",
        size: "md",
        animation: true,
        disabled: false,
        block: false,
        rounded: false,
        square: false,
        isIconButton: false,
        onClick: (status) => {
          props.fns.calls.generatetournamentcodes(__spreadProps(__spreadValues({}, state), {
            seasonNum: state.seasonNum ? state.seasonNum : props.D.getintegrations["LoL Tournament API"].settings.defaultseason,
            weekNum: state.weekNum ? state.weekNum : props.D.getintegrations["LoL Tournament API"].settings.defaultweek,
            MonacoRef: void 0
          }));
          props.setState((_) => __spreadProps(__spreadValues({}, _), {
            _isLoading: true,
            _primemodal: (D) => {
              const _2 = props.fns.e(
                D,
                `D.generatetournamentcodes.generatetournamentcodes`,
                {}
              );
              props.fns.setModal({
                noescape: true,
                mode: "full",
                bgImg: `${props.publicURI}/static/integrationsart/riotxlol.jpg`,
                body: () => /* @__PURE__ */ jsx43("div", { className: `arclight-w-full`, children: /* @__PURE__ */ jsx43(
                  "div",
                  {
                    className: `arclight-w-full arclight-h-96 arclight-p-4`,
                    children: /* @__PURE__ */ jsx43(
                      props.Controls.Monaco,
                      {
                        refName: "codes",
                        language: "json",
                        defaultValue: _2.JSON,
                        state,
                        setState
                      }
                    )
                  }
                ) })
              });
            }
          }));
        }
      }
    )
  ] }) : null;
};

// src/components/admin/apps/LoL Tournament API/panels/authenticatesummoner.tsx
import React22 from "react";
import { jsx as jsx44, jsxs as jsxs25 } from "react/jsx-runtime";
var _SUMMONERKEY = "User";
var authenticatesummoner_default = (props) => {
  const [user, setUser] = React22.useState(null);
  const [summonername, setSummonerName] = React22.useState(null);
  React22.useEffect(() => {
    if (!user)
      return;
    setSummonerName(user.summonername);
  }, [user]);
  const usermodeltype = props.fns.e(
    props.D,
    `D.getintegrations.LoL Tournament API.settings.usermodeltype`,
    null
  );
  React22.useEffect(() => {
    if (usermodeltype && props.D[`getrecords_${usermodeltype}`] && !props.D[`getrecords_${usermodeltype}`][_SUMMONERKEY])
      props.fns.calls[`getrecords_${usermodeltype}`]({
        index: _SUMMONERKEY,
        search: {
          skip: 0,
          limit: 10
        }
      });
  }, [props.D]);
  React22.useEffect(() => {
    if (props.fns.calls && props.fns.calls.getintegrations && props.D) {
      if (!props.D.getintegrations)
        props.fns.calls.getintegrations();
      if (usermodeltype && !props.D[`getrecords_${usermodeltype}`])
        props.fns.calls[`getrecords_${usermodeltype}`]();
    }
  });
  return usermodeltype && props.D && props.D[`getrecords_${usermodeltype}`] && props.D[`getrecords_${usermodeltype}`][_SUMMONERKEY] ? /* @__PURE__ */ jsxs25("div", { className: `arclight-flex arclight-flex-col arclight-space-y-10`, children: [
    /* @__PURE__ */ jsx44(
      props.Controls.PickList,
      {
        type: usermodeltype,
        D: props.D,
        fns: props.fns,
        span: true,
        hot: true,
        value: user,
        list: props.D[`getrecords_${usermodeltype}`][_SUMMONERKEY].records.map(
          (obj) => {
            const _ = { value: obj._id };
            if (obj.name)
              _.text = obj.name;
            else if (obj.username)
              _.text = obj.username;
            else if (obj.text)
              _.text = obj.text;
            return _;
          }
        ),
        onChange: (e) => {
          return setUser(e.target.value);
        },
        label: _SUMMONERKEY,
        variant: "standard",
        searchkey: "username"
      },
      0
    ),
    /* @__PURE__ */ jsx44(
      props.Controls.TextField,
      {
        span: true,
        hot: true,
        value: summonername && summonername.length ? summonername : "",
        onChange: (e) => setSummonerName(e.target.value),
        type: "text",
        label: "Summoner Name",
        variant: "standard"
      },
      0
    ),
    /* @__PURE__ */ jsx44(
      props.Controls.Button,
      {
        span: true,
        label: "Authenticate Summoner",
        type: "button",
        size: "md",
        animation: true,
        disabled: false,
        block: false,
        rounded: false,
        square: false,
        isIconButton: false,
        onClick: (status) => {
          props.fns.calls.authenticatesummoner(
            user ? {
              user,
              summonername
            } : {}
          );
          props.setState((_) => __spreadProps(__spreadValues({}, _), {
            _isLoading: true
          }));
        }
      }
    )
  ] }) : null;
};

// src/components/admin/apps/LoL Tournament API/panels/importgamefromtournamentcode.tsx
import React23 from "react";
import { jsx as jsx45, jsxs as jsxs26 } from "react/jsx-runtime";
var importgamefromtournamentcode_default = (props) => {
  const [code, setCode] = React23.useState(null);
  React23.useEffect(() => {
    if (props.fns.calls && props.fns.calls.getintegrations && props.D && !props.D.getintegrations)
      props.fns.calls.getintegrations();
  });
  return /* @__PURE__ */ jsxs26("div", { className: `arclight-flex arclight-flex-col arclight-space-y-10`, children: [
    /* @__PURE__ */ jsx45(
      props.Controls.TextField,
      {
        span: true,
        hot: true,
        value: code,
        onChange: (e) => setCode(e.target.value),
        type: "text",
        label: "Tournament Code",
        variant: "standard"
      },
      0
    ),
    /* @__PURE__ */ jsx45(
      props.Controls.Button,
      {
        span: true,
        label: "Import Game",
        type: "button",
        size: "md",
        animation: true,
        disabled: false,
        block: false,
        rounded: false,
        square: false,
        isIconButton: false,
        onClick: (status) => {
          props.fns.calls.importgamefromtournamentcode({
            code
          });
          props.setState((_) => __spreadProps(__spreadValues({}, _), {
            _isLoading: true
          }));
        }
      }
    )
  ] });
};

// src/components/pagetitle/index.tsx
import React25 from "react";

// src/components/pagetitle/styles.js
import styled25 from "styled-components";
var Container25 = styled25.div``;
var styles_default25 = {
  Container: Container25
};

// src/components/animatedborder/styles.js
import styled26 from "styled-components";
var Container26 = styled26.div`
  position: relative;
`;
var Img = styled26.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
var styles_default26 = {
  Container: Container26,
  Img
};

// src/components/clippingmask/index.tsx
import React24 from "react";

// src/components/clippingmask/styles.js
import styled27 from "styled-components";
var Canvas = styled27.canvas`
  transition: all 0.25s ease-in;
  opacity: ${(props) => props.opacity};
  opacity: 0;
`;
var styles_default27 = {
  Canvas
};

// src/components/clippingmask/index.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var Video = (fns2, src, context, width, height, cb) => {
  return;
  const _src = document.createElement("video");
  _src.src = src.props.src;
  _src.autoplay = true;
  _src.muted = true;
  _src.loop = true;
  _src.play();
  _src.oncanplay = () => {
    fns2.addAnimationFrame(() => context.drawImage(_src, 0, 0, width, height));
    cb();
  };
};
var BoundGraphic = React24.memo(
  ({ src, clippingMask, width, height, className, fns: fns2 }) => {
    const [opacity, setOpacity] = React24.useState(0);
    const canvasRef = React24.useRef(null);
    React24.useEffect(() => {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      const _clippingMask = document.createElement("img");
      _clippingMask.src = clippingMask.props.src;
      _clippingMask.onload = () => {
        context.drawImage(_clippingMask, 0, 0, width, height);
        context.globalCompositeOperation = "source-atop";
        Video(fns2, src, context, width, height, () => setOpacity(1));
      };
    }, []);
    return /* @__PURE__ */ jsx46(
      styles_default27.Canvas,
      {
        ref: canvasRef,
        width,
        height,
        opacity,
        className
      }
    );
  }
);
var clippingmask_default = BoundGraphic;

// src/components/animatedborder/index.tsx
import { jsx as jsx47, jsxs as jsxs27 } from "react/jsx-runtime";
var Footer = ({
  src,
  video,
  className,
  borderWidth,
  heightOffset,
  fns: fns2
}) => {
  return /* @__PURE__ */ jsxs27(
    styles_default26.Container,
    {
      className,
      style: { width: src.props.width, height: src.props.width },
      children: [
        /* @__PURE__ */ jsx47(
          "div",
          {
            className: `arclight-absolute`,
            style: { top: "50%", left: "50%", transform: "translate(-50%, -50%)" },
            children: video ? /* @__PURE__ */ jsx47(
              clippingmask_default,
              {
                fns: fns2,
                clippingMask: src,
                src: video,
                width: parseInt(src.props.width.split("px")[0]),
                height: parseInt(src.props.width.split("px")[0]) + (heightOffset ? heightOffset : 0)
              }
            ) : null
          }
        ),
        src && src.props && src.props.src ? /* @__PURE__ */ jsx47(
          styles_default26.Img,
          {
            src: src.props.src,
            style: {
              width: `calc(${src.props.width} - ${borderWidth} * 2)`,
              marginLeft: borderWidth
            }
          }
        ) : null
      ]
    }
  );
};
var animatedborder_default = Footer;

// src/components/pagetitle/index.tsx
import { jsx as jsx48, jsxs as jsxs28 } from "react/jsx-runtime";
var PageTitle = React25.memo(
  ({ text, orientation, fns: fns2, bg, img, bgOffset }) => {
    const [small, setSmall] = React25.useState(false);
    const handleResize = () => {
      if (window.innerWidth > 1024)
        setSmall(false);
      else
        setSmall(true);
    };
    window.addEventListener("resize", handleResize);
    React25.useEffect(handleResize, []);
    return /* @__PURE__ */ jsxs28(
      styles_default25.Container,
      {
        className: `arclight-text-${orientation} arclight-m-24 lg:arclight-m-36`,
        children: [
          img ? /* @__PURE__ */ jsxs28("div", { className: "arclight-relative", children: [
            /* @__PURE__ */ jsx48(
              animatedborder_default,
              {
                fns: fns2,
                src: img ? /* @__PURE__ */ jsx48("img", { src: img, width: `400px` }) : null,
                video: bg ? /* @__PURE__ */ jsx48("video", { src: bg }) : null,
                heightOffset: bgOffset ? bgOffset : 100,
                borderWidth: 20,
                className: `arclight-m-auto ${small ? "arclight-hidden" : null}`
              }
            ),
            /* @__PURE__ */ jsx48(
              animatedborder_default,
              {
                fns: fns2,
                src: img ? /* @__PURE__ */ jsx48("img", { src: img, width: `200px` }) : null,
                video: bg ? /* @__PURE__ */ jsx48("video", { src: bg }) : null,
                heightOffset: bgOffset ? bgOffset : 100,
                borderWidth: 10,
                className: `arclight-m-auto ${!small ? "arclight-hidden" : null}`
              }
            )
          ] }) : null,
          /* @__PURE__ */ jsx48(
            "span",
            {
              className: `arclight-text-text-primary arclight-font-primary arclight-text-4xl lg:arclight-text-6xl arclight-relative`,
              children: text
            }
          )
        ]
      }
    );
  }
);
var pagetitle_default = PageTitle;

// src/components/admin/apps/LoL Tournament API/panels/index.tsx
import { jsx as jsx49, jsxs as jsxs29 } from "react/jsx-runtime";
var panels_default = (panel, publicURI, fns2, D, Controls2, state, setState) => {
  let App2;
  let gem = "";
  const title = fns2.parseAdminDomainState().subItem;
  if (title === "Tournament Codes") {
    gem = "purple_essence.png";
    App2 = /* @__PURE__ */ jsx49(
      buildtournamnetcodes_default,
      {
        publicURI,
        fns: fns2,
        D,
        Controls: Controls2,
        state,
        setState
      }
    );
  } else if (title === "Authenticate Summoner") {
    gem = "orange_essence.png";
    App2 = /* @__PURE__ */ jsx49(
      authenticatesummoner_default,
      {
        publicURI,
        fns: fns2,
        D,
        Controls: Controls2,
        state,
        setState
      }
    );
  } else if (title === "Import Game Data") {
    gem = "blue_essence.png";
    App2 = /* @__PURE__ */ jsx49(
      importgamefromtournamentcode_default,
      {
        publicURI,
        fns: fns2,
        D,
        Controls: Controls2,
        state,
        setState
      }
    );
  }
  return /* @__PURE__ */ jsxs29("div", { className: `arclight-w-full`, children: [
    /* @__PURE__ */ jsx49(
      pagetitle_default,
      {
        orientation: "center",
        text: title,
        fns: fns2,
        img: `https://highmountainlabs.io/cdn/arclight/media/${gem}`,
        bg: `https://highmountainlabs.io/cdn/arclight/media/${gem}`,
        bgOffset: -50
      }
    ),
    App2
  ] });
};

// src/components/admin/apps/LoL Tournament API/controls.tsx
var controls_default = {
  PickList: picklist_default,
  TextField: textfield_default,
  Button: button_default,
  Monaco: monaco_default
};

// src/components/admin/apps/LoL Tournament API/styles.js
import styled28 from "styled-components";
var Container27 = styled28.div`
  width: 100%;
  overflow-x: hidden;
`;
var SubContainer = styled28.div``;
var styles_default28 = {
  Container: Container27,
  SubContainer
};

// src/components/admin/apps/LoL Tournament API/index.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var LoLTournamentAPI = ({ state, setState, D, fns: fns2, publicURI }) => {
  const [index, setIndex] = React26.useState(0);
  return /* @__PURE__ */ jsx50(
    styles_default28.Container,
    {
      className: `arclight-flex arclight-justify-center arclight-align-middle arclight-h-full`,
      children: !fns2.parseAdminDomainState().activePanel ? /* @__PURE__ */ jsx50(
        styles_default28.SubContainer,
        {
          className: `arclight-flex arclight-flex-col arclight-justify-center arclight-align-middle arclight-h-full arclight-w-full`,
          children: /* @__PURE__ */ jsx50(
            heropanel_default,
            {
              index,
              small: true,
              rows: 1,
              title: "Select a Function",
              pageCallback: setIndex,
              cards: [
                {
                  hoverComponent: /* @__PURE__ */ jsx50(
                    "img",
                    {
                      src: `https://highmountainlabs.io/cdn/arclight/media/purple_essence.png`,
                      className: `arclight-w-32 lg:arclight-w-64 arclight-object-cover`
                    }
                  ),
                  bgImg: `https://highmountainlabs.io/cdn/arclight/media/ionia_1.jpg`,
                  subText: "Tournament Codes",
                  onClick: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
                    activePanel: 1,
                    subItem: "Tournament Codes"
                  }))
                },
                {
                  locked: true,
                  hoverComponent: /* @__PURE__ */ jsx50(
                    "img",
                    {
                      src: `https://highmountainlabs.io/cdn/arclight/media/orange_essence.png`,
                      className: `arclight-w-32 lg:arclight-w-64 arclight-object-cover`
                    }
                  ),
                  bgImg: `https://highmountainlabs.io/cdn/arclight/media/ionia_2.png`,
                  subText: "Authenticate Summoner",
                  onClick: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
                    activePanel: 1,
                    subItem: "Authenticate Summoner"
                  }))
                },
                {
                  locked: true,
                  hoverComponent: /* @__PURE__ */ jsx50(
                    "img",
                    {
                      src: `https://highmountainlabs.io/cdn/arclight/media/blue_essence.png`,
                      className: `arclight-w-32 lg:arclight-w-64 arclight-object-cover`
                    }
                  ),
                  bgImg: `https://highmountainlabs.io/cdn/arclight/media/ionia_3.jpg`,
                  subText: "Insert Forfeit",
                  onClick: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
                    activePanel: 1,
                    subItem: "Insert Forfeit"
                  }))
                },
                {
                  locked: true,
                  hoverComponent: /* @__PURE__ */ jsx50(
                    "img",
                    {
                      src: `https://highmountainlabs.io/cdn/arclight/media/blue_essence.png`,
                      className: `arclight-w-32 lg:arclight-w-64 arclight-object-cover`
                    }
                  ),
                  bgImg: `https://highmountainlabs.io/cdn/arclight/media/ionia_3.jpg`,
                  subText: "Import Game Data",
                  onClick: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
                    activePanel: 1,
                    subItem: "Import Game Data"
                  }))
                }
              ]
            }
          )
        }
      ) : panels_default(
        fns2.parseAdminDomainState().activePanel,
        publicURI,
        fns2,
        D,
        controls_default,
        state,
        setState
      )
    }
  );
};
var LoL_Tournament_API_default = LoLTournamentAPI;

// src/components/admin/flexpanel/components/app.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var app_default = (obj) => {
  const _ = {
    state: obj.state,
    setState: obj.setState,
    D: obj.D,
    fns: obj.fns,
    publicURI: obj.publicURI
  };
  switch (obj.fns.parseAdminDomainState().item) {
    case "LoL Tournament API":
      return /* @__PURE__ */ jsx51(LoL_Tournament_API_default, __spreadValues({}, _));
  }
};

// src/components/admin/flexpanel/components/application.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
var application_default2 = (obj) => {
  let f;
  const s = obj.fns.parseAdminDomainState();
  const k = obj.D && s.formtemplate && (s.formname || s.item === "Form Template") && obj.D[s.item === "Form Template" ? "getformtemplates" : "getforms"] && obj.D[s.item === "Form Template" ? "getformtemplates" : "getforms"].records;
  if (k)
    s.item === "Form Template" ? f = obj.D.getformtemplates.records.find(
      (r) => r.__template === `${s.formtemplate}.json`
    ) : f = obj.D.getforms.records[s.formtemplate][s.formname];
  return k && f ? /* @__PURE__ */ jsx52(
    "div",
    {
      className: false ? `arclight-opacity-50 arclight-pointer-events-none` : ``,
      children: /* @__PURE__ */ jsx52(
        obj.Application,
        {
          locked: true,
          D: obj.D,
          fns: obj.fns,
          form: f,
          className: `arclight-rounded-sm`
        }
      )
    }
  ) : null;
};

// src/components/admin/flexpanel/controlselector.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var __conditions = (obj) => {
  var _a, _b;
  return {
    condition1: obj.D && ((_a = obj.c) == null ? void 0 : _a.label) && ((_b = obj.state) == null ? void 0 : _b._id) && obj.state[obj.c.label] === void 0 && (obj.searchOn === "model" ? obj.D.getdatamodels : obj.D[`getrecords_${obj.searchOn}`]),
    condition2: obj.D && obj.D.getdatamodels && obj.D.getdatamodels.records ? obj.D.getdatamodels.records.find((el) => el._id === obj.state._id) : false,
    condition3: obj.D[`getrecords_${obj.searchOn}`] && obj.D[`getrecords_${obj.searchOn}`].init && obj.D[`getrecords_${obj.searchOn}`].init.records
  };
};
var controlselector_default = (obj) => {
  if (obj.c) {
    const conditions = __conditions(obj);
    if (conditions.condition1) {
      const v = conditions.condition2;
      if (obj.searchOn === "model") {
        if (v && v[obj.c.label])
          obj.state[obj.c.label] = typeof v[obj.c.label] === "object" ? {
            key: obj.c.label,
            type: v[obj.c.label]._type,
            lookup: obj.c.lookup,
            adminlookup: obj.c.adminlookup,
            required: obj.c.required,
            system: v._system
          } : v[obj.c.label];
        if (v)
          obj.state._system = v._system;
      } else if (conditions.condition3) {
        const value = obj.D[`getrecords_${obj.searchOn}`].init.records.find(
          (el) => el._id === obj.state._id
        );
        if (value)
          obj.state[obj.c.label] = value[obj.c.label];
      }
    }
    switch (obj.c.type) {
      case "Monaco":
        return monaco_default2(__spreadProps(__spreadValues({}, obj), { Monaco: monaco_default }));
      case "Boolean":
        return picklist_default2(__spreadProps(__spreadValues({}, obj), { PickList: picklist_default }));
      case "App":
        return app_default(__spreadValues({}, obj));
      case "ArticlePage":
        return articlepage_default2(__spreadProps(__spreadValues({}, obj), { ArticlePage: articlepage_default }));
      case "TextField":
        return textfield_default2(__spreadProps(__spreadValues({}, obj), { TextField: textfield_default }));
      case "Date":
        return dateselector_default2(
          obj.c,
          obj.i,
          dateselector_default,
          obj.state,
          obj.setState
        );
      case "Calendar":
        return calendar_default2(__spreadProps(__spreadValues({}, obj), { Calendar: calendar_default }));
      case "TextFieldNumber":
        return /* @__PURE__ */ jsx53("div", { className: ``, children: /* @__PURE__ */ jsx53(
          textfield_default,
          {
            span: true,
            hot: true,
            value: obj.state[obj.c.label],
            onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: e.target.value && e.target.value.length > 0 ? parseInt(e.target.value) : null
            })),
            type: "text",
            label: obj.c.label,
            variant: "standard"
          },
          obj.i
        ) });
      case "PasswordField":
        return /* @__PURE__ */ jsx53(
          textfield_default,
          {
            span: true,
            hot: true,
            value: obj.state[obj.c.label],
            onChange: (e) => obj.setState((_) => __spreadProps(__spreadValues({}, _), {
              [obj.c.label]: e.target.value
            })),
            type: "password",
            label: obj.c.label,
            variant: "standard"
          },
          obj.i
        );
      case "SinglePickList":
        return picklist_default2(__spreadProps(__spreadValues({}, obj), { PickList: picklist_default }));
      case "PickList":
        return picklist_default2(__spreadProps(__spreadValues({}, obj), { PickList: picklist_default }), true);
      case "ListPanel":
        return listpanel_default2(
          obj.state._items[obj.i].listquery,
          obj.c,
          obj.i,
          listpanel_default,
          obj.state,
          obj.setState,
          obj.fns,
          obj.D
        );
      case "DynamicField":
        return dynamicfield_default(__spreadProps(__spreadValues({}, obj), { TextField: textfield_default, PickList: picklist_default, Checkbox: checkbox_default }));
      case "FormSelector":
        return formselector_default(__spreadProps(__spreadValues({}, obj), { ListPanel: listpanel_default }));
      case "ScriptSelector":
        return scriptselector_default(__spreadProps(__spreadValues({}, obj), { ListPanel: listpanel_default }));
      case "IntegrationSelector":
        return integrationselector_default(__spreadProps(__spreadValues({}, obj), { HeroPanel: heropanel_default }));
      case "IntegrationMonaco":
        return integrationconfiguration_default(__spreadProps(__spreadValues({}, obj), { Monaco: monaco_default }));
      case "ScriptMonaco":
        return scriptconfiguration_default(__spreadProps(__spreadValues({}, obj), { Monaco: monaco_default }));
      case "Application":
        return application_default2(__spreadProps(__spreadValues({}, obj), { Application: application_default }));
    }
  }
};

// src/components/admin/flexpanel/item.tsx
import React28 from "react";

// src/components/admin/flexpanel/itemcontent.tsx
import React27 from "react";
import { jsx as jsx54, jsxs as jsxs30 } from "react/jsx-runtime";
var ChkBox = (props) => /* @__PURE__ */ jsxs30(
  "div",
  {
    className: `arclight-text-text-primary arclight-font-primary arclight-text-base arclight-flex arclight-justify-start`,
    children: [
      /* @__PURE__ */ jsx54("div", { className: `arclight-m-auto`, children: /* @__PURE__ */ jsx54(
        checkbox_default,
        {
          value: props.v,
          onChange: (b, cb) => props.a()
        }
      ) }),
      /* @__PURE__ */ jsx54("div", { className: `arclight-m-auto`, children: props.t })
    ]
  }
);
var itemcontent_default = (props) => {
  const endpontarr = ["get", "post", "put", "delete"];
  const arr = {
    public: [
      { c: "onPublicRead", s: "publicread" },
      { c: "onPublicEdit", s: "publicedit" },
      { c: "onPublicCreate", s: "publiccreate" },
      { c: "onPublicDelete", s: "publicdelete" }
    ],
    owner: [
      { c: "onOwnerRead", s: "ownerread" },
      { c: "onOwnerEdit", s: "owneredit" },
      { c: "onOwnerCreate", s: "ownercreate" },
      { c: "onOwnerDelete", s: "ownerdelete" }
    ]
  };
  React27.useEffect(() => {
    if (props.onScript && props.fns && props.fns.calls && props.fns.calls.getscripts)
      props.fns.calls.getscripts();
  }, []);
  return /* @__PURE__ */ jsx54(
    props.Styles.ItemContent,
    {
      className: `arclight-w-full arclight-h-full arclight-rounded ${props.constrain ? "arclight-max-w-xl" : null} arclight-p-5 arclight-max-h-full`,
      children: /* @__PURE__ */ jsx54(
        "div",
        {
          className: "arclight-flex arclight-justify-center arclight-items-center arclight-w-full arclight-h-full",
          children: /* @__PURE__ */ jsxs30("div", { className: "arclight-w-full arclight-space-y-8 arclight-h-full", children: [
            /* @__PURE__ */ jsx54(
              "div",
              {
                className: `arclight-flex arclight-justify-start arclight-w-full arclight-space-y-4`,
                style: { maxHeight: "85%", minHeight: "85%" },
                children: /* @__PURE__ */ jsxs30("div", { className: `arclight-w-full arclight-space-y-4`, children: [
                  props.children,
                  Object.keys(arr).map(
                    (k) => arr[k].find((o) => props[o.c]) ? /* @__PURE__ */ jsx54(
                      props.Picklist,
                      {
                        multiple: true,
                        unlinked: true,
                        disallowNone: true,
                        span: true,
                        hot: true,
                        value: Object.keys(props.state).filter(
                          (kk) => arr[k].find((el) => el.s === kk) && props.state[kk]
                        ),
                        list: arr[k].map((o) => ({
                          text: o.s,
                          value: o.s
                        })),
                        onChange: (e) => {
                          const _ = {};
                          arr[k].map(
                            (el) => _[el.s] = e.target.value.includes(el.s)
                          );
                          props.setState((s) => __spreadValues(__spreadValues({}, s), _));
                        },
                        label: `${k.charAt(0).toUpperCase()}${k.slice(1).toLowerCase()} Access`,
                        variant: "standard"
                      },
                      0
                    ) : null
                  ),
                  props.onAccessType ? /* @__PURE__ */ jsx54(
                    props.Picklist,
                    {
                      unlinked: true,
                      disallowNone: true,
                      span: true,
                      hot: true,
                      value: props.state.accesstype,
                      list: endpontarr.map((s) => ({
                        text: s,
                        value: s
                      })),
                      onChange: (e) => {
                        props.setState((s) => __spreadProps(__spreadValues({}, s), {
                          accesstype: e.target.value
                        }));
                      },
                      label: "accesstype",
                      variant: "standard"
                    },
                    0
                  ) : null,
                  props.onScript && props.D && props.D.getscripts && props.D.getscripts.records && props.D.getscripts.records.endpoint ? /* @__PURE__ */ jsx54(
                    props.Picklist,
                    {
                      unlinked: true,
                      disallowNone: true,
                      span: true,
                      hot: true,
                      value: props.state.script,
                      list: Object.keys(props.D.getscripts.records.endpoint).map(
                        (s) => ({
                          text: s,
                          value: s
                        })
                      ),
                      onChange: (e) => {
                        props.setState((s) => __spreadProps(__spreadValues({}, s), {
                          script: e.target.value
                        }));
                      },
                      label: "script",
                      variant: "standard"
                    },
                    0
                  ) : null
                ] })
              }
            ),
            /* @__PURE__ */ jsxs30("div", { className: `arclight-flex arclight-flex-row arclight-w-full`, children: [
              /* @__PURE__ */ jsx54(
                "div",
                {
                  className: `arclight-flex arclight-justify-start arclight-space-x-2 arclight-w-1/3`,
                  children: [{ fn: "onRecursiveInit", t: "Recursive Init" }].filter((el) => props[el.fn]).map((el) => /* @__PURE__ */ jsx54(
                    ChkBox,
                    {
                      v: props.state.recursiveinit,
                      t: el.t,
                      a: () => props[el.fn](
                        (s) => props.setState((_) => __spreadValues(__spreadValues({}, _), s))
                      )
                    }
                  ))
                }
              ),
              /* @__PURE__ */ jsx54(
                "div",
                {
                  className: `arclight-flex arclight-justify-end arclight-space-x-2 arclight-w-full`,
                  children: [
                    { fn: "onExecute", t: "Execute" },
                    { fn: "onLog", t: "Log" },
                    { fn: "onAddField", t: "Add Field" },
                    { fn: "onCreate", t: "Create" },
                    { fn: "onSubmit", t: "Submit" },
                    { fn: "onUpdate", t: "Update" },
                    { fn: "onReplace", t: "Replace" },
                    { fn: "onDelete", t: "Delete" },
                    { fn: "onUpload", t: "Upload" },
                    { fn: "onBack", t: "Back" }
                  ].filter(
                    (el) => props[el.fn] && !(props.state && props.state.onDelete)
                  ).map((el) => /* @__PURE__ */ jsx54(
                    props.Bttn,
                    {
                      t: el.t,
                      a: () => props[el.fn](
                        (s) => props.setState((_) => __spreadValues(__spreadValues({}, _), s))
                      )
                    }
                  ))
                }
              )
            ] })
          ] })
        }
      )
    }
  );
};

// src/components/admin/flexpanel/subitem.tsx
import { jsx as jsx55, jsxs as jsxs31 } from "react/jsx-runtime";
var subitem_default = (props) => {
  return /* @__PURE__ */ jsxs31(
    props.Styles.Item,
    {
      className: `arclight-bg-background-primary arclight-w-full arclight-h-full arclight-rounded arclight-p-5 ${props.className}`,
      mountAnim: { anim: "fadeIn", duration: "0.35s" },
      children: [
        /* @__PURE__ */ jsx55(
          props.Styles.BgImg,
          {
            src: props.backgroundImg ? props.backgroundImg : "http://localhost:7000/static/integrationsart/daedalus.jpg"
          }
        ),
        /* @__PURE__ */ jsxs31("div", { className: `arclight-w-full arclight-h-full`, children: [
          props.title ? /* @__PURE__ */ jsx55(
            "div",
            {
              className: `arclight-font-primary arclight-text-4xl${props.managed ? ` arclight-text-cyan-300` : ""}`,
              children: props.title
            }
          ) : null,
          /* @__PURE__ */ jsx55(itemcontent_default, __spreadProps(__spreadValues({}, props), { children: props.children }))
        ] })
      ]
    }
  );
};

// src/components/admin/flexpanel/item.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var item_default = (props) => {
  const t = React28.useRef();
  const [item, setItem] = React28.useState(/* @__PURE__ */ jsx56("div", {}));
  React28.useEffect(() => {
    if (props.title !== t.current)
      setItem(/* @__PURE__ */ jsx56("div", {}));
    setTimeout(() => setItem(/* @__PURE__ */ jsx56(subitem_default, __spreadValues({}, props))), 10);
    t.current = props.title;
  }, [props]);
  return /* @__PURE__ */ jsx56(
    "td",
    {
      className: `arclight-p-2 ${props.active ? `${props.waiting ? `arclight-opacity-30 arclight-pointer-events-none` : `arclight-opacity-100`} arclight-scale-100` : `arclight-hidden`} arclight-transition-all arclight-duration-300 arclight-flex-1 arclight-w-full arclight-h-full`,
      align: "center",
      children: item
    }
  );
};

// src/components/admin/flexpanel/index.tsx
import { jsx as jsx57, jsxs as jsxs32 } from "react/jsx-runtime";
var Bttn = (props) => /* @__PURE__ */ jsx57(
  button_default,
  {
    span: props.span,
    label: props.t,
    type: "button",
    size: "md",
    animation: true,
    disabled: false,
    block: false,
    rounded: false,
    square: false,
    isIconButton: false,
    onClick: (status) => props.a()
  }
);
var FlexPanel = ({
  className,
  items,
  cols,
  callresolved,
  D,
  searchOn,
  noSelect,
  fns: fns2,
  publicURI
}) => {
  const activePanel = fns2.parseAdminDomainState().activePanel;
  const defState = {
    _isLoading: false,
    _id: fns2.parseAdminDomainState().id ? fns2.parseAdminDomainState().id : null
  };
  const [state, setState] = React29.useState(defState);
  state._items = items.map((fn) => fn(state, setState));
  const [colNum, setColNum] = React29.useState(cols);
  const resize = (n) => {
    if (n < 768)
      setColNum(1);
    else if (n < 1280)
      setColNum(2);
    else
      setColNum(cols);
  };
  const rows = [];
  let row = [];
  for (let i = 0; i < state._items.length; i++) {
    state[`_waitingItems${state._items[i].bound}`] = false;
    if (state._items.bound && state._items[i].boundOpen)
      state[`_showingItems${state._items[i].bound}`] = true;
    if (i % colNum === 0 && i > 0) {
      rows.push(/* @__PURE__ */ jsx57("tr", { children: row }));
      row = [];
    }
    const map = {};
    row.push(
      /* @__PURE__ */ jsxs32(
        item_default,
        {
          managed: state._items[i].managed,
          D,
          Bttn,
          Picklist: picklist_default,
          Styles: styles_default9,
          listquery: state._items[i].listquery,
          fns: fns2,
          constrain: state._items[i].constrain,
          title: state._items[i].title,
          state,
          backgroundImg: state._items[i].backgroundImg,
          setState: (s) => setState(s),
          onCreate: state._items[i].onCreate,
          onSubmit: state._items[i].onSubmit,
          onUpdate: state._items[i].onUpdate,
          onDelete: state._items[i].onDelete,
          onUpload: state._items[i].onUpload,
          onReplace: state._items[i].onReplace,
          onBack: state._items[i].onBack,
          onAddField: state._items[i].onAddField,
          onExecute: state._items[i].onExecute,
          onRecursiveInit: state._items[i].onRecursiveInit,
          onLog: state._items[i].onLog,
          onPublicRead: state._items[i].onPublicRead,
          onPublicCreate: state._items[i].onPublicCreate,
          onPublicEdit: state._items[i].onPublicEdit,
          onPublicDelete: state._items[i].onPublicDelete,
          onOwnerRead: state._items[i].onOwnerRead,
          onOwnerCreate: state._items[i].onOwnerCreate,
          onOwnerEdit: state._items[i].onOwnerEdit,
          onOwnerDelete: state._items[i].onOwnerDelete,
          onAccessType: state._items[i].onAccessType,
          onScript: state._items[i].onScript,
          active: state._items[i].bound ? state[`_showingItems${state._items[i].bound}`] : cols === 0 ? activePanel === i : true,
          children: [
            state._items[i].bound ? /* @__PURE__ */ jsx57(
              fontawesome_default,
              {
                size: "lg",
                icon: "chain",
                className: `arclight-absolute arclight-top-5 arclight-right-5 lg:arclight-top-10 lg:arclight-right-10`
              }
            ) : null,
            state._items[i].controls ? state._items[i].controls.map((c, i2) => {
              return controlselector_default({
                c,
                D,
                state,
                searchOn,
                i: i2,
                setState,
                fns: fns2,
                Bttn,
                publicURI
              });
            }) : null
          ]
        }
      )
    );
  }
  if (row && row.length > 0)
    rows.push(/* @__PURE__ */ jsx57("tr", { children: row }));
  React29.useEffect(() => {
    if (callresolved) {
      if (callresolved > 1) {
        if (callresolved === 2) {
          fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
            activePanel: fns2.parseAdminDomainState().activePanel - 1
          }));
        }
        if (state._primemodal) {
          state._primemodal(D);
        } else {
          fns2.setModal(null);
        }
      }
      setState((_) => __spreadProps(__spreadValues({}, _), {
        _id: callresolved < 2 ? _._id : null,
        _isLoading: false,
        _primemodal: void 0
      }));
    }
  }, [callresolved]);
  React29.useEffect(() => {
    resize(window.innerWidth);
    window.addEventListener("resize", (n) => {
      const _ = n.currentTarget.innerWidth;
      resize(_);
    });
  }, []);
  return /* @__PURE__ */ jsxs32(
    styles_default9.Container,
    {
      className: `arclight-p-2 ${state._isLoading ? "arclight-pointer-events-none" : null}`,
      children: [
        !state._isLoading && rows && row && row.length ? /* @__PURE__ */ jsx57(
          styles_default9.Table,
          {
            className: `arclight-h-full arclight-text-text-primary arclight-font-primary`,
            children: /* @__PURE__ */ jsx57("tbody", { children: rows })
          }
        ) : noSelect ? /* @__PURE__ */ jsx57(
          styles_default9.NoSelect,
          {
            className: `arclight-relative`,
            mountAnim: { anim: "fadeIn", duration: "0.5s" },
            children: /* @__PURE__ */ jsx57(
              "div",
              {
                className: `arclight-w-full arclight-h-full arclight-flex arclight-align-middle arclight-items-center`
              }
            )
          }
        ) : null,
        /* @__PURE__ */ jsx57(loader_default, { loading: state._isLoading })
      ]
    }
  );
};
var flexpanel_default = FlexPanel;

// src/components/page/styles.js
import styled29 from "styled-components";
var Container28 = styled29.div``;
var Body7 = styled29.div`
	position: relative;
	min-height: 100vh;
`;
var styles_default29 = {
  Container: Container28,
  Body: Body7
};

// src/components/page/index.tsx
import { jsx as jsx58, jsxs as jsxs33 } from "react/jsx-runtime";
var Page = ({
  fns: fns2,
  backgroundImage,
  children,
  backgroundGradient,
  endpoint
}) => {
  const type2 = (backgroundImage == null ? void 0 : backgroundImage.src) && backgroundImage.src.match(/\.[0-9a-z]+$/i) ? (
    //@ts-ignore
    backgroundImage.src.match(/\.[0-9a-z]+$/i)[0]
  ) : null;
  return /* @__PURE__ */ jsxs33(styles_default29.Container, { children: [
    backgroundImage && type2 ? backgroundImage && (type2 === ".webm" || type2 === ".mp4") ? /* @__PURE__ */ jsx58(
      "video",
      {
        autoPlay: true,
        muted: true,
        loop: true,
        src: backgroundImage.src,
        className: `arclight-w-full arclight-h-full arclight-fixed arclight-object-cover`,
        style: { opacity: backgroundImage.opacity }
      }
    ) : /* @__PURE__ */ jsx58(
      "img",
      {
        src: backgroundImage.src,
        className: `arclight-w-full arclight-h-full arclight-fixed arclight-object-cover`,
        style: { opacity: backgroundImage.opacity }
      }
    ) : void 0,
    backgroundGradient ? /* @__PURE__ */ jsx58(
      "div",
      {
        className: `arclight-w-full arclight-h-full arclight-fixed arclight-object-cover arclight-bg-gradient-to-b arclight-from-[${backgroundGradient.to}] arclight-bg-gradient-to-t arclight-to-[${backgroundGradient.from}]`
      }
    ) : void 0,
    /* @__PURE__ */ jsx58(styles_default29.Body, { children })
  ] });
};
var page_default = Page;

// src/components/fileloader/index.tsx
import React30 from "react";

// src/components/fileloader/styles.js
import styled30 from "styled-components";
var Container29 = styled30.div``;
var styles_default30 = {
  Container: Container29
};

// src/components/fileloader/index.tsx
import { jsx as jsx59, jsxs as jsxs34 } from "react/jsx-runtime";
var FileLoader = ({ fns: fns2, D, operation, id }) => {
  const inputRef = React30.useRef(null);
  const MAX_HEIGHT = 72;
  const [previewUrl, setPreviewUrl] = React30.useState(null);
  const [file, setFile] = React30.useState(null);
  const [filename, setFilename] = React30.useState(null);
  const determineType = (s, url) => {
    const className = `arclight-w-full arclight-object-cover`;
    if (s === "image/jpeg" || s === "image/png")
      return /* @__PURE__ */ jsx59("img", { src: previewUrl, className });
    else if (s === "video/mp4")
      return /* @__PURE__ */ jsx59("video", { autoPlay: true, loop: true, muted: true, src: previewUrl, className });
  };
  return /* @__PURE__ */ jsxs34(
    styles_default30.Container,
    {
      className: `arclight-w-full arclight-p-10 arclight-flex-col arclight-space-y-5`,
      children: [
        /* @__PURE__ */ jsxs34(
          "div",
          {
            className: `arclight-rounded-md arclight-overflow-hidden arclight-max-h-${MAX_HEIGHT} arclight-relative`,
            children: [
              previewUrl && file ? determineType(file.type, previewUrl) : /* @__PURE__ */ jsx59(
                "div",
                {
                  className: `arclight-w-full arclight-h-${MAX_HEIGHT} arclight-bg-background-primary arclight-flex arclight-items-center arclight-justify-center arclight-p-10`,
                  children: /* @__PURE__ */ jsx59(
                    "div",
                    {
                      className: `arclight-border-[1px] arclight-rounded-full arclight-w-44 arclight-h-44 arclight-flex arclight-items-center arclight-justify-center`,
                      children: /* @__PURE__ */ jsx59(fontawesome_default, { size: "4x", icon: "cloud-arrow-up" })
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx59(
                "input",
                {
                  type: "file",
                  ref: inputRef,
                  className: `arclight-opacity-0 arclight-absolute arclight-top-0 arclight-left-0 arclight-w-full arclight-h-full arclight-cursor-pointer`,
                  onChange: (event) => {
                    setPreviewUrl(URL.createObjectURL(event.target.files[0]));
                    setFile(event.target.files[0]);
                    setFilename(event.target.files[0].name);
                  }
                }
              )
            ]
          }
        ),
        file && filename ? /* @__PURE__ */ jsx59(
          textfield_default,
          {
            span: true,
            hot: true,
            defaultValue: filename,
            onChange: (e) => setFilename(e.target.value),
            type: "text",
            label: "Name",
            variant: "standard"
          },
          0
        ) : null,
        /* @__PURE__ */ jsx59(
          button_default,
          {
            span: true,
            disabled: !file,
            className: ``,
            label: "Submit",
            type: "button",
            size: "normal",
            animation: true,
            onClick: () => {
              if (!(fns2 == null ? void 0 : fns2.calls) || !fns2.calls[`${operation}records_media`])
                return;
              try {
                fns2.calls[`${operation}records_media`]({
                  _id: id ? id : void 0,
                  nopanelchange: operation === "update" ? !id : true,
                  filename,
                  file
                });
              } catch (e) {
                console.log(e);
              }
            }
          }
        )
      ]
    }
  );
};
var fileloader_default = FileLoader;

// src/components/admin/flexpanel/components/fileloader.tsx
import { jsx as jsx60 } from "react/jsx-runtime";
var fileloader_default2 = (state, setState, D, fns2, operation) => {
  return /* @__PURE__ */ jsx60(
    "div",
    {
      className: `arclight-w-full arclight-h-full arclight-flex arclight-justify-center arclight-items-center`,
      children: /* @__PURE__ */ jsx60(fileloader_default, { fns: fns2, D, operation, id: state._id })
    }
  );
};

// src/components/admin/panels/database/listpanel.ts
var listpanel_default3 = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => {
  var _a;
  return {
    listquery: (type2, _id) => {
      if (fns2.calls && fns2.calls[`getrecords_${type2}`]) {
        fns2.calls[`getrecords_${type2}`]({
          search: { _id }
        });
      }
    },
    title: `${xFormKey2(key.replace(/_/g, ""))}`,
    backgroundImg: D && D.getdatamodels && D.getdatamodels.records && key !== "model" ? D.getdatamodels.records.find((m) => m._type === key).metaimg : `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
    controls: [
      {
        onClick: (el) => {
          updateState((_) => ({
            _id: el._id
          }));
          fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
            activePanel: key === "article" ? 3 : 1,
            id: el._id
          }));
        },
        type: "ListPanel",
        label: "Search"
      }
    ],
    onCreate: key !== "media" && ((_a = D == null ? void 0 : D.getdatamodels) == null ? void 0 : _a.records) && key !== "permissions" && (key !== "model" ? fns2 && fns2.calls && fns2.calls[`createrecords_${key}`] : true) ? () => {
      D.getdatamodels.records = D.getdatamodels.records.concat({
        _type: "model",
        type: "",
        text: "",
        icon: "",
        subicon: "",
        metaimg: "",
        category: ""
      });
      updateState((_) => ({
        _id: null
      }));
      fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
        _id: null,
        activePanel: key === "article" ? 3 : 1
      }));
    } : null,
    onUpload: key === "media" && (fns2 == null ? void 0 : fns2.calls) && fns2.calls[`createrecords_${key}`] ? () => {
      fns2.setModal({
        noescape: true,
        mode: "full",
        bgImg: ``,
        body: () => fileloader_default2(currentState, updateState, D, fns2, "create")
      });
    } : null
  };
};

// src/components/admin/panels/database/recordpanel.ts
var recordpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  managed: (() => {
    if (D && D.getdatamodels && D.getdatamodels.records && currentState._id) {
      if (key === "model") {
        const o = D.getdatamodels.records.find(
          (el) => el._id === currentState._id
        );
        if (o)
          return o._managed;
      } else if (D[`getrecords_${key}`] && D[`getrecords_${key}`].init) {
        const o = D[`getrecords_${key}`].init.records.find(
          (el) => el._id === currentState._id
        );
        if (o)
          return o._managed;
      }
    }
  })(),
  title: currentState._id && D.getdatamodels && D.getdatamodels.records ? `${xFormKey2(key.replace(/_/g, "")).slice(0, -1)}: ${(() => {
    const value = D.getdatamodels.records.find(
      (el) => el._id === currentState._id
    );
    const value2 = D[`getrecords_${key}`];
    return key === "model" && value && value.text ? value.text : value2 && value2.init ? setTitle2(
      D[`getrecords_${key}`].init.records.find(
        (el) => el._id === currentState._id
      )
    ) : "";
  })().replace("*", "(Integration) ")}` : `Create ${xFormKey2(key.replace(/_/g, ""))}`,
  backgroundImg: (() => {
    if (D && D.getdatamodels && D.getdatamodels.records && currentState._id) {
      if (key === "model") {
        const o = D.getdatamodels.records.find(
          (el) => el._id === currentState._id
        );
        if (o)
          return o.metaimg;
      } else if (D[`getrecords_${key}`] && D[`getrecords_${key}`].init) {
        const o = D[`getrecords_${key}`].init.records.find(
          (el) => el._id === currentState._id
        );
        if (o)
          return o.img;
      }
    }
  })(),
  controls: Constructors.constructFromDataModel(
    (() => {
      if (D && D.getdatamodels && D.getdatamodels.records) {
        const t = D.getdatamodels.records.find(
          (el) => key === "model" ? el._id === currentState._id : el._type === key
        );
        if (t && t._type)
          return t._type;
      }
      return key;
    })(),
    key === "model",
    D[`getrecords_${key}`] && key === "permissions" && D[`getrecords_${key}`].init ? {
      key,
      type: D[`getrecords_${key}`].init.records.find(
        (el) => el._id === currentState._id
      )
    } : null
  ),
  [currentState._id ? "onUpdate" : "onCreate"]: fns2.calls[`${currentState._id ? "update" : "create"}${key === "model" ? "datamodels" : `records_${key}`}`] ? () => {
    try {
      delete currentState._items;
      if (currentState.MonacoRef) {
        const MonacoRef = currentState.MonacoRef;
        delete currentState.MonacoRef;
        Object.keys(MonacoRef).map(
          (k) => currentState[k] = JSON.stringify(
            JSON.parse(MonacoRef[k].current.getValue())
          )
        );
      }
      delete currentState.Article;
      fns2.calls[`${currentState._id ? "update" : "create"}${key === "model" ? "datamodels" : `records_${key}`}`](currentState);
      updateState((_) => __spreadProps(__spreadValues({}, _), {
        _isLoading: true
      }));
    } catch (e) {
      console.log(e);
    }
  } : null,
  onReplace: key === "media" && (fns2 == null ? void 0 : fns2.calls) && fns2.calls[`updaterecords_${key}`] ? () => {
    fns2.setModal({
      noescape: true,
      mode: "full",
      bgImg: ``,
      body: () => fileloader_default2(currentState, updateState, D, fns2, "update")
    });
  } : null,
  onPublicRead: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    publicread: !_.publicread
  })) : null,
  onPublicCreate: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    publiccreate: !_.publiccreate
  })) : null,
  onPublicEdit: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    publicedit: !_.publicedit
  })) : null,
  onPublicDelete: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    publicdelete: !_.publicdelete
  })) : null,
  onOwnerRead: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    ownerread: !_.ownerread
  })) : null,
  onOwnerCreate: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    ownercreate: !_.ownercreate
  })) : null,
  onOwnerEdit: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    owneredit: !_.owneredit
  })) : null,
  onOwnerDelete: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    ownerdelete: !_.ownerdelete
  })) : null,
  onAccessType: key === "endpoint" ? (accesstype) => updateState((_) => __spreadProps(__spreadValues({}, _), {
    accesstype
  })) : null,
  onScript: key === "endpoint" ? (script) => updateState((_) => __spreadProps(__spreadValues({}, _), {
    script
  })) : null,
  onRecursiveInit: key === "permissions" ? () => updateState((_) => __spreadProps(__spreadValues({}, _), {
    recursiveinit: !_.recursiveinit
  })) : null,
  onAddField: key === "model" ? () => {
    const model = D.getdatamodels.records.find(
      (el) => el._id === currentState._id
    );
    if (model) {
      model["new_key"] = {
        _type: "String",
        unique: false,
        required: false
      };
      updateState((_) => __spreadValues({}, _));
    }
  } : null,
  onDelete: currentState._id && !isProtectedRecord2(currentState) && !currentState._system && (key !== "model" ? fns2 && fns2.calls && fns2.calls[`deleterecords_${key}`] : true) ? () => {
    delete currentState._items;
    fns2.calls[key === "model" ? "deletedatamodels" : `deleterecords_${key}`](currentState);
    updateState((_) => __spreadProps(__spreadValues({}, _), {
      _isLoading: true
    }));
  } : null,
  onBack: () => {
    const _ = fns2.parseAdminDomainState().item;
    fns2.calls[_ === "model" ? "getdatamodels" : `getrecords_${_}`]({
      search: { limit: 32 }
    });
    fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 0
    }));
  }
});

// src/components/admin/panels/database/eventschedulerpanel.ts
var eventschedulerpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `Events`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [
    {
      type: "Calendar",
      label: "Search"
    }
  ]
});

// src/components/admin/panels/database/articlepanel.ts
var articlepanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: currentState._id ? `Edit Article` : `Create Article`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [
    {
      type: "ArticlePage",
      label: "Article"
    }
  ],
  [currentState._id ? "onUpdate" : "onCreate"]: () => {
    if (!(fns2 && fns2.calls && fns2.calls[`createrecords_${key}`]))
      return;
    fns2.calls[`${currentState._id ? "update" : "create"}${`records_${key}`}`](
      currentState[`Article`]
    );
    updateState((_) => __spreadProps(__spreadValues({}, _), {
      _isLoading: true
    }));
    fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 1
    }));
  },
  onDelete: currentState._id && !currentState._system && fns2 && fns2.calls && fns2.calls[`deleterecords_${key}`] ? () => {
    delete currentState._items;
    fns2.calls[`deleterecords_${key}`](currentState);
    updateState((_) => __spreadProps(__spreadValues({}, _), {
      _isLoading: true
    }));
    fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 1
    }));
  } : null,
  onBack: () => {
    const _ = fns2.parseAdminDomainState().item;
    fns2.calls[`getrecords_${_}`]({
      search: { limit: 32 }
    });
    fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 0
    }));
  }
});

// src/components/admin/panels/forms/listpanel.ts
var listpanel_default4 = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `${xFormKey2(key.replace(/_/g, ""))}`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [
    {
      type: "FormSelector",
      label: "Search"
    }
  ],
  onCreate: !fns2.parseAdminDomainState().activePanel && fns2.parseAdminDomainState().item === "Form" || !fns2.calls.createformtemplates ? null : () => null,
  onBack: fns2.parseAdminDomainState().activePanel ? () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
    activePanel: 0,
    formname: void 0,
    formtemplate: void 0
  })) : null
});

// src/components/admin/panels/forms/formpanel.ts
var formpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  // title: `${xFormKey(key.replace(/_/g, ""))}`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: D && D.getformtemplates && D.getformtemplates.records ? [
    {
      type: "Application",
      label: "Search"
    }
  ] : [],
  onBack: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
    activePanel: fns2.parseAdminDomainState().item === "Form" ? 1 : 0,
    formname: void 0
  }))
});

// src/components/admin/panels/integration/integrationpanel.ts
var integrationpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `Integrations`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [{ type: "IntegrationSelector", label: "Search" }]
});

// src/components/admin/panels/integration/configurationpanel.ts
var configurationpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `${fns2.parseAdminDomainState().integration}`,
  backgroundImg: `${endpoint}/static/defaultart/integration.jpg`,
  controls: [
    { type: "IntegrationMonaco", label: "Search", onClick: () => null }
  ],
  onUpdate: () => {
    return fns2.calls.updateintegrations({
      integration: fns2.parseAdminDomainState().integration,
      value: currentState.MonacoRef.Integration.current.getValue()
    });
  },
  onBack: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
    integration: void 0,
    activePanel: 0
  }))
});

// src/components/admin/panels/scripts/scriptspanel.ts
var scriptspanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `Scripts`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [
    {
      cards: [
        "before-get",
        "after-get",
        "before-update",
        "after-update",
        "before-create",
        "after-create",
        "before-delete",
        "after-delete",
        "custom-call",
        "custom-call-admin",
        "endpoint",
        "universal"
      ].map((k) => ({
        img: `https://highmountainlabs.io/cdn/arclight/media/js-c.jpg`,
        name: k,
        onClick: () => {
          fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
            activePanel: 1,
            script: k
          }));
        }
      })),
      type: "ListPanel",
      label: "Search"
    }
  ]
});

// src/components/admin/panels/scripts/categorypanel.ts
var categorypanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `(${fns2.parseAdminDomainState().script}) Scripts`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: D && D.getscripts && fns2.parseAdminDomainState().script ? [
    {
      cards: D.getscripts.records[fns2.parseAdminDomainState().script] ? Object.keys(
        D.getscripts.records[fns2.parseAdminDomainState().script]
      ).map((k) => {
        return {
          img: `https://highmountainlabs.io/cdn/arclight/media/${JSON.parse(
            D.getscripts.records[fns2.parseAdminDomainState().script][k].metadata
          ).managed ? "js-m" : "js"}.jpg`,
          name: k,
          onClick: () => {
            fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
              activePanel: 2,
              selectedscript: k
            }));
          }
        };
      }) : [],
      type: "ScriptSelector",
      label: "Search"
    }
  ] : [],
  onCreate: () => {
    fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 2,
      selectedscript: void 0
    }));
  },
  onBack: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
    activePanel: 0,
    script: void 0
  }))
});

// src/components/admin/panels/scripts/scripteditpanel.ts
var scripteditpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => {
  const ss = fns2.parseAdminDomainState().selectedscript;
  return {
    title: ss ? `Edit Script` : `Create Script`,
    backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
    controls: [{ type: "ScriptMonaco", label: "Z", onClick: () => null }],
    [ss ? `onUpdate` : `onCreate`]: () => {
      return fns2.calls[ss ? `updatescripts` : "createscripts"]({
        script: ss,
        type: currentState.scriptkey,
        ctx: fns2.parseAdminDomainState().script,
        value: currentState.MonacoRef[currentState.scriptkey ? currentState.scriptkey : "Metadata"].current.getValue()
      });
    },
    onDelete: () => {
      return fns2.calls.deletescripts({
        ctx: fns2.parseAdminDomainState().script,
        value: currentState.MonacoRef.Metadata.current.getValue()
      });
    },
    onBack: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
      activePanel: 1,
      selectedscript: void 0
    })),
    onLog: fns2.calls.getlogs ? () => fns2.calls.getlogs() : null,
    onExecute: fns2.calls.executescripts ? () => fns2.calls.executescripts(fns2.parseAdminDomainState()) : null
  };
};

// src/components/admin/panels/scripts/scriptschedulerpanel.ts
var scriptschedulerpanel_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  title: `Script Scheduler`,
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
  controls: [
    {
      type: "Calendar",
      label: "Search",
      script: true
    }
  ]
});

// src/components/admin/panels/app/approuter.ts
var approuter_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  backgroundImg: `https://highmountainlabs.io/cdn/arclight/media/riotxlol.jpg`,
  controls: [{ type: "App", label: "Search", onClick: () => null }]
});

// src/components/admin/panels/app/appfunction.ts
var appfunction_default = (xFormKey2, setTitle2, isProtectedRecord2) => (D, Constructors, fns2, key, endpoint) => (currentState, updateState) => ({
  backgroundImg: (() => {
    switch (fns2.parseAdminDomainState().subItem) {
      case "Tournament Codes":
        return `https://highmountainlabs.io/cdn/arclight/media/ionia_1.jpg`;
      case "Authenticate Summoner":
        return `https://highmountainlabs.io/cdn/arclight/media/ionia_2.png`;
      case "Import Game Data":
        return `https://highmountainlabs.io/cdn/arclight/media/ionia_3.jpg`;
    }
  })(),
  controls: [{ type: "App", label: "Search", onClick: () => null }],
  onBack: () => fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
    activePanel: 0
  }))
});

// src/components/admin/panels/index.ts
var PROTECTED_NAMES = ["administrator", "default"];
var xFormKey = (key) => `${key.slice(0, 1).toUpperCase()}${key.slice(1)}${key.slice(-1) !== "s" ? "s" : ""}`.replace("*", "(Integration) ");
var setTitle = (object) => {
  if (!object)
    return "";
  else if (object.username)
    return object.username;
  else if (object.name)
    return object.name;
  else if (object.title)
    return object.title;
  else if (object._type)
    return object._type;
  return "New";
};
var isProtectedRecord = (currentState) => {
  if (currentState) {
    for (let i = 0; i < PROTECTED_NAMES.length; i++)
      if (PROTECTED_NAMES.some(
        (el) => el === currentState.name || el === currentState.username
      ))
        return PROTECTED_NAMES;
  }
};
var Panels = {
  Database: [
    listpanel_default3,
    recordpanel_default,
    eventschedulerpanel_default,
    articlepanel_default
  ].map((panel) => panel(xFormKey, setTitle, isProtectedRecord)),
  Forms: [listpanel_default4, listpanel_default4, formpanel_default].map(
    (panel) => panel(xFormKey, setTitle, isProtectedRecord)
  ),
  Integrations: [integrationpanel_default, configurationpanel_default].map(
    (panel) => panel(xFormKey, setTitle, isProtectedRecord)
  ),
  Scripts: [
    scriptspanel_default,
    categorypanel_default,
    scripteditpanel_default,
    scriptschedulerpanel_default
  ].map((panel) => panel(xFormKey, setTitle, isProtectedRecord)),
  Apps: [approuter_default, appfunction_default].map(
    (panel) => panel(xFormKey, setTitle, isProtectedRecord)
  )
};
var panels_default2 = (D, Constructors, fns2, endpoint) => {
  const key = fns2.parseAdminDomainState().section;
  const item = fns2.parseAdminDomainState().item;
  return key && Panels[key] && item ? Panels[key].map((P) => P(D, Constructors, fns2, item, endpoint)) : [];
};

// src/components/admin/index.tsx
import { useMediaQuery as useMediaQuery2 } from "react-responsive";

// src/components/admin/draweritems/database.tsx
var database_default = (D, fns2) => (items) => {
  const Categories = { _: { items: [] } };
  if (fns2.calls && fns2.calls.getdatamodels && ["create", "update", "delete"].some(
    (el) => fns2.calls[`${el}datamodels`]
  ))
    items = items.concat({
      text: "Data Models",
      model: "model",
      icon: "database",
      subicon: "server"
    });
  items.filter(
    (entity) => entity.model === "model" || fns2.calls[`getrecords_${entity.model}`]
  ).map((entity) => {
    if (entity.category && entity.category.length && !Categories[entity.category])
      Categories[entity.category] = { icon: entity.icon, items: [] };
    Categories[entity.category && entity.category.length ? entity.category : "_"].items.push({
      italic: false,
      color: entity.model === "model" ? null : null,
      icon: entity.subicon,
      text: entity.text,
      onClick: () => {
        return fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
          activePanel: entity.model === "event" ? 2 : 0,
          item: entity.model
        }));
      }
    });
  });
  return Object.keys(Categories).filter((k) => k !== "_").map((text) => ({
    italic: true,
    color: null,
    icon: Categories[text].icon,
    text,
    items: Categories[text].items,
    onClick: () => {
    }
  })).concat(Categories._.items);
};

// src/components/admin/indexitems/database.ts
var database_default2 = (D, fns2) => {
  const Items = database_default(
    D,
    fns2
  )(
    D && D.getdatamodels && D.getdatamodels.records && Array.isArray(D.getdatamodels.records) ? D.getdatamodels.records.map(
      (el) => Object.assign({ model: el._type }, el)
    ) : []
  );
  return {
    items: Items,
    icon: "toilet-portable",
    text: "Database",
    cond: Items.length
  };
};

// src/components/admin/draweritems/integration.tsx
var integration_default = (D, fns2) => (items) => {
  return items.map((entity) => ({
    italic: true,
    isExpanded: fns2.parseAdminDomainState()[entity.integration],
    icon: entity.icon,
    text: entity.text,
    onClick: () => {
      return fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
        activePanel: 0,
        item: entity.integration
      }));
    }
  }));
};

// src/components/admin/indexitems/integration.ts
var integration_default2 = (D, fns2) => {
  const Items = integration_default(
    D,
    fns2
  )(
    D && D.getdatamodels && D.getdatamodels.records && Array.isArray(D.getdatamodels.records) && fns2.calls.getintegrations ? [{ icon: "bolt", text: "Integrations", integration: "integrations" }] : []
  );
  return {
    items: Items,
    icon: "cloud-bolt",
    text: "Integrations",
    cond: Items.length
  };
};

// src/components/admin/draweritems/scripts.tsx
var scripts_default = (D, fns2) => (items) => {
  return items.map((entity) => ({
    italic: true,
    isExpanded: fns2.parseAdminDomainState()[entity.script],
    icon: entity.icon,
    text: entity.text,
    onClick: () => {
      return fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
        activePanel: entity.type ? 3 : 0,
        item: entity.script || entity.type,
        script: void 0
      }));
    }
  }));
};

// src/components/admin/indexitems/script.ts
var script_default = (D, fns2) => {
  var _a, _b;
  const Items = scripts_default(
    D,
    fns2
  )(
    ((_a = D == null ? void 0 : D.getdatamodels) == null ? void 0 : _a.records) && Array.isArray(D.getdatamodels.records) && ((_b = fns2 == null ? void 0 : fns2.calls) == null ? void 0 : _b.getscripts) ? [
      { icon: "calendar", text: "Scheduler", type: "scriptcalendar" },
      { icon: "node-js", text: "Scripts", script: "scripts" }
    ] : []
  );
  return {
    items: Items,
    icon: "node",
    text: "Scripts",
    cond: Items.length
  };
};

// src/components/admin/draweritems/form.tsx
var form_default = (D, fns2) => (items) => {
  return items.map((entity) => ({
    italic: true,
    isExpanded: entity ? fns2.parseAdminDomainState()[entity.form] : void 0,
    icon: entity ? entity.icon : void 0,
    text: entity ? entity.text : void 0,
    onClick: () => {
      if (!entity)
        return;
      return fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
        activePanel: 0,
        item: entity.form,
        formtemplate: void 0,
        formname: void 0
      }));
    }
  }));
};

// src/components/admin/indexitems/formsitems.ts
var formsitems_default = (D, fns2) => {
  const Items = form_default(
    D,
    fns2
  )(
    // remove false flag to restore
    false ? [
      fns2.calls.getforms ? { icon: "folder-open", text: "Forms", form: "Form" } : void 0,
      fns2.calls.getformtemplates ? {
        icon: "file-contract",
        text: "Form Templates",
        form: "Form Template"
      } : void 0
    ] : []
  );
  return {
    items: Items,
    icon: "tablet",
    text: "Forms",
    cond: Items.length
  };
};

// src/components/admin/draweritems/app.tsx
var app_default2 = (D, fns2) => (items) => {
  return items.map((entity) => ({
    italic: true,
    isExpanded: fns2.parseAdminDomainState()[entity.app],
    icon: entity.icon,
    text: entity.text,
    onClick: () => {
      return fns2.setAdminDomainState(__spreadProps(__spreadValues({}, fns2.parseAdminDomainState()), {
        activePanel: 0,
        item: entity.app
      }));
    }
  }));
};

// src/components/admin/indexitems/app.ts
var app_default3 = (D, fns2) => {
  const Items = app_default2(
    D,
    fns2
  )(
    fns2.calls && fns2.calls["update(M) LoL Tournament APIs"] ? [
      {
        icon: "diamond",
        text: "LoL Tournament API",
        app: "LoL Tournament API"
      }
    ] : []
  );
  return {
    items: Items,
    icon: "superpowers",
    text: "Apps",
    cond: Items.length
  };
};

// src/components/admin/stfns/constructfromrecordlist.ts
var constructfromrecordlist_default = (D) => (type2) => {
  if (D) {
    if (type2 === "model" && D[`getdatamodels`] && D[`getdatamodels`].records)
      return D[`getdatamodels`].records;
    else if (D[`getrecords_${type2}`] && D[`getrecords_${type2}`].records)
      return D[`getrecords_${type2}`][type2].records;
    else
      return [];
  }
  return [];
};

// src/components/admin/stfns/constructfromdatamodel.ts
var constructfromdatamodel_default = (D) => (type2, isModel, specials) => {
  const lookup = (value) => {
    if (value !== null) {
      const t = typeof value;
      if (t === "object") {
        if (isModel) {
          return "DynamicField";
        }
        if (value._type === "Number")
          return "TextFieldNumber";
        else if (value._type === "String" && value.lookup)
          return "SinglePickList";
        else if (value._type === "Array")
          return "PickList";
        else if (value._type === "String")
          return "TextField";
        else if (value._type === "Boolean")
          return "Boolean";
        else if (value._type === "Date")
          return "Date";
        else if (value._type === "JSON")
          return "Monaco";
      } else if (t === "string") {
        if (isModel) {
          return "TextField";
        }
      }
    }
  };
  const _specials = (k) => {
    if (!specials || !specials.type)
      return false;
    if (specials.key === "permissions" && specials.type.name !== "script" && k === "execute")
      return true;
  };
  if (D && D.getdatamodels && D.getdatamodels.records) {
    const fieldsObj = D.getdatamodels.records.find(
      (dm) => dm._type === type2
    );
    return fieldsObj ? Object.keys(fieldsObj).filter((k) => !(k.slice(0, 1) === "_" || _specials(k))).map((k) => {
      const _ = D.getdatamodels.records.find(
        (dm) => dm._type === type2
      )[k];
      return {
        searchkey: _ ? D.getdatamodels.records.find(
          (dm) => dm._type === _.lookup
        ) : void 0,
        lookup: _ && _.lookup ? _.lookup : null,
        adminlookup: _ && _.adminlookup ? _.adminlookup : null,
        D,
        type: lookup(fieldsObj[k]),
        label: k,
        required: false
      };
    }) : [];
  }
  return [];
};

// src/components/admin/stfns/parsecode.ts
var parsecode_default = (D) => {
  if (D && D.serversuccess) {
    if (D.serversuccess.includes("210")) {
      return 3;
    } else if (D.serversuccess.includes("201") || D.serversuccess.includes("202") || D.serversuccess.includes("203")) {
      return 2;
    }
  }
  return 1;
};

// src/components/admin/index.tsx
import { jsx as jsx61, jsxs as jsxs35 } from "react/jsx-runtime";
var _HIDE_BREAKPOINT = "lg";
var ItemsArray = [database_default2, integration_default2, script_default, app_default3, formsitems_default];
var Admin = ({ fns: fns2, backgroundImage, authBackgroundImage, D, noSelect, endpoint }) => {
  let authenticated = false;
  const Constructors = {
    constructFromRecordList: constructfromrecordlist_default(D),
    constructFromDataModel: constructfromdatamodel_default(D)
  };
  const iArray = [];
  ItemsArray.map((fn) => {
    const _ = fn(
      D,
      fns2
    );
    if (_.cond) {
      authenticated = true;
      iArray.push(
        Object.assign(
          {
            color: "lightgray",
            italic: true,
            isExpanded: fns2.parseAdminDomainState().section === _.text,
            onClick: () => fns2.setAdminDomainState(
              fns2.parseAdminDomainState().section === _.text ? void 0 : { section: _.text }
            )
          },
          _
        )
      );
    }
  });
  return /* @__PURE__ */ jsx61(styles_default.Container, { children: /* @__PURE__ */ jsxs35(
    page_default,
    {
      fns: fns2,
      backgroundImage: {
        src: backgroundImage ? backgroundImage : `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
        opacity: 0.5
      },
      children: [
        /* @__PURE__ */ jsxs35(
          styles_default.Body,
          {
            className: `arclight-flex arclight-flex-row xs:max-${_HIDE_BREAKPOINT}:arclight-hidden`,
            children: [
              /* @__PURE__ */ jsx61(
                styles_default.Drawer,
                {
                  className: `arclight-block ${!authenticated ? "arclight-hidden" : ""}`,
                  children: /* @__PURE__ */ jsx61(
                    drawer_default,
                    {
                      autoSort: true,
                      headerImg: useMediaQuery2({ query: "(min-width: 1024px)" }) ? noSelect ? noSelect : `https://highmountainlabs.io/cdn/arclight/media/highmountainlabs.png` : void 0,
                      startOpen: useMediaQuery2({ query: "(min-width: 1024px)" }),
                      locked: useMediaQuery2({ query: "(min-width: 1024px)" }),
                      animation: "slide",
                      buttonSide: "left",
                      side: "left",
                      items: iArray.sort(
                        (a, b) => a.text < b.text ? -1 : 1
                      ),
                      signOut: () => fns2.signOut()
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsxs35(styles_default.Content, { children: [
                !authenticated ? /* @__PURE__ */ jsx61(
                  authpage_default,
                  {
                    headless: true,
                    disableNewRegistration: true,
                    fns: fns2,
                    D,
                    authBackgroundImage: authBackgroundImage ? authBackgroundImage : `https://highmountainlabs.io/cdn/arclight/media/hml.jpg`,
                    OATHOnly: false,
                    OATH: [
                      {
                        type: "discord",
                        onClick: () => fns2.calls && fns2.calls.DiscordOATH2 ? fns2.calls.DiscordOATH2({
                          domain: fns2.readState().subdomain
                        }) : null
                      }
                    ]
                  }
                ) : null,
                authenticated && Object.keys(fns2.calls).length ? /* @__PURE__ */ jsx61(
                  flexpanel_default,
                  {
                    publicURI: endpoint,
                    fns: fns2,
                    noSelect: true,
                    D,
                    searchOn: fns2.parseAdminDomainState().item,
                    callresolved: (D == null ? void 0 : D.serversuccess) || (D == null ? void 0 : D.servererror) || (D == null ? void 0 : D.serverwarning) || (D == null ? void 0 : D.servermessage) ? parsecode_default(D) : 0,
                    cols: 0,
                    items: panels_default2(D, Constructors, fns2, endpoint)
                  }
                ) : null
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxs35(
          "div",
          {
            className: `${_HIDE_BREAKPOINT}:arclight-hidden arclight-absolute arclight-left-1/2 arclight-top-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2`,
            children: [
              /* @__PURE__ */ jsx61("div", { className: `arclight-flex arclight-justify-center`, children: /* @__PURE__ */ jsx61(
                "img",
                {
                  src: `https://highmountainlabs.io/cdn/arclight/media/highmountainlabs.png`,
                  className: `arclight-w-44`
                }
              ) }),
              /* @__PURE__ */ jsx61("div", { className: `arclight-flex arclight-justify-center`, children: /* @__PURE__ */ jsx61("div", { className: `arclight-mx-10 arclight-text-lg arclight-w-64`, children: "Arclight does not currently support this viewport." }) })
            ]
          }
        )
      ]
    }
  ) });
};
var admin_default = { default: Admin };

// src/components/app/index.tsx
import { io } from "socket.io-client";
import React33 from "react";
import Cookies from "universal-cookie";

// src/components/snack/index.tsx
import { Snackbar } from "@material-ui/core";
import { Alert as MuiAlert } from "@mui/material";
import React31 from "react";

// src/components/snack/styles.js
import styled31 from "styled-components";
var Container30 = styled31.div``;
var styles_default31 = {
  Container: Container30
};

// src/components/snack/index.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
var Alert = React31.forwardRef(function Alert2(props, ref) {
  return /* @__PURE__ */ jsx62(MuiAlert, __spreadValues({ elevation: 6, ref, variant: "filled" }, props));
});
var buildMessage = (D, setMessage) => {
  if (D && D.serversuccess)
    return setMessage({
      msg: D.serversuccess,
      severity: "success"
    });
  else if (D && D.servererror)
    return setMessage({
      msg: D.servererror,
      severity: "error"
    });
  else if (D && D.serverwarning)
    return setMessage({
      msg: D.serverwarning,
      severity: "warning"
    });
  else if (D && D.servermessage)
    return setMessage({
      msg: D.servermessage,
      severity: "info"
    });
};
var Snack = React31.memo(({ hide, D }) => {
  const [message, setMessage] = React31.useState({ severity: "info", msg: "" });
  React31.useEffect(
    () => buildMessage(D, setMessage),
    [
      D ? D.serversuccess : null,
      D ? D.servererror : null,
      D ? D.serverwarning : null,
      D ? D.servermessage : null
    ]
  );
  return /* @__PURE__ */ jsx62(styles_default31.Container, { children: /* @__PURE__ */ jsx62(
    Snackbar,
    {
      open: D && (D.serversuccess || D.servererror || D.serverwarning || D.servermessage),
      autoHideDuration: 6e3,
      onClose: () => hide(),
      children: /* @__PURE__ */ jsx62(Alert, { onClose: () => hide(), severity: message.severity, children: message.msg })
    }
  ) });
});
var snack_default = Snack;

// src/components/spinner/index.tsx
import { RingLoader } from "react-spinners";

// src/components/spinner/styles.js
import styled32 from "styled-components";
var Container31 = styled32.div`
  position: sticky;
  height: 0px;
  top: 50vh;
  z-index: 9999;
`;
var Loader2 = styled32.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
`;
var styles_default32 = {
  Container: Container31,
  Loader: Loader2
};

// src/components/spinner/index.tsx
import { jsx as jsx63 } from "react/jsx-runtime";
var Spinner = ({ loader, opacity }) => {
  return /* @__PURE__ */ jsx63(
    styles_default32.Container,
    {
      className: `arclight-opacity-${opacity} arclight-duration-700 arclight-transition-all arclight-pointer-events-none`,
      children: /* @__PURE__ */ jsx63(styles_default32.Loader, { children: /* @__PURE__ */ jsx63(RingLoader, { color: "rgb(3, 252, 194)", loading: true, size: 175 }) })
    }
  );
};
var spinner_default = Spinner;

// src/components/modal/index.tsx
import React32 from "react";

// src/components/modal/styles.js
import styled33 from "styled-components";
var Container32 = styled33.div`
  position: fixed;
  width: 100%;
  height: 100%;
`;
var Element = styled33.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
var Backdrop = styled33.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
`;
var styles_default33 = {
  Container: Container32,
  Element,
  Backdrop
};

// src/components/modal/index.tsx
import { jsx as jsx64, jsxs as jsxs36 } from "react/jsx-runtime";
var Modal = ({
  defaultBackground,
  modal,
  setModal,
  preloadModal,
  fns: fns2,
  D
}) => {
  let Body9;
  if (modal && modal.body)
    Body9 = modal.body;
  const [exitButton, setExitButton] = React32.useState(true);
  React32.useEffect(() => fns2.scrollLock(modal.active ? true : false), [modal]);
  const [activeEvent, setActiveEvent] = React32.useState(0);
  return /* @__PURE__ */ jsx64(
    "div",
    {
      className: `arclight-absolute arclight-top-0 ${modal.active ? `arclight-opacity-100` : `arclight-opacity-0`} arclight-transition-all arclight-duration-300 arclight-z-[9999]`,
      style: {
        pointerEvents: !modal.active ? "none" : "auto"
      },
      children: /* @__PURE__ */ jsxs36(styles_default33.Container, { children: [
        /* @__PURE__ */ jsx64(
          styles_default33.Backdrop,
          {
            onClick: () => !modal.noescape ? setModal(null) : null,
            className: `arclight-bg-visibility-primary`
          }
        ),
        /* @__PURE__ */ jsx64(
          styles_default33.Element,
          {
            className: `arclight-flex arclight-justify-center relative`,
            children: /* @__PURE__ */ jsx64(
              card_default,
              {
                modal: true,
                exitButton: exitButton ? () => {
                  setActiveEvent(0);
                  setModal(null);
                } : void 0,
                mountAnim: {
                  anim: modal ? "zoomIn" : "zoomOut",
                  duration: "0.25s",
                  delay: `0s`
                },
                hover: {
                  onMouseEnter: () => {
                  },
                  onMouseLeave: () => {
                  }
                },
                bgImg: modal && modal.bgImg ? modal.bgImg : defaultBackground,
                bodyComponent: (modal == null ? void 0 : modal.body) ? /* @__PURE__ */ jsxs36("div", { className: `relative arclight-w-full arclight-h-full`, children: [
                  modal.events && modal.events.length ? /* @__PURE__ */ jsxs36(
                    "div",
                    {
                      className: `arclight-bg-background-primary arclight-absolute arclight-left-0 arclight-top-3 -arclight-translate-x-44 arclight-w-40 flex-col arclight-space-y-1 arclight-border-0 arclight-rounded arclight-pr-6`,
                      children: [
                        /* @__PURE__ */ jsx64("div", { className: `arclight-text-lg`, children: "Events" }),
                        modal.events.map((el, i) => {
                          return /* @__PURE__ */ jsx64("div", { className: ``, children: /* @__PURE__ */ jsx64(
                            card_default,
                            {
                              className: `arclight-border-[1px] arclight-border-white arclight-rounded`,
                              active: activeEvent === i,
                              linesmall: true,
                              hover: {
                                onMouseEnter: () => {
                                },
                                onMouseLeave: () => {
                                }
                              },
                              bgImg: el.info.img,
                              bodyComponent: /* @__PURE__ */ jsx64("div", { className: `arclight-text-xs`, children: el._id ? el.info.text : "+ New Event" }),
                              onClick: () => {
                                const Body10 = (modal == null ? void 0 : modal.events) ? modal.events[i].info.body : /* @__PURE__ */ jsx64("div", {});
                                setActiveEvent(i);
                                setModal({
                                  noescape: modal.noescape,
                                  body: () => /* @__PURE__ */ jsx64(
                                    "div",
                                    {
                                      className: `arclight-flex arclight-flex-col arclight-justify-center arclight-align-middle arclight-w-full arclight-h-full arclight-rounded`,
                                      children: Body10
                                    }
                                  ),
                                  events: modal.events,
                                  bgImg: el.info.img
                                });
                              }
                            }
                          ) });
                        })
                      ]
                    }
                  ) : null,
                  /* @__PURE__ */ jsx64(
                    Body9,
                    {
                      setExitButton,
                      D,
                      fns: fns2,
                      setModal
                    }
                  )
                ] }) : null,
                onClick: () => null
              }
            )
          }
        )
      ] })
    }
  );
};
var modal_default = Modal;

// src/components/app/index.tsx
import { diff } from "deep-object-diff";

// src/components/app/styles.js
import styled34 from "styled-components";
var Container33 = styled34.div``;
var styles_default34 = {
  Container: Container33
};

// src/components/app/fns/init.ts
var init_default = (_) => (D, cb, fns2, init) => {
  if (_ && _.calls && !init) {
    if (_.calls.getdatamodels)
      _.calls.getdatamodels();
    Object.keys(_.calls).map((key) => {
      if (key.includes("recursiveinit")) {
        _.calls[key]({ _recursive: true });
      }
    });
    cb(true);
  }
};

// src/components/app/fns/parseAdminDomainState.ts
var parseAdminDomainState_default = (_) => () => {
  try {
    return _.readState().route && _.readState().route.length > 1 ? JSON.parse(atob(_.readState().route.slice(1))) : {};
  } catch (e) {
    return false;
  }
};

// src/components/app/fns/setAdminDomainState.ts
var setAdminDomainState_default = (_) => (cb) => (object) => {
  return cb(
    object && Object.keys(object).length ? btoa(JSON.stringify(object)) : "/"
  );
};

// src/components/app/fns/addAnimationFrame.ts
var addAnimationFrame_default = (_, animationFrames2) => (fn) => {
  animationFrames2.push(fn);
};

// src/components/app/fns/animate.ts
var animate = (animationFrames2) => {
};
var animate_default = (_, animationFrames2) => () => animate(animationFrames2);

// src/components/app/fns/promisify.ts
var promisify_default = (D, setD, _) => (cb) => __async(void 0, null, function* () {
  return yield cb();
});

// src/components/app/fns/getSubdomain.ts
var getSubdomain_default = (_) => () => {
  const isLocalhost = window.location.hostname.includes("localhost");
  const __ = window.location.hostname.split(".");
  return __.length > (isLocalhost ? 0 : 2) ? __[isLocalhost ? __.length - 2 : __.length - 3] : null;
};

// src/components/app/fns/joinRoom.ts
var joinRoom_default = (rooms2, _) => (socket2) => (room) => {
  if (rooms2[room])
    return;
  rooms2[room] = true;
  return socket2.emit("join", { room });
};

// src/components/app/fns/readState.ts
var readState_default = (_) => () => ({
  subdomain: _.getSubdomain(),
  route: window.location.pathname,
  query: Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  )
});

// src/components/app/fns/authenticate.ts
var authenticate_default = (_) => (socket2, fade, cb) => (obj, redirect) => __async(void 0, null, function* () {
  socket2.emit("authenticate", __spreadProps(__spreadValues({}, obj), {
    redirect
  }));
});

// src/components/app/fns/route.ts
var route_default = (_) => (setRoute, setTransitioning, transitionDuration2) => (to, subdomain, popstate) => {
  if (_.readState().route !== to || subdomain && _.readState().subdomain !== subdomain || popstate) {
    if (setTransitioning)
      setTransitioning(true);
    setTimeout(() => {
      setRoute(to);
      if (subdomain) {
        window.location.assign(
          `${window.location.protocol}//${`${subdomain}${subdomain.length > 0 ? "." : ""}`}${window.location.host}${window.location.pathname}`
        );
      } else {
        window.history.pushState(null, "", to);
      }
    }, transitionDuration2 / 3);
    if (!subdomain) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
        if (setTransitioning)
          setTransitioning(false);
      }, transitionDuration2);
    }
  }
};

// src/components/app/fns/routeExternal.ts
var routeExternal_default = (_) => (route) => window.open(route, "_blank");

// src/components/app/fns/readToken.ts
var readToken_default = (_, C) => (token) => ({
  _token: C.get(token ? token : "authtoken")
});

// src/components/app/fns/signOut.ts
var signOut_default = (_) => (S) => () => {
  S.emit("signout");
};

// src/components/app/fns/writeToken.ts
var writeToken_default = (_, C) => (token, customname) => {
  if (token)
    C.set(customname ? customname : "authtoken", token, { path: "/" });
  else {
    C.remove(customname ? customname : "authtoken", { path: "/" });
    if (!customname)
      window.location.reload();
  }
};

// src/components/app/fns/route404.ts
var route404_default = (_) => () => window.location = "/";

// src/components/app/fns/eval.ts
var ___sub = (obj, keys) => {
  const c = keys[0] ? keys[0].match(/(?:\[)(.*?)(?=\])/g) : null;
  return keys.length && keys[0] ? ___sub(c ? obj[keys[0].split("[")[0]][0] : obj[keys[0]], keys.slice(1)) : obj;
};
var eval_default = (_, D) => (o, s, fallback) => {
  const keys = s.split(".");
  try {
    const v = ___sub(o, keys.slice(1));
    return v ? v : fallback;
  } catch (e) {
    return fallback;
  }
};

// src/components/app/fns/scrolllock.ts
import {
  disableBodyScroll,
  enableBodyScroll
} from "body-scroll-lock";
var scrolllock_default = (element) => (b) => {
  return b ? disableBodyScroll(element) : enableBodyScroll(element);
};

// src/components/app/fns/verifyregisteruser.ts
var verifyregisteruser_default = (_) => (password) => {
  try {
    const q = _.readState();
    if (q && q.query && q.query.v && _.calls && _.calls.verifyregisteruser) {
      _.calls.verifyregisteruser({ v: q.query.v, password });
    }
  } catch (e) {
    return false;
  }
};

// src/components/app/fns/getCallType.ts
var getCallType_default = (s, i, local) => {
  if (local)
    return [`D.${s}`, s];
  else if (s === "model")
    return [`D.getdatamodels`, `getdatamodels`];
  else if (s === "scripts")
    return [`D.getscripts`, `getscripts`];
  else if (s === "Form")
    return [`D.getforms`, `getforms`];
  else if (s === "Form Template")
    return [`D.getformtemplates`, `getformtemplates`];
  return [`D.getrecords_${s}.${i}`, `getrecords_${s}`];
};

// src/components/app/fns/setQueryParams.ts
var setQueryParams_default = (_) => (obj) => {
  let __ = `?`;
  if (obj)
    Object.keys(obj).map((k) => __ += `${k}=${obj[k]}`);
  const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
  window.history.pushState(
    { path: newurl },
    "",
    `${newurl}${obj && Object.keys(obj).length ? __ : ""}`
  );
};

// src/components/app/fns/consumeOATH2Code.ts
var consumeOATH2Code_default = (_) => (socket2, query) => {
  if (!socket2)
    return;
  if (query.code) {
    socket2.emit("authenticate", {
      code: query.code,
      type: "Discord",
      subdomain: _.readState().subdomain,
      redirect: "/"
    });
  }
  const n = _.readState().query;
  delete n.code;
  delete n.error;
  delete n.error_description;
  _.setQueryParams(__spreadValues({}, n));
};

// src/components/app/fns/subscribe.ts
var subscribe_default = (_) => (socket2) => (event, cb) => socket2.on(event, cb);

// src/components/app/fns/index.ts
var animationFrames = [];
var rooms = {};
var fns_default = (D, setD, Cookies2, App2) => {
  const _ = {};
  _.init = init_default(_);
  _.promisify = promisify_default(D, setD, _);
  _.parseAdminDomainState = parseAdminDomainState_default(_);
  _.setAdminDomainState = setAdminDomainState_default(_);
  _.verifyRegisterUser = verifyregisteruser_default(_);
  _.animate = animate_default(_, animationFrames);
  _.addAnimationFrame = addAnimationFrame_default(_, animationFrames);
  _.getSubdomain = getSubdomain_default(_);
  _.joinRoom = joinRoom_default(rooms, _);
  _.consumeOATH2Code = consumeOATH2Code_default(_);
  _.readState = readState_default(_);
  _.authenticate = authenticate_default(_);
  _.route = route_default(_);
  _.setQueryParams = setQueryParams_default(_);
  _.routeExternal = routeExternal_default(_);
  _.readToken = readToken_default(_, new Cookies2());
  _.signOut = signOut_default(_);
  _.writeToken = writeToken_default(_, new Cookies2());
  _.e = eval_default(_, D);
  _.scrollLock = scrolllock_default(App2);
  _.route404 = route404_default(_);
  _.getCallType = getCallType_default;
  _.subscribe = subscribe_default(_);
  return _;
};

// src/components/app/index.tsx
import { jsx as jsx65, jsxs as jsxs37 } from "react/jsx-runtime";
var fns;
var socket;
var transitionDuration = 1e3;
var App = ({
  pages,
  socketEndpoint,
  nopage,
  loader,
  background
}) => {
  const AppRef = React33.useRef(null);
  let pagenotfound = true;
  const [D, _setD] = React33.useState({ nopage });
  const [LastD, setLastD] = React33.useState(void 0);
  const [app, setApp] = React33.useState(null);
  const [loading, setLoading] = React33.useState(true);
  const [transitioning, setTransitioning] = React33.useState(false);
  const [init, setInit] = React33.useState(false);
  const [modal, _setModal] = React33.useState({});
  const setD = (fn) => {
    _setD(fn);
  };
  if (!fns)
    fns = fns_default(D, setD, Cookies, AppRef);
  const [route, setRoute] = React33.useState(fns.readState().route);
  const _route = fns.route(setRoute, setTransitioning, transitionDuration);
  const setAdminDomainState = fns.setAdminDomainState(
    (_) => fns.route(setRoute, null, 0)(_, null, null)
  );
  const setModal = (M) => _setModal(M ? __spreadProps(__spreadValues({}, M), { active: true }) : __spreadProps(__spreadValues({}, modal), { active: false }));
  const preloadModal = (M) => _setModal(__spreadProps(__spreadValues({}, M), { active: false }));
  React33.useEffect(() => {
    const _diff = diff(LastD, D) || {};
    setLastD(D);
    setApp(() => /* @__PURE__ */ jsxs37(
      styles_default34.Container,
      {
        className: `arclight-relative arclight-text-text-primary arclight-font-primary`,
        ref: AppRef,
        children: [
          background ? /* @__PURE__ */ jsx65(
            "img",
            {
              src: background.src,
              className: `arclight-w-full arclight-h-full arclight-fixed arclight-object-cover`,
              style: {
                opacity: loading || transitioning ? background.opacity : 0,
                transition: `all 0.15s ease-in`
              }
            }
          ) : null,
          loader ? /* @__PURE__ */ jsx65(
            "div",
            {
              className: `arclight-sticky arclight-h-0 arclight-top-[50vh]`,
              style: {
                opacity: loading || transitioning ? 100 : 0,
                transition: `all 0.15s ease-in`
              },
              children: /* @__PURE__ */ jsx65(
                "img",
                {
                  src: loader,
                  className: `arclight-w-56 arclight-object-cover arclight-absolute arclight-top-1/2 arclight-left-1/2 -arclight-translate-x-1/2 -arclight-translate-y-1/2`
                }
              )
            }
          ) : /* @__PURE__ */ jsx65(
            spinner_default,
            {
              loader: "GridLoader",
              opacity: loading || transitioning ? 100 : 0
            }
          ),
          /* @__PURE__ */ jsxs37(
            "div",
            {
              className: `arclight-bg-background-primary arclight-min-h-screen arclight-overflow-x-hidden`,
              style: loading || transitioning ? { pointerEvents: "none" } : {},
              children: [
                Object.keys(pages).map((domain) => {
                  if (domain === "admin") {
                    pages.admin.Home.component = admin_default;
                  }
                  return Object.keys(pages[domain]).map((component) => {
                    const Page2 = pages[domain][component].component.default;
                    const backgroundImage = pages[domain][component].backgroundImage && domain === "admin" ? pages[domain][component].backgroundImage : null;
                    const authBackgroundImage = pages[domain][component].authBackgroundImage && domain === "admin" ? pages[domain][component].authBackgroundImage : null;
                    const noSelect = pages[domain][component].noSelect && domain === "admin" ? pages[domain][component].noSelect : null;
                    if (pagenotfound && route)
                      pagenotfound = domain !== "admin" ? !((fns.readState().subdomain == domain || domain === "_root_" && !fns.readState().subdomain) && (route.includes("?") ? route.split("?")[0] : route) == pages[domain][component].route) : !fns.parseAdminDomainState();
                    return (fns.readState().subdomain === domain || domain === "_root_" && !fns.readState().subdomain) && (route.split("?")[0] === pages[domain][component].route || domain === "admin" && !pagenotfound) ? /* @__PURE__ */ jsx65(
                      "div",
                      {
                        className: `${loading || transitioning ? `arclight-opacity-0` : `arclight-opacity-100`} arclight-duration-700 arclight-delay-0 arclight-transition-all`,
                        children: /* @__PURE__ */ jsx65(
                          Page2,
                          {
                            D: __spreadProps(__spreadValues({}, D), {
                              _diff: (() => {
                                const _ = {};
                                Object.keys(_diff).map((k) => {
                                  _[k] = _diff[k];
                                });
                                return _;
                              })()
                            }),
                            endpoint: socketEndpoint,
                            backgroundImage,
                            authBackgroundImage,
                            noSelect,
                            fns: {
                              joinRoom: fns.joinRoom(socket),
                              subscribe: fns.subscribe(socket),
                              verifyRegisterUser: fns.verifyRegisterUser,
                              getCallType: fns.getCallType,
                              readState: fns.readState,
                              setQueryParams: fns.setQueryParams,
                              scrollLock: fns.scrollLock,
                              setModal,
                              preloadModal,
                              readToken: fns.readToken,
                              writeToken: fns.writeToken,
                              e: fns.e,
                              setAdminDomainState: domain === "admin" ? setAdminDomainState : null,
                              parseAdminDomainState: fns.parseAdminDomainState,
                              calls: (() => {
                                const _ = {};
                                Object.keys(fns.calls || {}).map((key) => {
                                  if (fns == null ? void 0 : fns.calls[key])
                                    _[key] = (input) => __async(void 0, null, function* () {
                                      fns.calls[key](input);
                                      return yield new Promise((res, rej) => {
                                        setTimeout(
                                          () => rej(`Failed to call ${fns.calls[key]}`),
                                          1e5
                                        );
                                        return res();
                                      });
                                    });
                                });
                                return _;
                              })(),
                              addAnimationFrame: fns.addAnimationFrame,
                              route: _route,
                              routeExternal: fns.routeExternal,
                              route404: fns.route404,
                              authenticate: fns.authenticate(
                                socket,
                                (b) => __async(void 0, null, function* () {
                                  if (b)
                                    setTransitioning(b);
                                  yield new Promise(
                                    (r) => setTimeout(r, transitionDuration)
                                  );
                                  if (!b)
                                    setTransitioning(b);
                                }),
                                (b) => setInit(b)
                              ),
                              setLoading: (b) => setLoading(b),
                              signOut: fns.signOut(socket, fns)
                            }
                          }
                        )
                      }
                    ) : null;
                  });
                }),
                /* @__PURE__ */ jsx65(
                  "div",
                  {
                    className: `nopage ${loading || transitioning ? `arclight-opacity-0` : `arclight-opacity-100`} arclight-duration-700 arclight-delay-0 arclight-transition-all ${pagenotfound ? `` : `arclight-hidden`}`,
                    children: /* @__PURE__ */ jsx65("img", { src: nopage })
                  }
                ),
                /* @__PURE__ */ jsx65(
                  snack_default,
                  {
                    hide: () => {
                      setD((_) => __spreadProps(__spreadValues({}, _), {
                        serversuccess: null,
                        servererror: null,
                        serverwarning: null,
                        servermessage: null
                      }));
                    },
                    D
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx65(
            modal_default,
            {
              defaultBackground: `https://highmountainlabs.io/cdn/arclight/media/permissions.jpg`,
              modal,
              setModal,
              preloadModal,
              fns,
              D
            }
          )
        ]
      }
    ));
    fns.init(D, () => setInit(true), fns, init);
    if (loading && D)
      setTimeout(() => setLoading(false), 1e3);
    if (fns.readState().query)
      fns.consumeOATH2Code(socket, fns.readState().query);
  }, [route, loading, transitioning, D, modal]);
  React33.useEffect(() => {
    window.addEventListener(
      "popstate",
      (event) => event && event.target && event.target ? _route(event.target.location.pathname, null, true) : null,
      false
    );
    fns.animate();
    if (!socket) {
      socket = socketEndpoint ? io(socketEndpoint, {
        transports: ["websocket"]
      }) : null;
      socket == null ? void 0 : socket.emit("join", fns.readToken());
      socket == null ? void 0 : socket.on("disconnect", () => {
        setLoading(true);
        socket.emit("join", fns.readToken());
      });
      socket == null ? void 0 : socket.on("redirect", (msg) => _route(msg.route));
      socket == null ? void 0 : socket.on("init", (calls) => {
        fns.calls = {};
        Object.keys(calls).map((event) => {
          if (Array.isArray(calls[event]))
            calls[event].map((n) => {
              fns.calls[`${event}_${n}`] = (input) => fns.promisify(
                () => socket.emit(`${event}_${n}`, __spreadValues(__spreadValues({
                  index: "init"
                }, input), fns.readToken()))
              );
              socket.on(`${event}_${n}`, (data) => {
                const trigger = data._triggerFetch;
                const index = data.index;
                delete data.index;
                delete data._triggerFetch;
                setD((_) => {
                  if (!_[`${event}_${n}`])
                    _[`${event}_${n}`] = {};
                  return __spreadProps(__spreadValues({}, _), {
                    [`${event}_${n}`]: __spreadProps(__spreadValues({}, _[`${event}_${n}`]), {
                      [index]: data
                    })
                  });
                });
                if (trigger)
                  socket.emit(`getrecords_${n}`, __spreadValues({}, fns.readToken()));
              });
            });
          else {
            fns.calls[event] = (input) => fns.promisify(
              () => socket.emit(event, __spreadValues(__spreadValues({}, input), fns.readToken()))
            );
            socket.on(event, (data) => {
              if (event === "getlogs")
                console.log(JSON.parse(data));
              const trigger = data._triggerFetch;
              const index = data.index;
              delete data._triggerFetch;
              delete data.index;
              setD((_) => {
                return __spreadProps(__spreadValues({}, _), {
                  [event]: index ? __spreadProps(__spreadValues({}, _[event]), {
                    [index]: data
                  }) : data
                });
              });
              if (trigger) {
                socket.emit(event, __spreadValues({}, fns.readToken()));
              }
            });
          }
        });
        socket.on(
          `savetoken`,
          (msg) => fns.writeToken(msg.token)
        );
        socket.on(`cleartoken`, (msg) => __async(void 0, null, function* () {
          fns.writeToken();
          setTransitioning(true);
          yield new Promise((r) => setTimeout(r, transitionDuration / 2));
          window.location.reload();
        }));
        socket.on(`clearurlparameters`, () => {
          window.history.pushState(
            "object",
            document.title,
            window.location.href.split("?")[0]
          );
        });
        ["success", "error", "warning", "message"].map(
          (el) => socket.on(`server${el}`, (msg) => {
            if (msg.code === 401 || msg.code === 500 && msg.msg.includes("Unable to find user")) {
              fns.writeToken();
            }
            setD((_) => {
              return __spreadProps(__spreadValues({}, _), {
                [`server${el}`]: `(${msg.code}) ${msg.msg}`
              });
            });
          })
        );
        setD((_) => {
          return __spreadValues({}, _);
        });
      });
    }
  }, []);
  return app;
};
var app_default4 = App;

// src/components/compassviewer/index.tsx
import React35 from "react";

// src/components/compassviewer/styles.js
import styled35 from "styled-components";
var Container34 = styled35.div`
  overflow-x: hidden;
`;
var ViewItem = styled35.div`
  max-height: 800px;
`;
var TdLg = styled35.td`
  opacity: ${(props) => props.expanded ? "1" : "0"};
  width: ${(props) => props.expanded ? "100%" : "0%"};
  transition: all ease 0.5s;
  overflow-x: hidden;
  @media only screen and (max-width: 1280px) {
    display: none;
  }
`;
var TdSm = styled35.td`
  opacity: ${(props) => props.expanded ? "1" : "0"};
  width: ${(props) => props.expanded ? "100%" : "0%"};
  transition: all ease 0.5s;
  overflow: hidden;
`;
var Item4 = styled35.div`
  ${(props) => mountHandler(props)}
`;
var styles_default35 = {
  Container: Container34,
  ViewItem,
  TdLg,
  TdSm,
  Item: Item4
};

// src/components/diamondselector/index.tsx
import React34 from "react";

// src/components/diamondselector/styles.js
import styled36 from "styled-components";
var fullWidth = "600px";
var smallWidth = "300px";
var breakPoint = "1280px";
var Container35 = styled36.div`
	position: relative;
	width: ${fullWidth};
	height: ${fullWidth};
	margin-left: calc(${fullWidth} * 0.1);
	margin-right: calc(${fullWidth} * 0.1);
	margin-top: calc(${fullWidth} * 0.1);
	margin-bottom: calc(${fullWidth} * 0.1);
	@media only screen and (max-width: ${breakPoint}) {
		width: ${smallWidth};
		height: ${smallWidth};
		margin-left: calc(${smallWidth} * 0.1);
		margin-right: calc(${smallWidth} * 0.1);
		margin-top: calc(${smallWidth} * 0.1);
		margin-bottom: calc(${smallWidth} * 0.1);
	}
	border-radius: 50%;
	background-color: rgb(40, 44, 52);
`;
var DiamondWrapper = styled36.div`
	position: absolute;
	top: ${(props) => props.top};
	left: ${(props) => props.left};
	right: ${(props) => props.right};
	bottom: ${(props) => props.bottom};
	transform: ${(props) => props.translate};
	cursor: pointer;
`;
var Diamond = styled36.div`
	position: relative;
	transform-origin: center;
	width: calc(${fullWidth} * ${(props) => props.lg ? "0.7" : "0.405"});
	height: calc(${fullWidth} * ${(props) => props.lg ? "0.7" : "0.405"});
	@media only screen and (max-width: ${breakPoint}) {
		width: calc(${smallWidth} * ${(props) => props.lg ? "0.7" : "0.405"});
		height: calc(${smallWidth} * ${(props) => props.lg ? "0.7" : "0.405"});
	}
	overflow: hidden;
	transform: rotate(-45deg);
	transition: all 0.25s ease;
	${(props) => props.lg ? "z-index: 5" : null}
	opacity: ${(props) => props.focus ? props.focus === props.i + 1 ? 1 : 0.25 : props.selected === props.i + 1 || props.selected === 0 ? 1 : 0.25};
	&:hover {
		opacity: ${(props) => props.focus ? props.focus === props.i + 1 ? 1 : 0.65 : props.selected === props.i + 1 || props.selected === 0 ? 1 : 0.65};
	}
`;
var DiamondContent = styled36.div`
	position: relative;
	width: 150%;
	height: 150%;
	transform: rotate(45deg);
	margin-left: -25%;
	margin-top: -25%;
`;
var Image = styled36.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
var BgElement = styled36.video`
	position: absolute;
	height: 100%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	object-fit: cover;
	border-radius: 50%;
	opacity: 1;
`;
var styles_default36 = {
  Container: Container35,
  Diamond,
  DiamondWrapper,
  Image,
  DiamondContent,
  BgElement
};

// src/components/diamondselector/index.tsx
import { jsx as jsx66, jsxs as jsxs38 } from "react/jsx-runtime";
var Card2 = ({
  items,
  bgElement,
  callback,
  defaultSelection,
  offset
}) => {
  const [selected, setSelected] = React34.useState(
    defaultSelection ? defaultSelection : 0
  );
  const [focus, setFocus] = React34.useState(
    defaultSelection ? defaultSelection : 0
  );
  return /* @__PURE__ */ jsxs38(
    styles_default36.Container,
    {
      onMouseLeave: () => setSelected(0),
      className: `arclight-border-2 lg:arclight-border-2 arclight-border-background-tertiary`,
      children: [
        bgElement ? /* @__PURE__ */ jsx66(styles_default36.BgElement, { src: bgElement, autoPlay: true, muted: true, loop: true }) : null,
        [
          { l: "50%", t: "0%", r: null, b: null },
          { l: "0%", t: "50%", r: null, b: null },
          { l: null, t: "50%", r: "0%", b: null },
          { l: "50%", t: null, r: null, b: "0%" }
        ].map(
          (el, i) => items[i] ? /* @__PURE__ */ jsx66(
            styles_default36.DiamondWrapper,
            {
              left: el.l,
              top: el.t,
              right: el.r,
              bottom: el.b,
              translate: `translate(-${el.l ? el.l : el.r}, -${el.t ? el.t : el.b})`,
              children: /* @__PURE__ */ jsx66(
                styles_default36.Diamond,
                {
                  className: `arclight-border-background-tertiary arclight-border-2 lg:arclight-border-2`,
                  lg: false,
                  onMouseEnter: () => setSelected(i + 1),
                  onClick: () => {
                    if (callback)
                      callback(i + (offset ? offset : 0));
                    setFocus(i + 1);
                  },
                  focus,
                  i,
                  selected,
                  children: /* @__PURE__ */ jsx66(styles_default36.DiamondContent, { children: items[i] && items[i].bgImg ? /* @__PURE__ */ jsx66(styles_default36.Image, { src: items[i].bgImg }) : null })
                }
              )
            }
          ) : null
        ).filter((el) => el)
      ]
    }
  );
};
var diamondselector_default = Card2;

// src/components/compassviewer/index.tsx
import { jsx as jsx67, jsxs as jsxs39 } from "react/jsx-runtime";
var CompassViewer = ({
  items,
  defaultSelection,
  bgCompassElement
}) => {
  const [expanded, setExpanded] = React35.useState(
    defaultSelection ? true : false
  );
  const [selected, setSelected] = React35.useState(
    defaultSelection ? defaultSelection - 1 : 0
  );
  const [batch, setBatch] = React35.useState(0);
  const RenderItem = React35.useMemo(
    () => /* @__PURE__ */ jsx67(
      styles_default35.Item,
      {
        mountAnim: {
          anim: "fadeIn",
          duration: "750ms"
        },
        children: items[selected].element
      },
      selected
    ),
    [selected]
  );
  return /* @__PURE__ */ jsx67(
    styles_default35.Container,
    {
      className: "arclight-text-text-primary arclight-font-primary arclight-w-full",
      children: /* @__PURE__ */ jsx67("table", { className: "arclight-w-full arclight-overflow-hidden", children: /* @__PURE__ */ jsxs39("tbody", { children: [
        /* @__PURE__ */ jsxs39("tr", { children: [
          /* @__PURE__ */ jsxs39(
            "td",
            {
              className: "arclight-transition-all arclight-duration-500",
              align: "center",
              width: expanded ? "25%" : "100%",
              onClick: () => setExpanded(true),
              children: [
                /* @__PURE__ */ jsx67(
                  diamondselector_default,
                  {
                    callback: (value) => setSelected(value),
                    offset: batch * 4,
                    bgElement: bgCompassElement,
                    items: items.slice(4 * batch, 4 * (batch + 1)).map((el) => ({ bgImg: el.bgImg })),
                    defaultSelection
                  }
                ),
                items && items.length > 4 ? /* @__PURE__ */ jsx67(
                  minidiamondpicker_default,
                  {
                    columns: 4,
                    index: batch,
                    count: items.length,
                    cb: setBatch
                  }
                ) : null
              ]
            }
          ),
          /* @__PURE__ */ jsx67(styles_default35.TdLg, { expanded, children: /* @__PURE__ */ jsx67(
            styles_default35.ViewItem,
            {
              className: `${expanded ? "arclight-w-full" : "arclight-w-0"} arclight-transition-all arclight-duration-300 arclight-px-12`,
              children: RenderItem
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx67("tr", { className: `xl:arclight-hidden`, children: /* @__PURE__ */ jsx67(styles_default35.TdSm, { expanded, children: /* @__PURE__ */ jsx67(
          styles_default35.ViewItem,
          {
            className: `${expanded ? "arclight-w-full" : "arclight-w-0"} arclight-transition-all arclight-duration-300 arclight-px-10`,
            children: RenderItem
          }
        ) }) })
      ] }) })
    }
  );
};
var compassviewer_default = CompassViewer;

// src/components/dashboard/styles.js
import styled37 from "styled-components";
var Container36 = styled37.div``;
var styles_default37 = {
  Container: Container36
};

// src/components/dashboard/index.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
var Dashboard = ({}) => {
  return /* @__PURE__ */ jsx68(styles_default37.Container, {});
};
var dashboard_default = Dashboard;

// src/components/entryportal/index.tsx
import React36 from "react";

// src/components/entryportal/styles.js
import styled38 from "styled-components";
var Container37 = styled38.div`
  width: 100%;
  height: 100vh;
  position: relative;
`;
var Body8 = styled38.div`
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
var BaseBackground = styled38.img`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.1;
  object-fit: cover;
  transition: all ease 0.5s;
`;
var HoverBackground = styled38.img`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  object-fit: cover;
  transition: all ease 0.5s;
`;
var styles_default38 = {
  Container: Container37,
  Body: Body8,
  BaseBackground,
  HoverBackground
};

// src/components/entryportal/index.tsx
import { jsx as jsx69, jsxs as jsxs40 } from "react/jsx-runtime";
var EntryPortal = ({
  cards,
  baseBackground,
  className,
  rows
}) => {
  const [h, setH] = React36.useState(-1);
  const [index, setIndex] = React36.useState(0);
  return /* @__PURE__ */ jsxs40(
    styles_default38.Container,
    {
      className: `arclight-flex arclight-min-h-screen${className ? ` ${className}` : ""}`,
      children: [
        /* @__PURE__ */ jsx69(
          styles_default38.BaseBackground,
          {
            src: baseBackground,
            style: { opacity: h < 0 ? 0.1 : 0 }
          }
        ),
        cards.map(
          (c, i) => c.backgroundHover && !c.locked ? /* @__PURE__ */ jsx69(
            styles_default38.HoverBackground,
            {
              src: c.backgroundHover,
              style: { opacity: h === i ? 0.1 : 0 }
            },
            i
          ) : null
        ),
        /* @__PURE__ */ jsx69(styles_default38.Body, { className: `arclight-p-10 md:arclight-p-0`, children: /* @__PURE__ */ jsx69(
          heropanel_default,
          {
            rows,
            index: rows ? index : void 0,
            pageCallback: rows ? (n) => setIndex(n) : void 0,
            cards: cards.map((c, i) => {
              if (c.backgroundHover && !c.locked) {
                c.onHover = () => setH(i);
                c.onHoverLeave = () => setH(-1);
              }
              return c;
            })
          }
        ) })
      ]
    }
  );
};
var entryportal_default = EntryPortal;

// src/components/footer/styles.js
import styled39 from "styled-components";
var Container38 = styled39.div``;
var styles_default39 = {
  Container: Container38
};

// src/components/footer/index.tsx
import { jsx as jsx70, jsxs as jsxs41 } from "react/jsx-runtime";
var Footer2 = ({ logoSrc, text }) => {
  return /* @__PURE__ */ jsxs41(
    styles_default39.Container,
    {
      className: "arclight-flex arclight-flex-row arclight-w-full arclight-h-20 arclight-mt-36 arclight-p-5 arclight-justify-center arclight-items-center arclight-space-x-10 arclight-text-text-primary arclight-bg-background-secondary arclight-font-primary",
      children: [
        /* @__PURE__ */ jsx70("img", { src: logoSrc, className: "arclight-h-full" }),
        /* @__PURE__ */ jsxs41("div", { className: "arclight-text-md", children: [
          text,
          " \xA9 ",
          (/* @__PURE__ */ new Date()).getFullYear()
        ] })
      ]
    }
  );
};
var footer_default = Footer2;

// src/components/header/styles.js
import styled40 from "styled-components";
var Container39 = styled40.div`
  position: relative;
  z-index: 40;
`;
var Td = styled40.td`
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
var LinkText = styled40.div`
  z-index: 1;
`;
var LinkTextsilhouette = styled40.div`
  z-index: 0;
  position: absolute;
  pointer-events: none;
  text-shadow: none;
`;
var styles_default40 = {
  Container: Container39,
  Td,
  LinkText,
  LinkTextsilhouette
};

// src/components/header/index.tsx
import { jsx as jsx71, jsxs as jsxs42 } from "react/jsx-runtime";
var Header = ({
  linksLeft,
  linksRight,
  links,
  socialMedia,
  socialMediaRight,
  socialMediaLeft,
  logo,
  fns: fns2
}) => {
  const iconBackdropClassName = `arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-transform arclight-opacity-0 group-hover:arclight-opacity-100 group-hover:arclight-translate-x-1 group-hover:arclight-translate-y-1 arclight-transition-all arclight-ease-linear`;
  return /* @__PURE__ */ jsxs42(
    styles_default40.Container,
    {
      className: "arclight-text-text-primary arclight-font-primary",
      children: [
        (links == null ? void 0 : links.length) || (linksLeft == null ? void 0 : linksLeft.length) || (linksRight == null ? void 0 : linksRight.length) ? /* @__PURE__ */ jsx71(
          drawer_default,
          {
            animation: "slide",
            buttonSide: "right",
            side: "right",
            className: "lg:arclight-hidden",
            items: linksRight && linksLeft ? linksLeft.concat(linksRight).filter((el) => el).map((l) => ({
              icon: l.icon,
              text: l.text,
              onClick: () => fns2.route ? fns2.route(l.route) : fns2.routeExternal ? fns2.routeExternal(l.routeExternal) : null
            })) : links ? links.filter((el) => el).map((l) => ({
              icon: l.icon,
              text: l.text,
              onClick: () => fns2.route ? fns2.route(l.route) : fns2.routeExternal ? fns2.routeExternal(l.routeExternal) : null
            })) : null
          }
        ) : null,
        /* @__PURE__ */ jsx71(
          "div",
          {
            className: "lg:arclight-my-10 arclight-absolute arclight-left-1/2 arclight-transform -arclight-translate-x-1/2 arclight-w-full",
            style: links ? { display: "none" } : {},
            children: /* @__PURE__ */ jsx71("table", { className: "arclight-table-fixed arclight-w-full", children: /* @__PURE__ */ jsx71("tbody", { children: /* @__PURE__ */ jsxs42("tr", { children: [
              /* @__PURE__ */ jsx71(styles_default40.Td, { className: "w-2/5 relative", children: /* @__PURE__ */ jsxs42("div", { className: "arclight-flex arclight-m-auto arclight-gap-8 arclight-relative arclight-place-content-end", children: [
                linksLeft ? linksLeft.filter((el) => el).map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: `arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-text-background-tertiary arclight-transform arclight-opacity-0 group-hover:arclight-opacity-100 group-hover:arclight-translate-x-1 group-hover:arclight-translate-y-1 arclight-transition-all ease-linear`,
                      children: l.text
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkText,
                    {
                      className: "arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-cursor-pointer arclight-relative",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      },
                      children: l.text
                    }
                  )
                ] })) : null,
                /* @__PURE__ */ jsx71("div", { className: "arclight-absolute arclight-top-12", children: /* @__PURE__ */ jsx71("div", { className: "arclight-flex arclight-m-auto arclight-gap-4", children: socialMediaLeft ? socialMediaLeft.map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: iconBackdropClassName,
                      children: /* @__PURE__ */ jsx71(
                        fontawesome_default,
                        {
                          className: `arclight-text-background-tertiary`,
                          animation: "none",
                          icon: l.icon,
                          size: "lg",
                          onClick: () => {
                            if (l.onClick)
                              l.onClick();
                            if (!fns2.route)
                              return;
                            return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    fontawesome_default,
                    {
                      className: `arclight-relative arclight-z-10`,
                      animation: "none",
                      icon: l.icon,
                      size: "xl",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      }
                    }
                  )
                ] })) : null }) })
              ] }) }),
              /* @__PURE__ */ jsx71("td", { className: "arclight-w-1/5", children: /* @__PURE__ */ jsx71(
                "img",
                {
                  onClick: () => {
                    if (logo.onClick)
                      logo.onClick();
                    if (!fns2.route)
                      return;
                    return fns2.route(logo.route);
                  },
                  src: logo.src,
                  className: "arclight-h-24 arclight-m-4 lg:arclight-h-36 lg:arclight-m-auto arclight-cursor-pointer"
                }
              ) }),
              /* @__PURE__ */ jsx71(styles_default40.Td, { className: "arclight-w-2/5", children: /* @__PURE__ */ jsxs42("div", { className: "arclight-flex arclight-m-auto arclight-gap-8 arclight-relative", children: [
                linksRight ? linksRight.filter((el) => el).map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: `arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-text-background-tertiary arclight-transform arclight-opacity-0 group-hover:arclight-opacity-100 group-hover:arclight-translate-x-1 group-hover:arclight-translate-y-1 arclight-transition-all arclight-ease-linear`,
                      children: l.text
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkText,
                    {
                      className: "arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-cursor-pointer arclight-relative",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      },
                      children: l.text
                    }
                  )
                ] })) : null,
                /* @__PURE__ */ jsx71("div", { className: "arclight-absolute arclight-top-12", children: /* @__PURE__ */ jsx71("div", { className: "arclight-flex arclight-m-auto arclight-gap-4 arclight-place-content-start", children: socialMediaRight ? socialMediaRight.map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: iconBackdropClassName,
                      children: /* @__PURE__ */ jsx71(
                        fontawesome_default,
                        {
                          className: `arclight-text-background-tertiary`,
                          animation: "none",
                          icon: l.icon,
                          size: "lg",
                          onClick: () => {
                            if (l.onClick)
                              l.onClick();
                            if (!fns2.route)
                              return;
                            return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    fontawesome_default,
                    {
                      className: `arclight-relative`,
                      animation: "none",
                      icon: l.icon,
                      size: "xl",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      }
                    }
                  )
                ] })) : null }) })
              ] }) })
            ] }) }) })
          }
        ),
        /* @__PURE__ */ jsx71(
          "div",
          {
            className: "lg:arclight-py-10",
            style: !links ? { display: "none" } : {},
            children: /* @__PURE__ */ jsx71("table", { width: "100%", children: /* @__PURE__ */ jsx71("tbody", { children: /* @__PURE__ */ jsxs42("tr", { children: [
              /* @__PURE__ */ jsx71("td", { className: "arclight-w-1/5 arclight-relative", children: /* @__PURE__ */ jsx71(
                "img",
                {
                  onClick: () => {
                    if (logo.onClick)
                      logo.onClick();
                    if (!fns2.route)
                      return;
                    return fns2.route(logo.route);
                  },
                  src: logo.src,
                  className: "arclight-h-16 arclight-m-4 lg:arclight-h-24 lg:arclight-m-auto arclight-cursor-pointer"
                }
              ) }),
              /* @__PURE__ */ jsx71(styles_default40.Td, { className: "arclight-w-4/5 arclight-relative", children: /* @__PURE__ */ jsxs42("div", { className: "arclight-flex arclight-m-auto arclight-gap-8 arclight-relative arclight-justify-center", children: [
                links ? links.filter((el) => el).map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: `arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-text-background-tertiary arclight-transform arclight-opacity-0 group-hover:arclight-opacity-100 group-hover:arclight-translate-x-1 group-hover:arclight-translate-y-1 arclight-transition-all arclight-ease-linear`,
                      children: l.text
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkText,
                    {
                      className: "arclight-text-xl arclight-font-bold arclight-whitespace-nowrap arclight-cursor-pointer arclight-relative",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      },
                      children: l.text
                    }
                  )
                ] })) : null,
                /* @__PURE__ */ jsx71("div", { className: "arclight-absolute arclight-top-12", children: /* @__PURE__ */ jsx71("div", { className: "arclight-flex arclight-m-auto arclight-gap-4 arclight-place-content-start", children: socialMedia ? socialMedia.map((l) => /* @__PURE__ */ jsxs42("div", { className: `arclight-relative arclight-group`, children: [
                  /* @__PURE__ */ jsx71(
                    styles_default40.LinkTextsilhouette,
                    {
                      className: iconBackdropClassName,
                      children: /* @__PURE__ */ jsx71(
                        fontawesome_default,
                        {
                          className: `arclight-text-background-tertiary`,
                          animation: "none",
                          icon: l.icon,
                          size: "lg",
                          onClick: () => {
                            if (l.onClick)
                              l.onClick();
                            if (!fns2.route)
                              return;
                            return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx71(
                    fontawesome_default,
                    {
                      className: `arclight-relative`,
                      animation: "none",
                      icon: l.icon,
                      size: "xl",
                      onClick: () => {
                        if (l.onClick)
                          l.onClick();
                        if (!fns2.route)
                          return;
                        return l.route ? fns2.route(l.route) : l.routeExternal ? fns2.routeExternal(l.routeExternal) : null;
                      }
                    }
                  )
                ] })) : null }) })
              ] }) })
            ] }) }) })
          }
        )
      ]
    }
  );
};
var header_default = Header;

// src/components/layout/index.tsx
import { WidthProvider, Responsive } from "react-grid-layout";

// src/components/layout/styles.js
import styled41 from "styled-components";
var Container40 = styled41.div``;
var styles_default41 = {
  Container: Container40
};

// src/components/layout/index.tsx
import { jsx as jsx72, jsxs as jsxs43 } from "react/jsx-runtime";
var ResponsiveGridLayout = WidthProvider(Responsive);
var Layout = ({}) => {
  return /* @__PURE__ */ jsx72(styles_default41.Container, { children: /* @__PURE__ */ jsxs43(
    ResponsiveGridLayout,
    {
      className: "layout",
      breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
      cols: { lg: 12, md: 10, sm: 6, xs: 2, xxs: 1 },
      children: [
        /* @__PURE__ */ jsx72("div", { style: { backgroundColor: "blue" }, children: "1" }, "1"),
        /* @__PURE__ */ jsx72("div", { style: { backgroundColor: "red" }, children: "2" }, "2"),
        /* @__PURE__ */ jsx72("div", { style: { backgroundColor: "purple" }, children: "3" }, "3")
      ]
    }
  ) });
};
var layout_default = Layout;

// src/components/missionstatement/styles.js
import styled42 from "styled-components";
var Container41 = styled42.div`
  width: 100%;
  position: relative;
`;
var BgImg3 = styled42.img`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 50%;
  transform: translateY(50%);
  object-fit: cover;
`;
var styles_default42 = {
  Container: Container41,
  BgImg: BgImg3
};

// src/components/missionstatement/index.tsx
import { jsx as jsx73, jsxs as jsxs44 } from "react/jsx-runtime";
var MissionStatement = ({ title, Message, bgImg, button }) => {
  return /* @__PURE__ */ jsxs44(
    styles_default42.Container,
    {
      className: "arclight-text-text-primary arclight-font-primary",
      children: [
        bgImg ? /* @__PURE__ */ jsx73(
          styles_default42.BgImg,
          {
            src: bgImg,
            className: `arclight-rounded xs:max-md:arclight-h-full`
          }
        ) : null,
        /* @__PURE__ */ jsxs44(
          "div",
          {
            className: `arclight-w-full arclight-px-10 arclight-m-auto lg:arclight-w-4/5 arclight-relative ${bgImg ? "arclight-bg-visibility-primary arclight-rounded-md arclight-p-10" : ""}`,
            children: [
              /* @__PURE__ */ jsx73(
                "div",
                {
                  className: `${bgImg ? "arclight-text-xl" : `arclight-text-2xl md:arclight-text-6xl`} ${bgImg ? "arclight-my-0" : "arclight-my-14"}`,
                  children: title
                }
              ),
              bgImg ? /* @__PURE__ */ jsx73("div", { className: "arclight-text-md arclight-my-14 arclight-w-full", children: Message }) : /* @__PURE__ */ jsx73(
                "div",
                {
                  className: "arclight-text-md lg:arclight-text-2xl arclight-my-14 arclight-w-full",
                  children: Message
                }
              ),
              button ? button : null
            ]
          }
        )
      ]
    }
  );
};
var missionstatement_default = MissionStatement;

// src/components/timeline/index.tsx
import React37 from "react";

// src/components/timeline/styles.js
import styled43 from "styled-components";
var Container42 = styled43.div``;
var DescriptionComponent = styled43.div``;
var styles_default43 = {
  Container: Container42,
  DescriptionComponent
};

// src/components/timeline/index.tsx
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { jsx as jsx74, jsxs as jsxs45 } from "react/jsx-runtime";
var DescComponent = (props) => /* @__PURE__ */ jsxs45(
  styles_default43.DescriptionComponent,
  {
    className: `arclight-font-primary arclight-text-text-primary`,
    children: [
      /* @__PURE__ */ jsx74("div", { className: `arclight-text-2xl`, children: props.title }),
      /* @__PURE__ */ jsx74("div", { className: `arclight-text-lg`, children: props.text }),
      /* @__PURE__ */ jsx74("div", { className: `arclight-text-sm`, children: props.date })
    ]
  }
);
var Timeline = ({ bgVideo, elements }) => {
  const [scale, setScale] = React37.useState(0);
  const [loaded, setLoaded] = React37.useState(false);
  return /* @__PURE__ */ jsxs45(styles_default43.Container, { className: `arclight-mt-10`, children: [
    /* @__PURE__ */ jsxs45(
      "div",
      {
        className: `arclight-relative arclight-group arclight-m-auto arclight-border-4 arclight-border-white arclight-w-32 arclight-h-32 arclight-rounded-full arclight-flex arclight-align-middle arclight-justify-center arclight-cursor-pointer arclight-overflow-hidden`,
        onClick: () => {
          if (loaded) {
            setScale(0);
            setTimeout(() => setLoaded(false), 150);
          } else {
            setScale(100);
            setLoaded(true);
          }
        },
        children: [
          /* @__PURE__ */ jsx74(
            "video",
            {
              src: bgVideo,
              className: `arclight-absolute arclight-h-full arclight-object-cover`,
              loop: true,
              muted: true,
              autoPlay: true
            }
          ),
          /* @__PURE__ */ jsx74(
            "div",
            {
              className: `arclight-relative arclight-flex arclight-flex-col arclight-justify-center`,
              children: /* @__PURE__ */ jsx74(
                fontawesome_default,
                {
                  icon: "hurricane",
                  size: "4x",
                  className: `arclight-scale-100 group-hover:arclight-rotate-180 group-hover:arclight-scale-125 arclight-transition-all arclight-duration-300`
                }
              )
            }
          )
        ]
      }
    ),
    loaded ? /* @__PURE__ */ jsx74(
      VerticalTimeline,
      {
        layout: "2-columns",
        lineColor: "white",
        className: `arclight-origin-top ${scale ? `arclight-scale-100` : `arclight-scale-0`} arclight-transition-transform arclight-duration-300`,
        children: [
          {
            bgImg: "http://localhost:7000/static/media/ionia.jpg",
            hoverComponent: /* @__PURE__ */ jsx74("div", { children: "A New Dynasty Begins" }),
            descriptionComponent: /* @__PURE__ */ jsx74(
              DescComponent,
              {
                title: "A New Dynasty Begins",
                text: "Org Alcatraz joins Titan Esports",
                date: "March 21, 2022"
              }
            ),
            icon: "champagne-glasses",
            color: "rgb(33, 150, 243)"
          },
          {
            bgImg: "http://localhost:7000/static/media/jadevi.jpg",
            hoverComponent: /* @__PURE__ */ jsx74("div", { children: "Alcatraz Gains Steam" }),
            descriptionComponent: /* @__PURE__ */ jsx74(
              DescComponent,
              {
                title: "Alcatraz Gains Steam",
                text: "Team Alcatraz defeats Team Phoenix Acsent 2-0",
                date: "April 13, 2022"
              }
            ),
            icon: "hand-fist",
            color: "purple"
          },
          {
            bgImg: "http://localhost:7000/static/media/kayn.jpg",
            hoverComponent: /* @__PURE__ */ jsx74("div", { children: "You Can't Wim 'Em All" }),
            descriptionComponent: /* @__PURE__ */ jsx74(
              DescComponent,
              {
                title: "You Can't Wim 'Em All",
                text: "Team Alcatraz loses 1-2 to Team Deadly Gale in a tight series",
                date: "April 29, 2022"
              }
            ),
            icon: "skull-crossbones",
            color: "maroon"
          },
          {
            bgImg: "http://localhost:7000/static/media/jadewukong.jpg",
            hoverComponent: /* @__PURE__ */ jsx74("div", { children: "Legends In The Making" }),
            descriptionComponent: /* @__PURE__ */ jsx74(
              DescComponent,
              {
                title: "Legends In The Making",
                text: "Team Alcatraz takes 2nd in their first Divinity League debut",
                date: "June 11, 2022"
              }
            ),
            icon: "ribbon",
            color: "gold"
          },
          {
            locked: true,
            bgImg: "http://localhost:7000/static/media/general.jpg",
            hoverComponent: /* @__PURE__ */ jsx74("div", { children: "End Of An Era" }),
            descriptionComponent: /* @__PURE__ */ jsx74(
              DescComponent,
              {
                title: "End Of An Era",
                text: "Org Alcatraz departs from Titan Esports",
                date: "December 2, 2022"
              }
            ),
            icon: "face-sad-cry",
            color: "black"
          }
        ].map((el) => /* @__PURE__ */ jsx74(
          VerticalTimelineElement,
          {
            className: ``,
            contentStyle: {
              background: "transparent",
              boxShadow: "none"
            },
            contentArrowStyle: { borderRight: `0px solid` },
            date: el.descriptionComponent,
            iconStyle: { background: el.color },
            icon: /* @__PURE__ */ jsx74(fontawesome_default, { icon: el.icon, size: "4x" }),
            children: /* @__PURE__ */ jsx74("div", { className: "arclight-flex arclight-justify-center", children: /* @__PURE__ */ jsx74(
              card_default,
              {
                medium: true,
                index: 0,
                hoverComponent: el.hoverComponent,
                locked: el.locked,
                bgImg: el.bgImg,
                subText: el.subText,
                onClick: () => null
              }
            ) })
          }
        ))
      }
    ) : null
  ] });
};
var timeline_default = Timeline;

// src/components/profilepage/styles.js
import styled44 from "styled-components";
var Container43 = styled44.div`
  margin-top: 350px;
`;
var ProfileImg = styled44.div`
  pointer-events: none;
  z-index: 1;
  top: -350px;
  left: 50%;
  width: 350px;
  height: 350px;
  @media only screen and (max-width: 1024px) {
    width: 225px;
    height: 225px;
    top: -225px;
  }
  transform: translate(-50%, 50%);
  border-radius: 50%;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;
var Content2 = styled44.div``;
var styles_default44 = { Container: Container43, ProfileImg, Content: Content2 };

// src/components/profilepage/index.tsx
import { jsx as jsx75, jsxs as jsxs46 } from "react/jsx-runtime";
var ProfilePage = ({
  fns: fns2,
  Panel: Panel4,
  title,
  panelImg,
  profileImg,
  timeline
}) => {
  return /* @__PURE__ */ jsxs46("div", { children: [
    /* @__PURE__ */ jsx75("div", { className: `arclight-flex arclight-justify-end`, children: /* @__PURE__ */ jsx75(
      button_default,
      {
        label: "Customize Page",
        className: `arclight-mx-8`,
        type: "button",
        size: "normal",
        animation: true,
        onClick: (status) => fns2.setModal({
          noescape: true,
          body: (props) => /* @__PURE__ */ jsx75("div", { children: "Shalom" })
        })
      }
    ) }),
    /* @__PURE__ */ jsxs46(
      styles_default44.Container,
      {
        className: `arclight-relative flex arclight-justify-center`,
        children: [
          /* @__PURE__ */ jsx75(
            styles_default44.ProfileImg,
            {
              className: `arclight-absolute arclight-bg-background-secondary`,
              children: /* @__PURE__ */ jsx75(
                "img",
                {
                  src: profileImg,
                  className: `arclight-border-2 arclight-border-l-4 arclight-border-r-4 arclight-border-b-8 arclight-border-background-tertiary`
                }
              )
            }
          ),
          /* @__PURE__ */ jsx75(
            card_default,
            {
              max: true,
              bgImg: panelImg,
              noBodyComponentAbsolute: true,
              bodyComponent: /* @__PURE__ */ jsxs46(
                styles_default44.Content,
                {
                  className: `arclight-mt-32 md:arclight-mt-60 arclight-mb-18 md:arclight-mb-24 arclight-flex arclight-flex-col arclight-space-y-0 arclight-w-full`,
                  children: [
                    /* @__PURE__ */ jsx75("div", { className: `arclight-text-4xl md:arclight-text-6xl`, children: title }),
                    Panel4
                  ]
                }
              )
            }
          )
        ]
      }
    ),
    timeline ? /* @__PURE__ */ jsx75(timeline_default, { bgVideo: timeline.bgVideo, elements: timeline.elements }) : null
  ] });
};
var profilepage_default = ProfilePage;

// src/components/slanteddivider/styles.js
import styled45 from "styled-components";
var Container44 = styled45.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  height: 800px;
  @media only screen and (max-width: 1024px) {
    height: 300px;
  }
`;
var Divider2 = styled45.div`
  position: absolute;
  top: -10%;
  left: -10%;
  width: 125%;
  height: 100%;
  transform: rotate(${(props) => props.rotation}deg);
  transform-origin: bottom right;
  overflow: hidden;
  & img {
    transform: rotate(-${(props) => props.rotation}deg);
  }
`;
var styles_default45 = {
  Container: Container44,
  Divider: Divider2
};

// src/components/slanteddivider/index.tsx
import { jsx as jsx76, jsxs as jsxs47 } from "react/jsx-runtime";
var SlantedDivider = ({ rotation, img, ruby }) => {
  return /* @__PURE__ */ jsxs47(
    styles_default45.Container,
    {
      className: `arclight-bg-gradient-to-b arclight-from-background-tertiary arclight-to arclight-to-transparent`,
      children: [
        /* @__PURE__ */ jsx76(
          styles_default45.Divider,
          {
            rotation,
            className: "arclight-border-text-secondary arclight-border-b-2",
            children: /* @__PURE__ */ jsx76("img", { src: img, width: "100%" })
          }
        ),
        ruby ? /* @__PURE__ */ jsx76(
          "img",
          {
            src: ruby,
            className: `arclight-absolute arclight-bottom-24 lg:arclight-bottom-48 arclight-left-1/2 -arclight-translate-x-1/2 arclight-w-56 lg:arclight-w-96`
          }
        ) : null
      ]
    }
  );
};
var slanteddivider_default = SlantedDivider;

// src/components/tournamentbracket/index.tsx
import {
  Bracket,
  Seed,
  SeedItem,
  SeedTeam
} from "react-brackets";

// src/components/tournamentbracket/styles.js
import styled46 from "styled-components";
var Container45 = styled46.div``;
var styles_default46 = {
  Container: Container45
};

// src/components/tournamentbracket/index.tsx
import { jsx as jsx77, jsxs as jsxs48 } from "react/jsx-runtime";
var TournamentBracket = ({}) => {
  const CustomSeed = ({
    seed,
    breakpoint,
    roundIndex,
    seedIndex
  }) => {
    const SItem = (props) => {
      var _a;
      return /* @__PURE__ */ jsxs48(
        SeedTeam,
        {
          className: `arclight-relative arclight-overflow-hidden arclight-cursor-pointer ${props.won ? `arclight-border-cyan-300 arclight-border-[0px]` : null}`,
          children: [
            /* @__PURE__ */ jsx77(
              "img",
              {
                src: props.img,
                className: `arclight-absolute arclight-opacity-10 arclight-top-0 arclight-left-0`
              }
            ),
            /* @__PURE__ */ jsxs48(
              "div",
              {
                className: "arclight-flex arclight-align-middle arclight-relative",
                children: [
                  /* @__PURE__ */ jsx77(
                    "img",
                    {
                      src: "http://titanesports.org:7000/static/media/TES-logo.png",
                      className: `arclight-mr-5`,
                      style: { height: 35 }
                    }
                  ),
                  /* @__PURE__ */ jsx77(
                    "div",
                    {
                      className: `arclight-flex arclight-flex-col arclight-justify-center`,
                      children: /* @__PURE__ */ jsx77("div", { children: ((_a = seed.teams[0]) == null ? void 0 : _a.name) || "NO TEAM " })
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    };
    return /* @__PURE__ */ jsx77(Seed, { mobileBreakpoint: breakpoint, style: { fontSize: "12px" }, children: /* @__PURE__ */ jsx77(SeedItem, { children: /* @__PURE__ */ jsxs48("div", { className: `arclight-bg-background-primary`, children: [
      /* @__PURE__ */ jsx77(
        SItem,
        {
          img: "https://pbs.twimg.com/media/DTxLgmyXcAE7Z5c.jpg",
          won: true
        }
      ),
      seed.teams.length > 1 ? /* @__PURE__ */ jsx77(SItem, { img: "https://pbs.twimg.com/media/DTxLgmyXcAE7Z5c.jpg" }) : null
    ] }) }) });
  };
  const rounds = [
    {
      title: "Quarter Finals",
      seeds: [
        {
          id: 1,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "My Very Long Team Name" }, { name: "Team B" }]
        },
        {
          id: 2,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team C" }, { name: "Team D" }]
        },
        {
          id: 3,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team E" }, { name: "Team F" }]
        },
        {
          id: 4,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team G" }, { name: "Team H" }]
        }
      ]
    },
    {
      title: "Semi-Finals",
      seeds: [
        {
          id: 5,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team A" }, { name: "Team C" }]
        },
        {
          id: 6,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team E" }, { name: "Team G" }]
        }
      ]
    },
    {
      title: "Finals",
      seeds: [
        {
          id: 7,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team A" }, { name: "Team E" }]
        }
      ]
    },
    {
      title: "Champions",
      seeds: [
        {
          id: 8,
          date: (/* @__PURE__ */ new Date()).toDateString(),
          teams: [{ name: "Team A" }]
        }
      ]
    }
  ];
  return /* @__PURE__ */ jsx77(
    styles_default46.Container,
    {
      className: `arclight-flex arclight-font-primary arclight-text-text-primary`,
      children: /* @__PURE__ */ jsx77(Bracket, { rounds, renderSeedComponent: CustomSeed, rtl: false })
    }
  );
};
var tournamentbracket_default = TournamentBracket;
export {
  admin_default as Admin,
  animatedborder_default as AnimatedBorder,
  app_default4 as App,
  application_default as Application,
  articlepage_default as ArticlePage,
  authpage_default as AuthPage,
  button_default as Button,
  calendar_default as Calendar,
  card_default as Card,
  checkbox_default as Checkbox,
  checkboxgroup_default as CheckboxGroup,
  clippingmask_default as ClippingMask,
  compassviewer_default as CompassViewer,
  dashboard_default as Dashboard,
  dateselector_default as DateSelector,
  diamondselector_default as DiamondSelector,
  drawer_default as Drawer,
  entryportal_default as EntryPortal,
  fadedivider_default as FadeDivider,
  fileloader_default as FileLoader,
  fontawesome_default as FontAwesome,
  footer_default as Footer,
  header_default as Header,
  heropanel_default as HeroPanel,
  layout_default as Layout,
  listpanel_default as ListPanel,
  loader_default as Loader,
  minidiamondpicker_default as MiniDiamondPicker,
  missionstatement_default as MissionStatement,
  monaco_default as Monaco,
  page_default as Page,
  pagetitle_default as PageTitle,
  picklist_default as Picklist,
  profilepage_default as ProfilePage,
  quill_default as Quill,
  searchcontrols_default as SearchControls,
  slanteddivider_default as SlantedDivider,
  snack_default as Snack,
  spinner_default as Spinner,
  textfield_default as TextField,
  tournamentbracket_default as TournamentBracket,
  animations_default as animations
};
